import { EXTRA_COMMAND_GROUPS, COMMAND_CATEGORY_EXPANSIONS, EXTRA_COMMAND_CATEGORIES } from "./commandsCatalog.extra.data";

const BASE_COMMAND_GROUPS = [
    {
        "id": "version-control",
        "label": "Control de versiones",
        "description": "Git y GitHub para historial, ramas, revisiones y automatizacion."
    },
    {
        "id": "terminals",
        "label": "Terminales y sistemas",
        "description": "Windows, PowerShell, Linux y WSL para trabajar con el sistema operativo."
    },
    {
        "id": "javascript",
        "label": "Ecosistema JavaScript",
        "description": "Node.js, npm, Yarn, pnpm y TypeScript."
    },
    {
        "id": "frameworks",
        "label": "Frameworks y aplicaciones",
        "description": "React, React Native, Expo y NestJS."
    },
    {
        "id": "devops",
        "label": "Contenedores e infraestructura",
        "description": "Docker, Compose, Kubernetes y Terraform."
    },
    {
        "id": "cloud",
        "label": "Nube",
        "description": "Comandos de infraestructura y servicios cloud."
    },
    {
        "id": "databases",
        "label": "Bases de datos",
        "description": "PostgreSQL, MySQL/MariaDB y Redis desde terminal."
    },
    {
        "id": "access-network",
        "label": "Red, HTTP y acceso remoto",
        "description": "cURL, SSH, transferencia, DNS, puertos y conectividad."
    },
    {
        "id": "python",
        "label": "Python",
        "description": "Runtime, entornos, paquetes, tests y depuracion."
    },
    {
        "id": "system-tools",
        "label": "Herramientas del sistema",
        "description": "Procesos, puertos y gestores de paquetes del sistema operativo."
    },
    {
        "id": "languages",
        "label": "Lenguajes y toolchains",
        "description": "Go, Rust, Java, .NET, PHP y otros toolchains."
    },
    {
        "id": "mobile",
        "label": "Mobile y Android",
        "description": "ADB, Android SDK y herramientas mobile."
    },
    {
        "id": "web-servers",
        "label": "Servidores y TLS",
        "description": "Nginx, systemd y OpenSSL."
    },
    {
        "id": "cli-utils",
        "label": "Utilidades CLI",
        "description": "jq, grep, sed, awk, compresion y build tools."
    },
    {
        "id": "observability",
        "label": "Observabilidad",
        "description": "Logs, métricas, tracing y diagnóstico de servicios."
    }
];

export const COMMAND_GROUPS = [...BASE_COMMAND_GROUPS, ...EXTRA_COMMAND_GROUPS];

const BASE_COMMAND_CATEGORIES = [
    {
        "id": "git",
        "group": "version-control",
        "title": "Git",
        "description": "Referencia extensa de Git: configuración, repositorios, remotos, tracking, colaboración, ramas, historial, recuperación, submódulos, worktrees, mantenimiento e internals.",
        "aliases": [
            "git",
            "version control",
            "repository",
            "repo"
        ],
        "commands": [
            {
                "command": "git --version",
                "level": "basic",
                "description": "Muestra la version instalada de Git.",
                "example": "git --version",
                "expected": "git version 2.x.x",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --get <key>",
                "level": "basic",
                "description": "Obtiene una clave concreta.",
                "example": "git config --get user.email",
                "expected": "Valor configurado.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global --list",
                "level": "basic",
                "topic": "Configuración",
                "description": "Lista la configuración global del usuario.",
                "example": "git config --global --list",
                "expected": "Pares clave=valor provenientes del archivo global de Git.",
                "note": ""
            },
            {
                "command": "git config --global alias.co checkout",
                "level": "basic",
                "topic": "Configuración",
                "description": "Crea un alias global para ejecutar checkout como co.",
                "example": "git config --global alias.co checkout",
                "expected": "Sin salida; luego git co funciona como git checkout.",
                "note": ""
            },
            {
                "command": "git config --global core.editor \"code --wait\"",
                "level": "basic",
                "description": "Usa VS Code como editor Git.",
                "example": "git config --global core.editor \"code --wait\"",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global init.defaultBranch main",
                "level": "basic",
                "description": "Define main como rama inicial por defecto.",
                "example": "git config --global init.defaultBranch main",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global user.email \"<email>\"",
                "level": "basic",
                "description": "Configura email global de autor.",
                "example": "git config --global user.email \"dev@example.com\"",
                "expected": "Sin salida; persiste en ~/.gitconfig.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global user.name \"<name>\"",
                "level": "basic",
                "description": "Configura nombre global de autor.",
                "example": "git config --global user.name \"Gastón\"",
                "expected": "Sin salida; persiste en ~/.gitconfig.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --list",
                "level": "basic",
                "description": "Lista la configuracion Git efectiva.",
                "example": "git config --list",
                "expected": "Pares clave=valor.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --local --list",
                "level": "basic",
                "topic": "Configuración",
                "description": "Lista únicamente la configuración del repositorio actual.",
                "example": "git config --local --list",
                "expected": "Configuración guardada en .git/config.",
                "note": ""
            },
            {
                "command": "git config user.email \"<email>\"",
                "level": "basic",
                "description": "Configura email solo para el repositorio actual.",
                "example": "git config user.email \"repo@example.com\"",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config user.name \"<name>\"",
                "level": "basic",
                "description": "Configura nombre solo para el repositorio actual.",
                "example": "git config user.name \"Dev Local\"",
                "expected": "Sin salida; guarda en .git/config.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --get-regexp <regex>",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Filtra claves de configuración usando una expresión regular.",
                "example": "git config --get-regexp \"^alias\\.\"",
                "expected": "Lista las claves y valores que coinciden con la expresión.",
                "note": ""
            },
            {
                "command": "git config --global --get-all safe.directory",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Lista todas las rutas marcadas como seguras.",
                "example": "git config --global --get-all safe.directory",
                "expected": "Una ruta por línea.",
                "note": ""
            },
            {
                "command": "git config --global --unset <key>",
                "level": "intermediate",
                "description": "Elimina una clave global.",
                "example": "git config --global --unset pull.rebase",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global alias.lg \"log --oneline --graph --decorate --all\"",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Crea un alias gráfico compacto para revisar el historial.",
                "example": "git config --global alias.lg \"log --oneline --graph --decorate --all\"",
                "expected": "Sin salida; git lg mostrará el grafo compacto.",
                "note": ""
            },
            {
                "command": "git config --global core.autocrlf input",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Convierte CRLF a LF al commitear pero no modifica LF al checkout.",
                "example": "git config --global core.autocrlf input",
                "expected": "Sin salida; común en Linux/macOS.",
                "note": ""
            },
            {
                "command": "git config --global core.autocrlf true",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Configura conversión CRLF/LF típica para Windows.",
                "example": "git config --global core.autocrlf true",
                "expected": "Sin salida; afecta normalización de finales de línea.",
                "note": "Usalo solo si comprendés la política de line endings de tu equipo."
            },
            {
                "command": "git config --global core.excludesfile <path>",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Define un .gitignore global para archivos que nunca querés versionar.",
                "example": "git config --global core.excludesfile ~/.gitignore_global",
                "expected": "Sin salida; Git aplica ese archivo de ignores a todos los repositorios.",
                "note": ""
            },
            {
                "command": "git config --global credential.helper cache",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Mantiene credenciales temporalmente en memoria.",
                "example": "git config --global credential.helper cache",
                "expected": "Sin salida; próximas autenticaciones pueden reutilizar la credencial cacheada.",
                "note": ""
            },
            {
                "command": "git config --global credential.helper manager",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Usa Git Credential Manager como helper de credenciales.",
                "example": "git config --global credential.helper manager",
                "expected": "Sin salida; Git delega el almacenamiento/renovación de credenciales al helper.",
                "note": "El helper debe estar instalado en el sistema."
            },
            {
                "command": "git config --global fetch.prune true",
                "level": "intermediate",
                "description": "Elimina refs remotas obsoletas al hacer fetch.",
                "example": "git config --global fetch.prune true",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global pull.rebase true",
                "level": "intermediate",
                "description": "Hace pull con rebase por defecto.",
                "example": "git config --global pull.rebase true",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global push.autoSetupRemote true",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Permite que el primer push configure upstream automáticamente cuando corresponde.",
                "example": "git config --global push.autoSetupRemote true",
                "expected": "Sin salida; simplifica el primer push de ramas nuevas.",
                "note": ""
            },
            {
                "command": "git config --global push.default current",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Hace que git push publique por defecto la rama actual con el mismo nombre.",
                "example": "git config --global push.default current",
                "expected": "Sin salida; cambia el comportamiento por defecto de push.",
                "note": ""
            },
            {
                "command": "git config --global user.signingkey <key-id>",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Define la clave usada para firmar commits o tags.",
                "example": "git config --global user.signingkey ABCD1234",
                "expected": "Sin salida; Git usará esa clave cuando se solicite firma.",
                "note": ""
            },
            {
                "command": "git config --show-origin --list",
                "level": "intermediate",
                "description": "Lista configuracion indicando el archivo de origen.",
                "example": "git config --show-origin --list",
                "expected": "archivo + clave=valor.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --system --list",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Lista la configuración de Git a nivel del sistema.",
                "example": "git config --system --list",
                "expected": "Configuración del archivo system de Git; puede requerir permisos elevados.",
                "note": ""
            },
            {
                "command": "git config core.fileMode false",
                "level": "intermediate",
                "topic": "Configuración",
                "description": "Hace que Git ignore cambios solo de bit ejecutable en este repositorio.",
                "example": "git config core.fileMode false",
                "expected": "Sin salida; git status deja de marcar cambios de modo cuando corresponde.",
                "note": ""
            },
            {
                "command": "git config --global --add safe.directory <path>",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Agrega otra ruta a la lista global de directorios seguros.",
                "example": "git config --global --add safe.directory C:/repos/otro",
                "expected": "Sin salida; se agrega una entrada adicional.",
                "note": "No uses * salvo que entiendas la implicancia de seguridad."
            },
            {
                "command": "git config --global --unset-all safe.directory",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Elimina todas las entradas safe.directory globales.",
                "example": "git config --global --unset-all safe.directory",
                "expected": "Sin salida si se eliminan; puede devolver código distinto si no había entradas.",
                "note": ""
            },
            {
                "command": "git config --global commit.gpgsign true",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Firma automáticamente todos los commits.",
                "example": "git config --global commit.gpgsign true",
                "expected": "Sin salida; los commits nuevos intentarán firmarse.",
                "note": "Requiere una clave de firma correctamente configurada."
            },
            {
                "command": "git config --global credential.helper store",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Guarda credenciales mediante el helper store.",
                "example": "git config --global credential.helper store",
                "expected": "Sin salida; el helper puede guardar credenciales sin cifrar en disco.",
                "note": "Evitá esta opción para secretos sensibles si disponés de un credential manager seguro."
            },
            {
                "command": "git config --global diff.algorithm histogram",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Usa el algoritmo histogram para calcular diffs.",
                "example": "git config --global diff.algorithm histogram",
                "expected": "Sin salida; futuros git diff usan ese algoritmo.",
                "note": ""
            },
            {
                "command": "git config --global fetch.pruneTags true",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Permite podar tags locales que ya no existen al hacer fetch con prune.",
                "example": "git config --global fetch.pruneTags true",
                "expected": "Sin salida; afecta operaciones fetch futuras.",
                "note": "Revisá la política de tags antes de activarlo."
            },
            {
                "command": "git config --global include.path <file>",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Incluye otro archivo de configuración Git desde la configuración global.",
                "example": "git config --global include.path ~/.gitconfig-work",
                "expected": "Sin salida; Git carga el archivo incluido.",
                "note": ""
            },
            {
                "command": "git config --global merge.conflictstyle zdiff3",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Muestra contexto base adicional en conflictos con estilo zdiff3.",
                "example": "git config --global merge.conflictstyle zdiff3",
                "expected": "Sin salida; los conflictos futuros incluyen una representación más informativa.",
                "note": ""
            },
            {
                "command": "git config --global rerere.autoupdate true",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Permite que rerere actualice el índice tras reutilizar una resolución conocida.",
                "example": "git config --global rerere.autoupdate true",
                "expected": "Sin salida; rerere podrá aplicar resoluciones previas automáticamente.",
                "note": ""
            },
            {
                "command": "git config --global rerere.enabled true",
                "level": "advanced",
                "description": "Recuerda resoluciones de conflictos para reutilizarlas.",
                "example": "git config --global rerere.enabled true",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Configuración"
            },
            {
                "command": "git config --global safe.directory <path>",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Marca un repositorio como directorio seguro cuando Git detecta propietario distinto.",
                "example": "git config --global safe.directory C:/repos/app",
                "expected": "Sin salida; Git deja de bloquear ese repositorio por dubious ownership.",
                "note": "Agregá solo rutas que realmente controles."
            },
            {
                "command": "git config --global tag.gpgSign true",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Firma automáticamente los tags anotados.",
                "example": "git config --global tag.gpgSign true",
                "expected": "Sin salida; los tags nuevos intentarán incluir firma.",
                "note": ""
            },
            {
                "command": "git config --show-scope --show-origin --list",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Muestra alcance, archivo de origen, clave y valor de cada configuración efectiva.",
                "example": "git config --show-scope --show-origin --list",
                "expected": "Filas con scope, ruta de origen y clave=valor.",
                "note": ""
            },
            {
                "command": "git credential approve",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Informa a los helpers que una credencial fue aceptada y puede guardarse.",
                "example": "printf \"protocol=https\\nhost=example.com\\nusername=user\\npassword=secret\\n\\n\" | git credential approve",
                "expected": "Normalmente sin salida.",
                "note": "El ejemplo contiene secret ilustrativo; no pegues secretos reales en historiales de shell inseguros."
            },
            {
                "command": "git credential fill",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Pide a los credential helpers completar una credencial descrita por stdin.",
                "example": "printf \"protocol=https\\nhost=github.com\\n\\n\" | git credential fill",
                "expected": "Campos como protocol, host, username, password/token según helper.",
                "note": "No imprimas ni registres el resultado en logs compartidos."
            },
            {
                "command": "git credential reject",
                "level": "advanced",
                "topic": "Configuración",
                "description": "Solicita a los helpers olvidar/rechazar una credencial.",
                "example": "printf \"protocol=https\\nhost=example.com\\n\\n\" | git credential reject",
                "expected": "Normalmente sin salida.",
                "note": ""
            },
            {
                "command": "git clone --branch <branch> <url>",
                "level": "basic",
                "topic": "Inicialización y clone",
                "description": "Clona y deja checkout en una rama o tag específico.",
                "example": "git clone --branch develop https://github.com/example/app.git",
                "expected": "Clona el repositorio y deja develop activo.",
                "note": ""
            },
            {
                "command": "git clone <url>",
                "level": "basic",
                "description": "Clona un repositorio remoto completo.",
                "example": "git clone https://github.com/example/app.git",
                "expected": "Se crea la carpeta app y se descargan objetos y ramas remotas.",
                "note": "",
                "topic": "Inicialización y clone"
            },
            {
                "command": "git clone <url> <directory>",
                "level": "basic",
                "topic": "Inicialización y clone",
                "description": "Clona un repositorio usando un nombre de carpeta personalizado.",
                "example": "git clone https://github.com/example/app.git app-local",
                "expected": "Crea app-local y descarga el repositorio.",
                "note": ""
            },
            {
                "command": "git init",
                "level": "basic",
                "description": "Inicializa un repositorio Git en la carpeta actual.",
                "example": "git init",
                "expected": "Initialized empty Git repository in .../.git/",
                "note": "",
                "topic": "Inicialización y clone"
            },
            {
                "command": "git clone --depth <n> <url>",
                "level": "intermediate",
                "topic": "Inicialización y clone",
                "description": "Realiza un clone shallow limitado a cierta profundidad de historial.",
                "example": "git clone --depth 1 https://github.com/example/app.git",
                "expected": "Clona el commit más reciente y crea un repositorio shallow.",
                "note": ""
            },
            {
                "command": "git clone --no-checkout <url>",
                "level": "intermediate",
                "topic": "Inicialización y clone",
                "description": "Clona objetos y refs pero no realiza checkout del working tree.",
                "example": "git clone --no-checkout https://github.com/example/app.git",
                "expected": "Repositorio clonado sin archivos checkout.",
                "note": ""
            },
            {
                "command": "git clone --recurse-submodules <url>",
                "level": "intermediate",
                "topic": "Inicialización y clone",
                "description": "Clona el repositorio e inicializa/actualiza sus submódulos.",
                "example": "git clone --recurse-submodules https://github.com/example/app.git",
                "expected": "Clona repo principal y contenido de submódulos configurados.",
                "note": ""
            },
            {
                "command": "git clone --single-branch --branch <branch> <url>",
                "level": "intermediate",
                "topic": "Inicialización y clone",
                "description": "Clona únicamente el historial alcanzable desde una rama seleccionada.",
                "example": "git clone --single-branch --branch release https://github.com/example/app.git",
                "expected": "Descarga la rama release sin traer todas las ramas remotas.",
                "note": ""
            },
            {
                "command": "git init --bare",
                "level": "intermediate",
                "topic": "Inicialización y clone",
                "description": "Inicializa un repositorio bare, sin working tree, útil como remoto central.",
                "example": "git init --bare project.git",
                "expected": "Initialized empty Git repository in .../project.git/",
                "note": ""
            },
            {
                "command": "git clone --bare <url>",
                "level": "advanced",
                "topic": "Inicialización y clone",
                "description": "Clona como repositorio bare sin working tree.",
                "example": "git clone --bare https://github.com/example/app.git app.git",
                "expected": "Crea app.git sin checkout de archivos.",
                "note": ""
            },
            {
                "command": "git clone --filter=blob:none <url>",
                "level": "advanced",
                "topic": "Inicialización y clone",
                "description": "Hace un partial clone omitiendo blobs hasta que sean necesarios.",
                "example": "git clone --filter=blob:none https://github.com/example/large.git",
                "expected": "Crea un partial clone; objetos de archivo se descargan bajo demanda.",
                "note": ""
            },
            {
                "command": "git clone --mirror <url>",
                "level": "advanced",
                "topic": "Inicialización y clone",
                "description": "Crea un mirror bare con todas las refs y configuración remota apropiada para replicación.",
                "example": "git clone --mirror https://github.com/example/app.git app.git",
                "expected": "Crea app.git con todas las refs para mirror.",
                "note": "Ideal para migraciones/replicación; no es un working copy normal."
            },
            {
                "command": "git clone --origin <name> <url>",
                "level": "advanced",
                "topic": "Inicialización y clone",
                "description": "Cambia el nombre del remoto inicial en vez de usar origin.",
                "example": "git clone --origin upstream https://github.com/example/app.git",
                "expected": "El remoto inicial queda llamado upstream.",
                "note": ""
            },
            {
                "command": "git clone --sparse <url>",
                "level": "advanced",
                "topic": "Inicialización y clone",
                "description": "Clona preparando sparse-checkout para trabajar con una parte del repo.",
                "example": "git clone --sparse https://github.com/example/monorepo.git",
                "expected": "Clona el repo y habilita sparse-checkout.",
                "note": ""
            },
            {
                "command": "git clone <bundle> <directory>",
                "level": "advanced",
                "topic": "Inicialización y clone",
                "description": "Clona un repositorio directamente desde un archivo bundle.",
                "example": "git clone repo.bundle recovered-repo",
                "expected": "Crea recovered-repo usando el bundle como origen.",
                "note": ""
            },
            {
                "command": "git fetch",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Descarga refs y objetos del remoto por defecto sin integrar cambios.",
                "example": "git fetch",
                "expected": "From ... seguido de ramas/tags actualizados; working tree no cambia.",
                "note": ""
            },
            {
                "command": "git fetch origin",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Descarga actualizaciones desde origin sin merge/rebase.",
                "example": "git fetch origin",
                "expected": "Actualiza refs origin/* y muestra lo descargado.",
                "note": ""
            },
            {
                "command": "git fetch origin <branch>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Descarga una rama concreta desde origin.",
                "example": "git fetch origin main",
                "expected": "Actualiza FETCH_HEAD y la ref remota correspondiente.",
                "note": ""
            },
            {
                "command": "git pull",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Hace fetch e integra la rama upstream en la rama actual según configuración.",
                "example": "git pull",
                "expected": "Salida de fetch seguida de merge/rebase o Already up to date.",
                "note": ""
            },
            {
                "command": "git pull origin <branch>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Trae e integra una rama concreta desde origin.",
                "example": "git pull origin main",
                "expected": "Fetch de origin/main seguido de integración en la rama actual.",
                "note": ""
            },
            {
                "command": "git push",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Publica la rama/ref actual según upstream y push.default.",
                "example": "git push",
                "expected": "Enumerating objects... o Everything up-to-date.",
                "note": ""
            },
            {
                "command": "git push --set-upstream origin <branch>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Publica una rama y establece origin/<branch> como upstream.",
                "example": "git push --set-upstream origin feature/login",
                "expected": "branch feature/login set up to track origin/feature/login.",
                "note": ""
            },
            {
                "command": "git push -u origin <branch>",
                "level": "basic",
                "description": "Publica una rama y configura su upstream.",
                "example": "git push -u origin feature/payments",
                "expected": "branch ... set up to track origin/...",
                "note": "",
                "topic": "Remotos y colaboración"
            },
            {
                "command": "git push origin --delete <branch>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Elimina una rama del remoto origin.",
                "example": "git push origin --delete feature/old",
                "expected": "- [deleted] feature/old.",
                "note": "Borra la referencia remota; coordiná antes con el equipo."
            },
            {
                "command": "git push origin <branch>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Publica una rama local en origin con el mismo nombre.",
                "example": "git push origin main",
                "expected": "Objetos enviados y actualización main -> main.",
                "note": ""
            },
            {
                "command": "git push origin <tag>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Publica un tag concreto en origin.",
                "example": "git push origin v1.2.0",
                "expected": "[new tag] v1.2.0 -> v1.2.0.",
                "note": ""
            },
            {
                "command": "git remote",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Lista los nombres de los remotos configurados.",
                "example": "git remote",
                "expected": "origin\nupstream",
                "note": ""
            },
            {
                "command": "git remote -v",
                "level": "basic",
                "description": "Lista remotos y sus URLs de fetch/push.",
                "example": "git remote -v",
                "expected": "origin  https://... (fetch)\norigin  https://... (push)",
                "note": "",
                "topic": "Remotos y colaboración"
            },
            {
                "command": "git remote add origin <url>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Agrega un remoto llamado origin al repositorio actual.",
                "example": "git remote add origin https://github.com/example/app.git",
                "expected": "Normalmente no imprime salida; git remote -v mostrará origin.",
                "note": "Este es el comando típico después de git init antes del primer push."
            },
            {
                "command": "git remote add upstream <url>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Agrega un remoto upstream, habitual al trabajar con forks.",
                "example": "git remote add upstream https://github.com/original/app.git",
                "expected": "Sin salida; upstream queda disponible para fetch/pull.",
                "note": ""
            },
            {
                "command": "git remote get-url origin",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Muestra la URL de fetch del remoto origin.",
                "example": "git remote get-url origin",
                "expected": "https://github.com/example/app.git",
                "note": ""
            },
            {
                "command": "git remote remove <name>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Elimina un remoto y sus ramas de seguimiento remoto asociadas.",
                "example": "git remote remove upstream",
                "expected": "Sin salida; upstream deja de aparecer en git remote -v.",
                "note": "No borra el repositorio remoto real."
            },
            {
                "command": "git remote rm <name>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Alias histórico de git remote remove.",
                "example": "git remote rm upstream",
                "expected": "Sin salida; elimina la configuración local del remoto.",
                "note": ""
            },
            {
                "command": "git remote set-url origin <new-url>",
                "level": "basic",
                "topic": "Remotos y colaboración",
                "description": "Cambia la URL principal del remoto origin.",
                "example": "git remote set-url origin git@github.com:example/app.git",
                "expected": "Sin salida; git remote -v mostrará la nueva URL.",
                "note": ""
            },
            {
                "command": "git fetch --all",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Ejecuta fetch para todos los remotos configurados.",
                "example": "git fetch --all",
                "expected": "Salida de cada remoto consultado.",
                "note": ""
            },
            {
                "command": "git fetch --all --prune",
                "level": "intermediate",
                "description": "Actualiza referencias remotas y elimina referencias a ramas remotas borradas.",
                "example": "git fetch --all --prune",
                "expected": "From origin ...; ramas nuevas/actualizadas/eliminadas.",
                "note": "",
                "topic": "Remotos y colaboración"
            },
            {
                "command": "git fetch --prune",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Hace fetch y elimina ramas remotas locales que ya no existen.",
                "example": "git fetch --prune",
                "expected": "Actualizaciones y líneas [deleted] para refs podadas.",
                "note": ""
            },
            {
                "command": "git fetch --tags",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Descarga explícitamente todos los tags del remoto.",
                "example": "git fetch --tags",
                "expected": "Nuevos tags y objetos asociados.",
                "note": ""
            },
            {
                "command": "git ls-remote --heads origin",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Lista únicamente ramas publicadas en el remoto.",
                "example": "git ls-remote --heads origin",
                "expected": "SHA refs/heads/main, refs/heads/develop, etc.",
                "note": ""
            },
            {
                "command": "git ls-remote --tags origin",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Lista tags disponibles en el remoto.",
                "example": "git ls-remote --tags origin",
                "expected": "SHA refs/tags/v1.0.0, etc.",
                "note": ""
            },
            {
                "command": "git ls-remote origin",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Consulta refs del remoto sin hacer fetch.",
                "example": "git ls-remote origin",
                "expected": "SHA y ref remota por línea.",
                "note": ""
            },
            {
                "command": "git pull --autostash",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Crea temporalmente un autostash para permitir el pull y lo reaplica al final.",
                "example": "git pull --rebase --autostash",
                "expected": "Created autostash... seguido de pull/rebase y reaplicación.",
                "note": "Puede generar conflictos al reaplicar cambios locales."
            },
            {
                "command": "git pull --ff-only",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Actualiza solo si puede hacerse fast-forward; evita merge commits automáticos.",
                "example": "git pull --ff-only",
                "expected": "Fast-forward ... o error si la historia diverge.",
                "note": ""
            },
            {
                "command": "git pull --no-rebase",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Fuerza estrategia merge para integrar el fetch.",
                "example": "git pull --no-rebase",
                "expected": "Merge/fast-forward según estado de las ramas.",
                "note": ""
            },
            {
                "command": "git pull --prune",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Hace pull mientras poda refs remotas obsoletas durante el fetch.",
                "example": "git pull --prune",
                "expected": "Fetch con poda seguido de integración.",
                "note": ""
            },
            {
                "command": "git pull --rebase",
                "level": "intermediate",
                "description": "Trae cambios remotos y reaplica tus commits locales encima.",
                "example": "git pull --rebase",
                "expected": "Already up to date o secuencia fetch + rebase.",
                "note": "",
                "topic": "Remotos y colaboración"
            },
            {
                "command": "git pull --tags",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Hace pull solicitando también todos los tags.",
                "example": "git pull --tags",
                "expected": "Fetch de tags más integración de la rama correspondiente.",
                "note": ""
            },
            {
                "command": "git push --dry-run",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Simula qué refs se publicarían sin enviar cambios.",
                "example": "git push --dry-run origin main",
                "expected": "Muestra el refspec/resultado previsto sin modificar el remoto.",
                "note": ""
            },
            {
                "command": "git push --follow-tags",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Publica commits y tags anotados alcanzables que faltan en el remoto.",
                "example": "git push --follow-tags origin main",
                "expected": "Push de main más tags anotados relacionados.",
                "note": ""
            },
            {
                "command": "git push origin --delete <tag>",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Elimina del remoto una ref cuyo nombre corresponde al tag indicado cuando no hay ambigüedad.",
                "example": "git push origin --delete v1.2.0",
                "expected": "- [deleted] v1.2.0.",
                "note": "Si existe una rama con el mismo nombre, usá refs/tags/<tag> explícitamente."
            },
            {
                "command": "git push origin --tags",
                "level": "intermediate",
                "description": "Publica todos los tags locales.",
                "example": "git push origin --tags",
                "expected": "Tags enviados.",
                "note": "",
                "topic": "Remotos y colaboración"
            },
            {
                "command": "git push origin <local-branch>:<remote-branch>",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Publica una rama local bajo otro nombre remoto.",
                "example": "git push origin feature/login:review/login",
                "expected": "feature/login -> review/login.",
                "note": ""
            },
            {
                "command": "git push origin HEAD",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Publica el commit/rama actual usando HEAD como ref de origen.",
                "example": "git push origin HEAD",
                "expected": "Actualiza la rama remota correspondiente según refspec/configuración.",
                "note": ""
            },
            {
                "command": "git push origin refs/tags/<tag>",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Publica un tag concreto usando su ref completa.",
                "example": "git push origin refs/tags/v1.2.0",
                "expected": "Crea/actualiza refs/tags/v1.2.0 en origin.",
                "note": ""
            },
            {
                "command": "git remote add -f <name> <url>",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Agrega un remoto y hace fetch inmediatamente.",
                "example": "git remote add -f upstream https://github.com/original/app.git",
                "expected": "Muestra el fetch inicial y crea refs remotas.",
                "note": ""
            },
            {
                "command": "git remote get-url --all origin",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Lista todas las URLs de fetch asociadas al remoto.",
                "example": "git remote get-url --all origin",
                "expected": "Una o más URLs, una por línea.",
                "note": ""
            },
            {
                "command": "git remote get-url --push origin",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Muestra la URL usada para push hacia origin.",
                "example": "git remote get-url --push origin",
                "expected": "URL configurada para push.",
                "note": ""
            },
            {
                "command": "git remote prune origin",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Borra refs remotas locales que ya no existen en origin.",
                "example": "git remote prune origin",
                "expected": "Pruning origin\nURL: ...\n * [pruned] origin/old-branch",
                "note": ""
            },
            {
                "command": "git remote rename <old> <new>",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Renombra un remoto y actualiza sus refs/configuración asociada.",
                "example": "git remote rename origin github",
                "expected": "Sin salida; refs remotas pasan a remotes/github/...",
                "note": ""
            },
            {
                "command": "git remote show origin",
                "level": "intermediate",
                "description": "Muestra tracking y estado detallado de origin.",
                "example": "git remote show origin",
                "expected": "HEAD remoto, ramas tracked y estado push/pull.",
                "note": "",
                "topic": "Remotos y colaboración"
            },
            {
                "command": "git remote update",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Hace fetch de los remotos configurados según remotes/groups.",
                "example": "git remote update",
                "expected": "Salida similar a uno o varios fetch.",
                "note": ""
            },
            {
                "command": "git remote update --prune",
                "level": "intermediate",
                "topic": "Remotos y colaboración",
                "description": "Actualiza remotos y poda referencias obsoletas.",
                "example": "git remote update --prune",
                "expected": "Fetch de remotos más refs eliminadas cuando corresponda.",
                "note": ""
            },
            {
                "command": "git fetch --deepen <n>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Profundiza un shallow clone agregando más commits históricos.",
                "example": "git fetch --deepen 100 origin",
                "expected": "Descarga hasta 100 niveles históricos adicionales.",
                "note": ""
            },
            {
                "command": "git fetch --depth <n>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Limita/ajusta la profundidad de un repositorio shallow.",
                "example": "git fetch --depth 50 origin",
                "expected": "Actualiza historial shallow hasta la profundidad solicitada.",
                "note": ""
            },
            {
                "command": "git fetch --filter=blob:none origin",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Hace fetch usando partial clone filter para evitar blobs no necesarios.",
                "example": "git fetch --filter=blob:none origin",
                "expected": "Actualiza objetos/refs respetando el filtro cuando el servidor lo soporta.",
                "note": ""
            },
            {
                "command": "git fetch --prune --tags",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Actualiza refs, poda ramas obsoletas y trae tags.",
                "example": "git fetch --prune --tags",
                "expected": "Fetch con ramas/tags y refs eliminadas cuando corresponda.",
                "note": ""
            },
            {
                "command": "git fetch --unshallow",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Convierte un repositorio shallow en un clone con historial completo.",
                "example": "git fetch --unshallow",
                "expected": "Descarga el historial faltante y elimina la limitación shallow.",
                "note": ""
            },
            {
                "command": "git fetch origin +refs/heads/*:refs/remotes/origin/*",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Ejecuta un fetch usando un refspec explícito para todas las ramas.",
                "example": "git fetch origin +refs/heads/*:refs/remotes/origin/*",
                "expected": "Actualiza refs/remotes/origin/*; + permite non-fast-forward.",
                "note": "El + fuerza actualización de refs remotas locales."
            },
            {
                "command": "git fetch origin <branch> --force",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Fuerza actualización del fetch para una rama cuando el refspec normal no permite non-fast-forward.",
                "example": "git fetch origin feature/rebased --force",
                "expected": "Actualiza FETCH_HEAD/ref remota aun si el remoto reescribió historial.",
                "note": "Revisá reflog y cambios antes de sincronizar ramas reescritas."
            },
            {
                "command": "git fetch origin <remote-branch>:<local-branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Descarga una rama remota y actualiza/crea una rama local específica.",
                "example": "git fetch origin release:release-local",
                "expected": "Actualiza release-local con la ref release del remoto.",
                "note": "Puede sobrescribir el avance de la rama local según el refspec; revisá antes."
            },
            {
                "command": "git fetch origin refs/heads/<branch>:refs/remotes/origin/<branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Actualiza manualmente una remote-tracking ref mediante refspec explícito.",
                "example": "git fetch origin refs/heads/main:refs/remotes/origin/main",
                "expected": "Actualiza origin/main con la rama main remota.",
                "note": ""
            },
            {
                "command": "git fetch origin refs/pull/<id>/head:pr-<id>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Descarga una referencia de pull request de GitHub a una rama local.",
                "example": "git fetch origin refs/pull/123/head:pr-123",
                "expected": "Crea/actualiza la rama local pr-123.",
                "note": "Este refspec es específico de GitHub y depende del servidor."
            },
            {
                "command": "git ls-remote --exit-code origin refs/heads/<branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Comprueba si una rama concreta existe remotamente usando el exit code.",
                "example": "git ls-remote --exit-code origin refs/heads/main",
                "expected": "Imprime SHA+ref si existe; exit code 2 si no hay coincidencia.",
                "note": ""
            },
            {
                "command": "git ls-remote --symref origin HEAD",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Consulta la referencia simbólica HEAD del remoto.",
                "example": "git ls-remote --symref origin HEAD",
                "expected": "ref: refs/heads/main HEAD seguido del SHA.",
                "note": ""
            },
            {
                "command": "git pull --depth <n>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Hace pull ajustando profundidad en un repositorio shallow.",
                "example": "git pull --depth 50 origin main",
                "expected": "Actualiza el shallow history y luego integra.",
                "note": ""
            },
            {
                "command": "git pull --no-commit",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Realiza merge durante pull pero detiene antes de crear el commit de merge cuando es posible.",
                "example": "git pull --no-commit origin main",
                "expected": "Deja cambios mergeados listos para inspección/commit.",
                "note": ""
            },
            {
                "command": "git pull --rebase=merges",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Rebasea preservando/recreando estructura de merges.",
                "example": "git pull --rebase=merges",
                "expected": "Rebase de commits locales incluyendo topología de merges.",
                "note": ""
            },
            {
                "command": "git push --atomic origin <branch1> <branch2>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Solicita que varias refs se actualicen todas o ninguna.",
                "example": "git push --atomic origin main develop",
                "expected": "Actualiza ambas refs de forma atómica o falla todo.",
                "note": "El servidor remoto debe soportar atomic push."
            },
            {
                "command": "git push --force",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Fuerza actualización remota aunque no sea fast-forward.",
                "example": "git push --force origin feature/rebased",
                "expected": "Forced update si el servidor lo permite.",
                "note": "Puede borrar commits remotos de otros usuarios. Usalo solo con plena certeza."
            },
            {
                "command": "git push --force-if-includes",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Exige que actualizaciones remotas observadas estén integradas antes de permitir force-with-lease implícito.",
                "example": "git push --force-with-lease --force-if-includes origin feature/rebased",
                "expected": "Push forzado solo cuando se cumplen las verificaciones de inclusión.",
                "note": "Útil como protección adicional; requiere Git moderno."
            },
            {
                "command": "git push --force-with-lease",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Fuerza el push solo si la ref remota conserva el valor esperado localmente.",
                "example": "git push --force-with-lease",
                "expected": "Forced update si el lease coincide; rechazo si el remoto avanzó.",
                "note": "Preferilo sobre --force al reescribir historial compartido."
            },
            {
                "command": "git push --force-with-lease origin <branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Aplica force-with-lease a una rama/remoto específicos.",
                "example": "git push --force-with-lease origin feature/rebased",
                "expected": "Actualización forzada segura o rechazo por lease.",
                "note": ""
            },
            {
                "command": "git push --force-with-lease=<ref>:<expect> origin <branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Usa un lease explícito que exige un object id remoto concreto antes de forzar.",
                "example": "git push --force-with-lease=refs/heads/feature:abc1234 origin feature",
                "expected": "Push solo si la ref remota aún vale abc1234; si no, rechazo.",
                "note": ""
            },
            {
                "command": "git push --mirror origin",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Replica todas las refs locales bajo refs/ hacia el remoto, eliminando refs remotas ausentes localmente.",
                "example": "git push --mirror origin",
                "expected": "Sincronización completa de refs.",
                "note": "Muy destructivo si origin no es un mirror dedicado."
            },
            {
                "command": "git push --no-verify",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Omite el hook pre-push local.",
                "example": "git push --no-verify origin main",
                "expected": "Push normal sin ejecutar pre-push.",
                "note": "Evitá saltarte checks salvo que exista una razón controlada."
            },
            {
                "command": "git push --porcelain",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Produce salida estable y fácil de procesar por scripts.",
                "example": "git push --porcelain origin main",
                "expected": "Salida tabular/porcelain por cada ref actualizada.",
                "note": ""
            },
            {
                "command": "git push --prune origin",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Elimina refs remotas que no tengan equivalente local según el refspec aplicado.",
                "example": "git push --prune origin refs/heads/*:refs/heads/*",
                "expected": "Refs remotas sobrantes pueden ser eliminadas.",
                "note": "Revisá con --dry-run antes de usarlo."
            },
            {
                "command": "git push --signed",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Solicita firmar criptográficamente la operación push si servidor/cliente lo soportan.",
                "example": "git push --signed origin main",
                "expected": "Push firmado o error si no es soportado/configurado.",
                "note": ""
            },
            {
                "command": "git push -o <push-option>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Envía una push option al servidor remoto.",
                "example": "git push -o ci.skip origin main",
                "expected": "El servidor recibe la opción y puede actuar sobre ella.",
                "note": "Las opciones disponibles dependen del proveedor/servidor Git."
            },
            {
                "command": "git push origin --all",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Publica todas las ramas locales en origin.",
                "example": "git push origin --all",
                "expected": "Actualiza/crea varias refs refs/heads/* en el remoto.",
                "note": ""
            },
            {
                "command": "git push origin :<branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Sintaxis de refspec para eliminar una rama remota.",
                "example": "git push origin :feature/old",
                "expected": "- [deleted] feature/old.",
                "note": "Equivale conceptualmente a push --delete."
            },
            {
                "command": "git push origin :refs/tags/<tag>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Elimina un tag del remoto mediante refspec vacío.",
                "example": "git push origin :refs/tags/v1.2.0",
                "expected": "- [deleted] v1.2.0.",
                "note": "No elimina automáticamente el tag local."
            },
            {
                "command": "git push origin <commit>:refs/heads/<branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Publica un commit específico como tip de una rama remota.",
                "example": "git push origin abc1234:refs/heads/recovery",
                "expected": "Crea/actualiza recovery apuntando a abc1234.",
                "note": "Asegurate de publicar el commit correcto; no necesita corresponder a tu rama actual."
            },
            {
                "command": "git push origin HEAD:refs/heads/<remote-branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Publica la rama actual con un nombre remoto explícito.",
                "example": "git push origin HEAD:refs/heads/review/login",
                "expected": "Crea/actualiza review/login en origin.",
                "note": ""
            },
            {
                "command": "git remote add -t <branch> <name> <url>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Agrega un remoto configurado para seguir solo una rama concreta.",
                "example": "git remote add -t main upstream https://github.com/original/app.git",
                "expected": "Sin salida; el fetch refspec queda restringido a main.",
                "note": ""
            },
            {
                "command": "git remote set-branches --add origin <branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Añade otra rama al conjunto seguido por el remoto.",
                "example": "git remote set-branches --add origin develop",
                "expected": "Sin salida; agrega otro refspec de seguimiento.",
                "note": ""
            },
            {
                "command": "git remote set-branches origin <branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Configura qué rama(s) del remoto serán seguidas en fetch.",
                "example": "git remote set-branches origin main",
                "expected": "Sin salida; modifica remote.origin.fetch.",
                "note": ""
            },
            {
                "command": "git remote set-head origin -a",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Detecta automáticamente la rama HEAD predeterminada de origin.",
                "example": "git remote set-head origin -a",
                "expected": "origin/HEAD set to main o equivalente.",
                "note": ""
            },
            {
                "command": "git remote set-head origin -d",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Elimina la referencia simbólica origin/HEAD.",
                "example": "git remote set-head origin -d",
                "expected": "Sin salida; origin/HEAD se elimina.",
                "note": ""
            },
            {
                "command": "git remote set-head origin <branch>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Fija manualmente qué rama representa origin/HEAD.",
                "example": "git remote set-head origin main",
                "expected": "Sin salida; origin/HEAD apunta a origin/main.",
                "note": ""
            },
            {
                "command": "git remote set-url --add --push origin <url>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Agrega una URL adicional específicamente para push.",
                "example": "git remote set-url --add --push origin git@github.com:example/app.git",
                "expected": "Sin salida; push puede usar múltiples push URLs.",
                "note": ""
            },
            {
                "command": "git remote set-url --add origin <url>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Agrega una URL adicional al remoto.",
                "example": "git remote set-url --add origin https://mirror.example.com/app.git",
                "expected": "Sin salida; origin queda asociado a múltiples URLs.",
                "note": ""
            },
            {
                "command": "git remote set-url --delete --push origin <regex>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Elimina una push URL que coincida con el patrón.",
                "example": "git remote set-url --delete --push origin old-host",
                "expected": "Sin salida si elimina la URL.",
                "note": ""
            },
            {
                "command": "git remote set-url --delete origin <regex>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Elimina una URL de fetch del remoto que coincida con el patrón.",
                "example": "git remote set-url --delete origin mirror\\.example\\.com",
                "expected": "Sin salida si encuentra y elimina una URL coincidente.",
                "note": "Verificá con git remote get-url --all origin antes de borrar."
            },
            {
                "command": "git request-pull <start> <url> <end>",
                "level": "advanced",
                "topic": "Remotos y colaboración",
                "description": "Genera un resumen textual para solicitar que otro maintainer integre cambios.",
                "example": "git request-pull v1.0 https://github.com/example/app.git feature",
                "expected": "Resumen con commits y diffstat listo para enviar.",
                "note": ""
            },
            {
                "command": "git branch",
                "level": "basic",
                "description": "Lista ramas locales y marca la rama actual.",
                "example": "git branch",
                "expected": "* main\n  develop\n  feature/auth",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git branch --show-current",
                "level": "basic",
                "topic": "Ramas",
                "description": "Muestra el nombre de la rama actualmente checkout.",
                "example": "git branch --show-current",
                "expected": "main",
                "note": ""
            },
            {
                "command": "git branch -a",
                "level": "basic",
                "description": "Lista ramas locales y remotas.",
                "example": "git branch -a",
                "expected": "Ramas y remotes/origin/...",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git branch -d <branch>",
                "level": "basic",
                "description": "Elimina rama local ya integrada.",
                "example": "git branch -d feature/login",
                "expected": "Deleted branch ...",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git branch -m <new-name>",
                "level": "basic",
                "description": "Renombra la rama actual.",
                "example": "git branch -m main",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git branch -r",
                "level": "basic",
                "topic": "Ramas",
                "description": "Lista ramas de seguimiento remoto.",
                "example": "git branch -r",
                "expected": "origin/main\norigin/develop\nupstream/main",
                "note": ""
            },
            {
                "command": "git branch <branch>",
                "level": "basic",
                "topic": "Ramas",
                "description": "Crea una rama sin cambiarte a ella.",
                "example": "git branch feature/login",
                "expected": "Sin salida; la rama aparece en git branch.",
                "note": ""
            },
            {
                "command": "git switch -",
                "level": "basic",
                "topic": "Ramas",
                "description": "Vuelve a la rama previamente checkout.",
                "example": "git switch -",
                "expected": "Switched to branch ...",
                "note": ""
            },
            {
                "command": "git switch --track origin/<branch>",
                "level": "basic",
                "topic": "Ramas",
                "description": "Crea/cambia a una rama local que trackea la rama remota.",
                "example": "git switch --track origin/feature/login",
                "expected": "Switched to a new branch feature/login; tracking origin/feature/login.",
                "note": ""
            },
            {
                "command": "git switch -c <branch>",
                "level": "basic",
                "description": "Crea una rama nueva y cambia a ella.",
                "example": "git switch -c feature/payments",
                "expected": "Switched to a new branch 'feature/payments'",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git switch <branch>",
                "level": "basic",
                "description": "Cambia a una rama existente.",
                "example": "git switch develop",
                "expected": "Switched to branch 'develop'",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git branch --contains <commit>",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Lista ramas que contienen un commit.",
                "example": "git branch --contains abc1234",
                "expected": "Ramas locales que alcanzan ese commit.",
                "note": ""
            },
            {
                "command": "git branch --merged",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Lista ramas locales ya integradas en HEAD.",
                "example": "git branch --merged",
                "expected": "Ramas cuyos tips son ancestros de HEAD.",
                "note": ""
            },
            {
                "command": "git branch --no-merged",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Lista ramas todavía no integradas en HEAD.",
                "example": "git branch --no-merged",
                "expected": "Ramas con commits no fusionados.",
                "note": ""
            },
            {
                "command": "git branch --set-upstream-to=origin/<branch> <local-branch>",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Asocia una rama local existente con una rama upstream remota.",
                "example": "git branch --set-upstream-to=origin/main main",
                "expected": "branch main set up to track origin/main.",
                "note": ""
            },
            {
                "command": "git branch --sort=-committerdate",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Ordena ramas por fecha del último commit, más recientes primero.",
                "example": "git branch --sort=-committerdate",
                "expected": "Lista de ramas ordenada por committerdate.",
                "note": ""
            },
            {
                "command": "git branch --unset-upstream",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Quita el upstream configurado de la rama actual.",
                "example": "git branch --unset-upstream",
                "expected": "Sin salida; la rama queda sin tracking upstream.",
                "note": ""
            },
            {
                "command": "git branch -u origin/<branch>",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Forma abreviada para establecer upstream de la rama actual.",
                "example": "git branch -u origin/main",
                "expected": "branch main set up to track origin/main.",
                "note": ""
            },
            {
                "command": "git branch -vv",
                "level": "intermediate",
                "description": "Lista ramas con upstream y ultimo commit.",
                "example": "git branch -vv",
                "expected": "Rama, hash, tracking, mensaje.",
                "note": "",
                "topic": "Ramas"
            },
            {
                "command": "git branch <branch> <start-point>",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Crea una rama desde un commit/tag/rama específicos.",
                "example": "git branch hotfix v1.2.0",
                "expected": "Sin salida; hotfix apunta al start-point.",
                "note": ""
            },
            {
                "command": "git checkout -b <branch> --track origin/<branch>",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Crea una rama local con tracking usando checkout clásico.",
                "example": "git checkout -b feature/login --track origin/feature/login",
                "expected": "Switched to a new branch feature/login; tracking configurado.",
                "note": ""
            },
            {
                "command": "git switch --detach <commit>",
                "level": "intermediate",
                "topic": "Ramas",
                "description": "Cambia a un commit en detached HEAD.",
                "example": "git switch --detach HEAD~3",
                "expected": "HEAD is now at ...",
                "note": "Los commits nuevos pueden quedar sin rama si no creás una."
            },
            {
                "command": "git branch -D <branch>",
                "level": "advanced",
                "description": "Fuerza borrado de rama local.",
                "example": "git branch -D feature/broken",
                "expected": "Deleted branch ...",
                "note": "Puede perder commits no referenciados.",
                "topic": "Ramas"
            },
            {
                "command": "git branch -dr origin/<branch>",
                "level": "advanced",
                "topic": "Ramas",
                "description": "Elimina localmente una rama de seguimiento remoto sin tocar el servidor.",
                "example": "git branch -dr origin/old-branch",
                "expected": "Deleted remote-tracking branch origin/old-branch.",
                "note": "Un fetch posterior puede recrearla si sigue existiendo remotamente."
            },
            {
                "command": "git branch -r --contains <commit>",
                "level": "advanced",
                "topic": "Ramas",
                "description": "Lista ramas remotas de seguimiento que contienen un commit.",
                "example": "git branch -r --contains abc1234",
                "expected": "origin/main, origin/release, etc.",
                "note": ""
            },
            {
                "command": "git checkout --orphan <branch>",
                "level": "advanced",
                "topic": "Ramas",
                "description": "Crea una rama huérfana sin historial padre.",
                "example": "git checkout --orphan gh-pages",
                "expected": "Switched to a new branch gh-pages.",
                "note": "El índice/working tree pueden conservar archivos; limpiá según necesidad."
            },
            {
                "command": "git add -A",
                "level": "basic",
                "topic": "Staging y archivos",
                "description": "Stagea cambios, archivos nuevos y eliminaciones en todo el repositorio.",
                "example": "git add -A",
                "expected": "Sin salida; git status muestra todos los cambios staged.",
                "note": ""
            },
            {
                "command": "git add .",
                "level": "basic",
                "description": "Agrega al staging todos los cambios del directorio actual y subdirectorios.",
                "example": "git add .",
                "expected": "Normalmente no imprime salida.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git add <file>",
                "level": "basic",
                "description": "Agrega un archivo al staging area.",
                "example": "git add src/app.js",
                "expected": "Sin salida si finaliza correctamente; git status mostrara el archivo staged.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git mv <old> <new>",
                "level": "basic",
                "topic": "Staging y archivos",
                "description": "Renombra/mueve un archivo y stagea el cambio.",
                "example": "git mv old.js new.js",
                "expected": "Sin salida; git status muestra renamed.",
                "note": ""
            },
            {
                "command": "git restore --staged <path>",
                "level": "basic",
                "description": "Quita un archivo del staging sin borrar su cambio.",
                "example": "git restore --staged src/app.ts",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git restore <path>",
                "level": "basic",
                "description": "Descarta cambios no staged de un archivo.",
                "example": "git restore src/app.ts",
                "expected": "Sin salida.",
                "note": "Destructivo para ese cambio local.",
                "topic": "Staging y archivos"
            },
            {
                "command": "git rm <file>",
                "level": "basic",
                "topic": "Staging y archivos",
                "description": "Elimina un archivo del working tree y lo stagea como borrado.",
                "example": "git rm old.txt",
                "expected": "rm old.txt",
                "note": ""
            },
            {
                "command": "git status",
                "level": "basic",
                "description": "Muestra archivos modificados, staged, sin seguimiento y la rama actual.",
                "example": "git status",
                "expected": "On branch main ... Changes not staged / staged / untracked files.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git status --short --branch",
                "level": "basic",
                "description": "Estado compacto incluyendo rama/upstream.",
                "example": "git status --short --branch",
                "expected": "Cabecera ## + códigos XY por archivo.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git add -p",
                "level": "intermediate",
                "description": "Permite elegir hunks específicos para staging.",
                "example": "git add -p",
                "expected": "Prompt y/n/s/e por hunk.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git add -u",
                "level": "intermediate",
                "topic": "Staging y archivos",
                "description": "Stagea modificaciones y eliminaciones de archivos ya trackeados, no archivos nuevos.",
                "example": "git add -u",
                "expected": "Sin salida; untracked files permanecen fuera del staging.",
                "note": ""
            },
            {
                "command": "git check-ignore -v <path>",
                "level": "intermediate",
                "topic": "Staging y archivos",
                "description": "Explica qué regla de ignore afecta a una ruta.",
                "example": "git check-ignore -v .env",
                "expected": "Archivo de reglas, línea y patrón que ignoró la ruta.",
                "note": ""
            },
            {
                "command": "git clean -i",
                "level": "intermediate",
                "topic": "Staging y archivos",
                "description": "Abre modo interactivo para elegir qué archivos limpiar.",
                "example": "git clean -i",
                "expected": "Menú interactivo con opciones clean/filter/select.",
                "note": ""
            },
            {
                "command": "git clean -n",
                "level": "intermediate",
                "description": "Simula borrado de untracked.",
                "example": "git clean -n",
                "expected": "Would remove ...",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git clean -nd",
                "level": "intermediate",
                "topic": "Staging y archivos",
                "description": "Simula qué archivos/directorios untracked serían eliminados.",
                "example": "git clean -nd",
                "expected": "Would remove ... por cada elemento.",
                "note": ""
            },
            {
                "command": "git ls-files",
                "level": "intermediate",
                "topic": "Staging y archivos",
                "description": "Lista archivos conocidos por el índice.",
                "example": "git ls-files",
                "expected": "Una ruta trackeada por línea.",
                "note": ""
            },
            {
                "command": "git restore --staged <file>",
                "level": "intermediate",
                "description": "Quita un archivo del staging sin perder sus cambios locales.",
                "example": "git restore --staged src/app.js",
                "expected": "Sin salida; git status lo mostrara como modificado no staged.",
                "note": "",
                "topic": "Staging y archivos"
            },
            {
                "command": "git restore <file>",
                "level": "intermediate",
                "description": "Descarta cambios no staged de un archivo.",
                "example": "git restore src/app.js",
                "expected": "Sin salida; el archivo vuelve a la version del indice.",
                "note": "Operacion destructiva para cambios locales no guardados.",
                "topic": "Staging y archivos"
            },
            {
                "command": "git rm --cached <file>",
                "level": "intermediate",
                "topic": "Staging y archivos",
                "description": "Deja de trackear un archivo pero lo conserva físicamente.",
                "example": "git rm --cached .env",
                "expected": "rm .env; el archivo sigue en disco.",
                "note": "Agregalo a .gitignore si no querés que vuelva a aparecer como untracked."
            },
            {
                "command": "git add -N <file>",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Marca un archivo nuevo como intent-to-add para poder incluirlo en diffs sin stagear su contenido.",
                "example": "git add -N src/new.js",
                "expected": "Sin salida; git diff puede mostrar el archivo como nuevo.",
                "note": ""
            },
            {
                "command": "git clean -fd",
                "level": "advanced",
                "description": "Elimina archivos y carpetas untracked.",
                "example": "git clean -fd",
                "expected": "Removing ...",
                "note": "Ejecutar primero git clean -n.",
                "topic": "Staging y archivos"
            },
            {
                "command": "git clean -fdx",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Elimina archivos/directorios untracked e ignorados.",
                "example": "git clean -fdx",
                "expected": "Removing ...",
                "note": "Destructivo y normalmente irrecuperable por Git. Ejecutá primero git clean -ndx."
            },
            {
                "command": "git clean -ndx",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Simula limpieza incluyendo archivos ignorados.",
                "example": "git clean -ndx",
                "expected": "Would remove ... incluyendo contenido ignorado.",
                "note": "Usalo antes de -fdx para evitar pérdidas."
            },
            {
                "command": "git ls-files --stage",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Lista entradas del índice con modo, object id y stage.",
                "example": "git ls-files --stage",
                "expected": "mode SHA stage path.",
                "note": ""
            },
            {
                "command": "git update-index --assume-unchanged <file>",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Marca un archivo trackeado para que Git evite revisarlo como optimización local.",
                "example": "git update-index --assume-unchanged config.local",
                "expected": "Sin salida.",
                "note": "No es un mecanismo de ignore confiable para compartir configuración."
            },
            {
                "command": "git update-index --no-assume-unchanged <file>",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Quita la marca assume-unchanged.",
                "example": "git update-index --no-assume-unchanged config.local",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "git update-index --no-skip-worktree <file>",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Quita la marca skip-worktree.",
                "example": "git update-index --no-skip-worktree config.local",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "git update-index --skip-worktree <file>",
                "level": "advanced",
                "topic": "Staging y archivos",
                "description": "Marca una ruta para que ciertos comandos traten cambios locales con preferencia de working tree.",
                "example": "git update-index --skip-worktree config.local",
                "expected": "Sin salida.",
                "note": "No reemplaza .gitignore y puede confundir si se usa sin comprender el índice."
            },
            {
                "command": "git commit",
                "level": "basic",
                "topic": "Commits",
                "description": "Abre el editor para escribir el mensaje y crea un commit con lo staged.",
                "example": "git commit",
                "expected": "Abre editor; luego muestra resumen del commit creado.",
                "note": ""
            },
            {
                "command": "git commit -m \"mensaje\"",
                "level": "basic",
                "description": "Crea un commit con los cambios staged.",
                "example": "git commit -m \"feat: add login\"",
                "expected": "[main abc1234] feat: add login\nN files changed, ...",
                "note": "",
                "topic": "Commits"
            },
            {
                "command": "git commit --allow-empty -m \"<message>\"",
                "level": "intermediate",
                "topic": "Commits",
                "description": "Crea un commit sin cambios de archivos.",
                "example": "git commit --allow-empty -m \"chore: trigger pipeline\"",
                "expected": "Commit nuevo con 0 archivos modificados.",
                "note": ""
            },
            {
                "command": "git commit --amend",
                "level": "intermediate",
                "topic": "Commits",
                "description": "Reemplaza el último commit permitiendo cambiar mensaje y/o contenido staged.",
                "example": "git commit --amend",
                "expected": "Abre editor y crea un nuevo commit que reemplaza al anterior.",
                "note": "Reescribe historial; cuidado si ya fue publicado."
            },
            {
                "command": "git commit --amend --no-edit",
                "level": "intermediate",
                "description": "Reemplaza último commit conservando mensaje.",
                "example": "git commit --amend --no-edit",
                "expected": "Nuevo hash del commit.",
                "note": "",
                "topic": "Commits"
            },
            {
                "command": "git commit -am \"<message>\"",
                "level": "intermediate",
                "topic": "Commits",
                "description": "Stagea modificaciones/eliminaciones de archivos trackeados y crea commit en un paso.",
                "example": "git commit -am \"fix: adjust validation\"",
                "expected": "Resumen del commit.",
                "note": "No incluye archivos nuevos untracked."
            },
            {
                "command": "git am --abort",
                "level": "advanced",
                "topic": "Commits",
                "description": "Cancela la operación git am y vuelve al estado anterior.",
                "example": "git am --abort",
                "expected": "Sin salida; restaura el estado previo a am.",
                "note": ""
            },
            {
                "command": "git am --continue",
                "level": "advanced",
                "topic": "Commits",
                "description": "Continúa git am después de resolver conflictos.",
                "example": "git am --continue",
                "expected": "Aplica el patch pendiente y continúa la serie.",
                "note": ""
            },
            {
                "command": "git am <patch-file>",
                "level": "advanced",
                "topic": "Commits",
                "description": "Aplica un patch de email preservando autoría y mensaje como commit.",
                "example": "git am 0001-feature.patch",
                "expected": "Applying: ... por patch.",
                "note": ""
            },
            {
                "command": "git cherry-pick --abort",
                "level": "advanced",
                "description": "Cancela cherry-pick en curso.",
                "example": "git cherry-pick --abort",
                "expected": "Estado previo restaurado.",
                "note": "",
                "topic": "Commits"
            },
            {
                "command": "git cherry-pick <commit>",
                "level": "advanced",
                "description": "Aplica un commit especifico sobre la rama actual.",
                "example": "git cherry-pick a1b2c3d",
                "expected": "[branch hash] message o conflicto a resolver.",
                "note": "",
                "topic": "Commits"
            },
            {
                "command": "git commit --date=\"<date>\" -m \"<message>\"",
                "level": "advanced",
                "topic": "Commits",
                "description": "Crea commit especificando fecha de autor.",
                "example": "git commit --date=\"2026-08-24 10:00\" -m \"docs: import history\"",
                "expected": "Commit creado con author date indicada.",
                "note": ""
            },
            {
                "command": "git commit --fixup=<commit>",
                "level": "advanced",
                "description": "Crea commit fixup preparado para autosquash.",
                "example": "git commit --fixup=abc1234",
                "expected": "Nuevo commit fixup! ...",
                "note": "",
                "topic": "Commits"
            },
            {
                "command": "git commit --no-verify -m \"<message>\"",
                "level": "advanced",
                "topic": "Commits",
                "description": "Crea commit omitiendo hooks pre-commit y commit-msg.",
                "example": "git commit --no-verify -m \"hotfix\"",
                "expected": "Commit creado sin ejecutar esos hooks.",
                "note": "Usalo con cautela; puede saltarse validaciones del proyecto."
            },
            {
                "command": "git commit -S -m \"<message>\"",
                "level": "advanced",
                "topic": "Commits",
                "description": "Crea un commit firmado criptográficamente.",
                "example": "git commit -S -m \"feat: signed release\"",
                "expected": "Commit creado con firma o error si la firma no está configurada.",
                "note": ""
            },
            {
                "command": "git commit-graph verify",
                "level": "advanced",
                "topic": "Commits",
                "description": "Verifica integridad del commit-graph.",
                "example": "git commit-graph verify",
                "expected": "Sin salida si es válido; errores si detecta corrupción.",
                "note": ""
            },
            {
                "command": "git commit-graph write --reachable",
                "level": "advanced",
                "topic": "Commits",
                "description": "Escribe/actualiza commit-graph para commits alcanzables y acelerar consultas.",
                "example": "git commit-graph write --reachable",
                "expected": "Sin salida o progreso según configuración.",
                "note": ""
            },
            {
                "command": "git commit-tree <tree> -p <parent> -m \"<message>\"",
                "level": "advanced",
                "topic": "Commits",
                "description": "Crea manualmente un commit object desde un tree y parent.",
                "example": "git commit-tree $(git write-tree) -p HEAD -m \"manual commit\"",
                "expected": "Object id del commit nuevo.",
                "note": "Comando plumbing; no mueve una rama por sí solo."
            },
            {
                "command": "git revert <commit>",
                "level": "advanced",
                "description": "Crea un nuevo commit que revierte los cambios de otro commit.",
                "example": "git revert a1b2c3d",
                "expected": "Abre editor o crea un commit Revert ...; conserva el historial.",
                "note": "",
                "topic": "Commits"
            },
            {
                "command": "git merge --continue",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Continúa un merge después de resolver conflictos.",
                "example": "git merge --continue",
                "expected": "Crea/continúa el merge si todos los conflictos están resueltos.",
                "note": ""
            },
            {
                "command": "git merge --ff-only <branch>",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Permite merge solo si puede hacerse fast-forward.",
                "example": "git merge --ff-only origin/main",
                "expected": "Fast-forward o error Not possible to fast-forward.",
                "note": ""
            },
            {
                "command": "git merge --no-commit <branch>",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Detiene antes de crear un commit de merge cuando se requiere merge real.",
                "example": "git merge --no-commit feature/login",
                "expected": "Merge preparado; podés inspeccionar antes de commit.",
                "note": ""
            },
            {
                "command": "git merge --no-ff <branch>",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Fuerza un commit de merge aunque sea posible fast-forward.",
                "example": "git merge --no-ff feature/login",
                "expected": "Merge made by ... con commit de merge.",
                "note": ""
            },
            {
                "command": "git merge --squash <branch>",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Aplica cambios de una rama al working tree/index sin crear commit ni conservar sus commits individuales.",
                "example": "git merge --squash feature/login",
                "expected": "Squash commit -- not updating HEAD; cambios quedan staged.",
                "note": ""
            },
            {
                "command": "git merge <branch>",
                "level": "intermediate",
                "description": "Fusiona una rama en la rama actual.",
                "example": "git merge feature/payments",
                "expected": "Merge made by ... o Fast-forward; puede pedir resolver conflictos.",
                "note": "",
                "topic": "Merge y rebase"
            },
            {
                "command": "git mergetool",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Abre la herramienta de resolución de conflictos configurada.",
                "example": "git mergetool",
                "expected": "Invoca el mergetool por cada archivo conflictivo.",
                "note": ""
            },
            {
                "command": "git rebase --abort",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Cancela el rebase y restaura la rama al estado previo.",
                "example": "git rebase --abort",
                "expected": "Sin salida; rama vuelve al punto anterior al rebase.",
                "note": ""
            },
            {
                "command": "git rebase --autostash <upstream>",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Guarda temporalmente cambios locales para ejecutar rebase y los reaplica después.",
                "example": "git rebase --autostash origin/main",
                "expected": "Created autostash... rebase... Applied autostash.",
                "note": ""
            },
            {
                "command": "git rebase --continue",
                "level": "intermediate",
                "topic": "Merge y rebase",
                "description": "Continúa un rebase después de resolver conflictos.",
                "example": "git rebase --continue",
                "expected": "Aplica el siguiente commit o finaliza el rebase.",
                "note": ""
            },
            {
                "command": "git merge --abort",
                "level": "advanced",
                "description": "Cancela un merge conflictivo.",
                "example": "git merge --abort",
                "expected": "Estado pre-merge restaurado.",
                "note": "",
                "topic": "Merge y rebase"
            },
            {
                "command": "git merge --quit",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Olvida el estado de merge en progreso sin intentar restaurar cambios del working tree.",
                "example": "git merge --quit",
                "expected": "Sin salida; sale del estado MERGING.",
                "note": "Difiere de --abort: no intenta volver al estado previo."
            },
            {
                "command": "git merge-base --is-ancestor <a> <b>",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Comprueba por exit code si a es ancestro de b.",
                "example": "git merge-base --is-ancestor origin/main HEAD",
                "expected": "Sin salida; exit 0 si es ancestro, 1 si no.",
                "note": ""
            },
            {
                "command": "git merge-base main feature",
                "level": "advanced",
                "description": "Obtiene ancestro comun entre ramas.",
                "example": "git merge-base main feature",
                "expected": "SHA del merge base.",
                "note": "",
                "topic": "Merge y rebase"
            },
            {
                "command": "git merge-tree <branch1> <branch2>",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Calcula un merge y su resultado sin tocar working tree/index en modos modernos.",
                "example": "git merge-tree main feature/login",
                "expected": "Representación del merge, conflictos y tree resultante según versión.",
                "note": ""
            },
            {
                "command": "git rebase --onto main <oldbase> <branch>",
                "level": "advanced",
                "description": "Trasplanta una serie de commits a otra base.",
                "example": "git rebase --onto main release feature",
                "expected": "Successfully rebased...",
                "note": "",
                "topic": "Merge y rebase"
            },
            {
                "command": "git rebase --quit",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Sale del rebase conservando HEAD/working tree actuales y sin restaurar el estado previo.",
                "example": "git rebase --quit",
                "expected": "Sale del modo rebase.",
                "note": ""
            },
            {
                "command": "git rebase --rebase-merges <upstream>",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Rebasea intentando preservar la estructura de merges.",
                "example": "git rebase --rebase-merges origin/main",
                "expected": "Reescribe commits recreando merges.",
                "note": "Reescribe historial; idealmente trabajá sobre ramas no compartidas."
            },
            {
                "command": "git rebase --root",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Hace rebase interactivo/no interactivo desde el primer commit alcanzable.",
                "example": "git rebase -i --root",
                "expected": "Abre todo el historial para edición.",
                "note": "Puede reescribir todos los commits del repositorio."
            },
            {
                "command": "git rebase --skip",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Omite el commit conflictivo actual durante un rebase.",
                "example": "git rebase --skip",
                "expected": "Continúa con el siguiente commit.",
                "note": "Puede descartar cambios del commit omitido."
            },
            {
                "command": "git rebase --update-refs <upstream>",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Actualiza automáticamente otras ramas locales que apuntan a commits reescritos.",
                "example": "git rebase --update-refs origin/main",
                "expected": "Rebase y actualización de refs locales relacionadas.",
                "note": ""
            },
            {
                "command": "git rebase -i --autosquash <base>",
                "level": "advanced",
                "description": "Reordena automáticamente fixup!/squash! antes del rebase interactivo.",
                "example": "git rebase -i --autosquash main",
                "expected": "Editor/rebase; commits fixup quedan agrupados.",
                "note": "",
                "topic": "Merge y rebase"
            },
            {
                "command": "git rebase -i HEAD~5",
                "level": "advanced",
                "description": "Edita/reordena/squash los ultimos commits.",
                "example": "git rebase -i HEAD~5",
                "expected": "Editor con pick/reword/edit/squash/drop.",
                "note": "",
                "topic": "Merge y rebase"
            },
            {
                "command": "git rebase <branch>",
                "level": "advanced",
                "description": "Reaplica los commits de la rama actual encima de otra base.",
                "example": "git rebase main",
                "expected": "Successfully rebased and updated refs/heads/... o conflicto a resolver.",
                "note": "No reescribas historial compartido sin coordinarlo.",
                "topic": "Merge y rebase"
            },
            {
                "command": "git rerere diff",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Muestra el diff de resoluciones de conflicto registradas.",
                "example": "git rerere diff",
                "expected": "Diff de la resolución registrada.",
                "note": ""
            },
            {
                "command": "git rerere forget <path>",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Hace que rerere olvide una resolución previamente registrada para una ruta.",
                "example": "git rerere forget src/app.js",
                "expected": "Updated preimage for ... o salida equivalente.",
                "note": ""
            },
            {
                "command": "git rerere status",
                "level": "advanced",
                "topic": "Merge y rebase",
                "description": "Muestra rutas cuyos conflictos está registrando rerere.",
                "example": "git rerere status",
                "expected": "Lista de archivos en los que rerere participa.",
                "note": ""
            },
            {
                "command": "git stash",
                "level": "basic",
                "topic": "Stash",
                "description": "Guarda cambios tracked del working tree en un stash y limpia el árbol.",
                "example": "git stash",
                "expected": "Saved working directory and index state ...",
                "note": ""
            },
            {
                "command": "git stash list",
                "level": "basic",
                "description": "Lista stashes guardados.",
                "example": "git stash list",
                "expected": "stash@{0}: On main: wip login ...",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash show --stat stash@{0}",
                "level": "basic",
                "topic": "Stash",
                "description": "Muestra un resumen de archivos/cambios de un stash.",
                "example": "git stash show --stat stash@{0}",
                "expected": "Estadísticas de archivos y líneas del stash.",
                "note": ""
            },
            {
                "command": "git stash apply stash@{1}",
                "level": "intermediate",
                "description": "Aplica stash sin eliminarlo.",
                "example": "git stash apply stash@{1}",
                "expected": "Cambios o conflictos.",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash branch <branch> stash@{0}",
                "level": "intermediate",
                "topic": "Stash",
                "description": "Crea una rama desde el commit base del stash y aplica el stash.",
                "example": "git stash branch recover-work stash@{0}",
                "expected": "Crea/cambia a recover-work y aplica el stash; lo elimina si aplica con éxito.",
                "note": ""
            },
            {
                "command": "git stash drop stash@{1}",
                "level": "intermediate",
                "description": "Elimina un stash concreto.",
                "example": "git stash drop stash@{1}",
                "expected": "Dropped stash@{1}.",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash pop",
                "level": "intermediate",
                "description": "Aplica el stash mas reciente y lo elimina si no hay conflictos.",
                "example": "git stash pop",
                "expected": "Cambios aplicados; puede mostrar conflictos.",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash push -m \"mensaje\"",
                "level": "intermediate",
                "description": "Guarda cambios sin commitear para limpiar temporalmente el working tree.",
                "example": "git stash push -m \"wip login\"",
                "expected": "Saved working directory and index state ...",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash push -p",
                "level": "intermediate",
                "topic": "Stash",
                "description": "Permite elegir hunks interactivamente para guardar en stash.",
                "example": "git stash push -p",
                "expected": "Preguntas y/n por hunk; luego crea el stash.",
                "note": ""
            },
            {
                "command": "git stash push -u -m \"<message>\"",
                "level": "intermediate",
                "description": "Guarda tracked y untracked en stash.",
                "example": "git stash push -u -m \"wip\"",
                "expected": "Saved working directory...",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash show -p stash@{0}",
                "level": "intermediate",
                "description": "Muestra diff del stash.",
                "example": "git stash show -p stash@{0}",
                "expected": "Parche almacenado.",
                "note": "",
                "topic": "Stash"
            },
            {
                "command": "git stash clear",
                "level": "advanced",
                "topic": "Stash",
                "description": "Elimina todos los stashes.",
                "example": "git stash clear",
                "expected": "Sin salida.",
                "note": "Destructivo: las referencias de stash se eliminan."
            },
            {
                "command": "git stash create",
                "level": "advanced",
                "topic": "Stash",
                "description": "Crea un commit de stash y devuelve su object id sin guardarlo en refs/stash.",
                "example": "git stash create",
                "expected": "SHA del commit stash o salida vacía si no hay cambios.",
                "note": ""
            },
            {
                "command": "git stash push --keep-index",
                "level": "advanced",
                "topic": "Stash",
                "description": "Guarda cambios pero mantiene intacto el contenido staged en el working tree/index.",
                "example": "git stash push --keep-index",
                "expected": "Crea stash y conserva cambios del índice.",
                "note": ""
            },
            {
                "command": "git stash push --staged",
                "level": "advanced",
                "topic": "Stash",
                "description": "Guarda únicamente cambios que ya están staged.",
                "example": "git stash push --staged -m \"staged only\"",
                "expected": "Crea un stash con el contenido staged.",
                "note": ""
            },
            {
                "command": "git stash store -m \"<message>\" <commit>",
                "level": "advanced",
                "topic": "Stash",
                "description": "Guarda bajo refs/stash un commit producido previamente por stash create.",
                "example": "git stash store -m \"manual stash\" abc1234",
                "expected": "Sin salida; aparece en git stash list.",
                "note": ""
            },
            {
                "command": "git tag",
                "level": "basic",
                "topic": "Tags y firmas",
                "description": "Lista tags locales.",
                "example": "git tag",
                "expected": "v1.0.0\nv1.1.0",
                "note": ""
            },
            {
                "command": "git tag -d <tag>",
                "level": "basic",
                "topic": "Tags y firmas",
                "description": "Elimina un tag local.",
                "example": "git tag -d v1.2.0",
                "expected": "Deleted tag v1.2.0 (was ...).",
                "note": ""
            },
            {
                "command": "git tag -l \"<pattern>\"",
                "level": "basic",
                "topic": "Tags y firmas",
                "description": "Lista tags que coinciden con un patrón.",
                "example": "git tag -l \"v2.*\"",
                "expected": "Tags v2.x coincidentes.",
                "note": ""
            },
            {
                "command": "git tag <tag>",
                "level": "basic",
                "topic": "Tags y firmas",
                "description": "Crea un lightweight tag apuntando a HEAD.",
                "example": "git tag v1.2.0",
                "expected": "Sin salida; el tag aparece en git tag.",
                "note": ""
            },
            {
                "command": "git tag -a <tag> -m \"<message>\"",
                "level": "intermediate",
                "description": "Crea tag anotado.",
                "example": "git tag -a v1.2.0 -m \"Release\"",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Tags y firmas"
            },
            {
                "command": "git tag -a <tag> -m \"mensaje\"",
                "level": "intermediate",
                "description": "Crea un tag anotado.",
                "example": "git tag -a v1.4.0 -m \"release 1.4.0\"",
                "expected": "Sin salida si se crea correctamente.",
                "note": "",
                "topic": "Tags y firmas"
            },
            {
                "command": "git tag -n",
                "level": "intermediate",
                "topic": "Tags y firmas",
                "description": "Lista tags junto con la primera línea de su mensaje/commit.",
                "example": "git tag -n",
                "expected": "tag + anotación/resumen por línea.",
                "note": ""
            },
            {
                "command": "git notes add -m \"<note>\" <commit>",
                "level": "advanced",
                "description": "Adjunta metadata adicional a un commit sin cambiarlo.",
                "example": "git notes add -m \"Revisado\" HEAD",
                "expected": "Sin salida; nota almacenada.",
                "note": "",
                "topic": "Tags y firmas"
            },
            {
                "command": "git notes remove <commit>",
                "level": "advanced",
                "topic": "Tags y firmas",
                "description": "Elimina la nota asociada a un commit.",
                "example": "git notes remove HEAD",
                "expected": "Removing note for object ...",
                "note": ""
            },
            {
                "command": "git notes show <commit>",
                "level": "advanced",
                "topic": "Tags y firmas",
                "description": "Muestra notas Git asociadas a un commit.",
                "example": "git notes show HEAD",
                "expected": "Texto de la nota o error si no existe.",
                "note": ""
            },
            {
                "command": "git tag -s <tag> -m \"<message>\"",
                "level": "advanced",
                "topic": "Tags y firmas",
                "description": "Crea un tag anotado firmado.",
                "example": "git tag -s v1.2.0 -m \"Release 1.2.0\"",
                "expected": "Sin salida si firma correctamente.",
                "note": ""
            },
            {
                "command": "git tag -v <tag>",
                "level": "advanced",
                "topic": "Tags y firmas",
                "description": "Verifica la firma de un tag firmado.",
                "example": "git tag -v v1.2.0",
                "expected": "Información GPG/SSH de firma y objeto del tag.",
                "note": ""
            },
            {
                "command": "git verify-commit <commit>",
                "level": "advanced",
                "topic": "Tags y firmas",
                "description": "Verifica la firma criptográfica de un commit.",
                "example": "git verify-commit HEAD",
                "expected": "Información de firma válida o error.",
                "note": ""
            },
            {
                "command": "git verify-tag <tag>",
                "level": "advanced",
                "topic": "Tags y firmas",
                "description": "Verifica la firma criptográfica de un tag.",
                "example": "git verify-tag v1.2.0",
                "expected": "Información de firma válida o error.",
                "note": ""
            },
            {
                "command": "git grep -i \"<pattern>\"",
                "level": "basic",
                "topic": "Historial y búsqueda",
                "description": "Busca texto ignorando mayúsculas/minúsculas.",
                "example": "git grep -i \"authorization\"",
                "expected": "Coincidencias en archivos trackeados.",
                "note": ""
            },
            {
                "command": "git grep -n \"<pattern>\"",
                "level": "basic",
                "topic": "Historial y búsqueda",
                "description": "Busca texto en archivos trackeados mostrando números de línea.",
                "example": "git grep -n \"TODO\"",
                "expected": "path:line:contenido por coincidencia.",
                "note": ""
            },
            {
                "command": "git log -- <path>",
                "level": "basic",
                "topic": "Historial y búsqueda",
                "description": "Muestra historial que afectó una ruta.",
                "example": "git log -- src/app.js",
                "expected": "Commits relacionados con src/app.js.",
                "note": ""
            },
            {
                "command": "git log --author=\"<pattern>\"",
                "level": "basic",
                "topic": "Historial y búsqueda",
                "description": "Filtra historial por autor.",
                "example": "git log --author=\"Gastón\" --oneline",
                "expected": "Commits cuyo autor coincide.",
                "note": ""
            },
            {
                "command": "git show --stat <commit>",
                "level": "basic",
                "topic": "Historial y búsqueda",
                "description": "Muestra metadata del commit y resumen de cambios por archivo.",
                "example": "git show --stat HEAD",
                "expected": "Commit, autor, mensaje y estadísticas.",
                "note": ""
            },
            {
                "command": "git blame -L <start>,<end> <path>",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Limita blame a un rango de líneas.",
                "example": "git blame -L 10,30 src/app.js",
                "expected": "Commit, autor y línea para cada línea del rango.",
                "note": ""
            },
            {
                "command": "git blame <path>",
                "level": "intermediate",
                "description": "Anota cada linea con commit y autor.",
                "example": "git blame src/app.ts",
                "expected": "Hash, autor, fecha y linea.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git describe --tags --always",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Describe HEAD usando el tag alcanzable más cercano o un SHA.",
                "example": "git describe --tags --always",
                "expected": "v1.2.0-3-gabc1234 o abc1234.",
                "note": ""
            },
            {
                "command": "git describe --tags --dirty",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Describe HEAD e indica si el working tree está sucio.",
                "example": "git describe --tags --dirty",
                "expected": "v1.2.0-3-gabc1234-dirty si hay cambios.",
                "note": ""
            },
            {
                "command": "git log --diff-filter=D --summary",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Encuentra eliminaciones de archivos en el historial.",
                "example": "git log --diff-filter=D --summary",
                "expected": "Commits y delete mode ... para archivos eliminados.",
                "note": ""
            },
            {
                "command": "git log --merges --oneline",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Muestra únicamente commits de merge.",
                "example": "git log --merges --oneline",
                "expected": "SHA corto y mensaje de cada merge commit.",
                "note": ""
            },
            {
                "command": "git log --no-merges --oneline",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Excluye commits de merge del historial.",
                "example": "git log --no-merges --oneline",
                "expected": "Commits normales únicamente.",
                "note": ""
            },
            {
                "command": "git log --oneline --graph --decorate --all",
                "level": "intermediate",
                "description": "Muestra el historial compacto con grafo de ramas y referencias.",
                "example": "git log --oneline --graph --decorate --all",
                "expected": "Una linea por commit con hash corto, ramas/tags y arbol ASCII.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git log --reverse --oneline",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Muestra commits del más antiguo al más reciente.",
                "example": "git log --reverse --oneline",
                "expected": "Historial en orden cronológico ascendente.",
                "note": ""
            },
            {
                "command": "git log --since=\"<date>\" --until=\"<date>\"",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Filtra commits por rango temporal.",
                "example": "git log --since=\"2026-08-01\" --until=\"2026-08-31\" --oneline",
                "expected": "Commits dentro del rango indicado.",
                "note": ""
            },
            {
                "command": "git log -p -n 3",
                "level": "intermediate",
                "description": "Muestra tres commits con sus parches.",
                "example": "git log -p -n 3",
                "expected": "Metadata y diff por commit.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git log @{u}..HEAD --oneline",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Lista commits locales que todavía no están en upstream.",
                "example": "git log @{u}..HEAD --oneline",
                "expected": "Commits que serían enviados al remoto.",
                "note": ""
            },
            {
                "command": "git log HEAD..@{u} --oneline",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Lista commits del upstream que todavía no están localmente.",
                "example": "git log HEAD..@{u} --oneline",
                "expected": "Commits remotos pendientes de integrar.",
                "note": ""
            },
            {
                "command": "git rev-list --count HEAD",
                "level": "intermediate",
                "description": "Cuenta commits alcanzables.",
                "example": "git rev-list --count HEAD",
                "expected": "Numero entero.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git rev-parse --show-toplevel",
                "level": "intermediate",
                "description": "Devuelve raiz del repo.",
                "example": "git rev-parse --show-toplevel",
                "expected": "Ruta absoluta.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git shortlog -sn --all",
                "level": "intermediate",
                "description": "Resume commits por autor.",
                "example": "git shortlog -sn --all",
                "expected": "Cantidad + autor.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git shortlog -sne --all",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Resume commits por autor incluyendo email y todas las refs.",
                "example": "git shortlog -sne --all",
                "expected": "Cantidad, nombre y email por autor.",
                "note": ""
            },
            {
                "command": "git show --name-only --format=oneline <commit>",
                "level": "intermediate",
                "topic": "Historial y búsqueda",
                "description": "Muestra commit y rutas modificadas sin patch completo.",
                "example": "git show --name-only --format=oneline HEAD",
                "expected": "SHA/mensaje seguido de nombres de archivos.",
                "note": ""
            },
            {
                "command": "git cherry -v @{u}",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Muestra commits de la rama actual que no tienen equivalente en upstream.",
                "example": "git cherry -v @{u}",
                "expected": "+/- SHA mensaje por commit.",
                "note": ""
            },
            {
                "command": "git cherry <upstream> <head>",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Compara commits entre dos ramas detectando equivalentes por patch-id.",
                "example": "git cherry origin/main HEAD",
                "expected": "+/- SHA por commit.",
                "note": ""
            },
            {
                "command": "git for-each-ref --format=\"%(objectname) %(refname)\"",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Lista refs con un formato personalizado.",
                "example": "git for-each-ref --format=\"%(objectname) %(refname)\"",
                "expected": "SHA y ref por línea.",
                "note": ""
            },
            {
                "command": "git for-each-ref --format=\"%(refname:short) -> %(upstream:short)\" refs/heads",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Lista cada rama local junto con su upstream configurado.",
                "example": "git for-each-ref --format=\"%(refname:short) -> %(upstream:short)\" refs/heads",
                "expected": "main -> origin/main, feature/x -> origin/feature/x, etc.",
                "note": ""
            },
            {
                "command": "git for-each-ref --sort=-committerdate --format=\"%(committerdate:short) %(refname:short)\" refs/heads",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Genera un listado personalizado de ramas ordenadas por actividad.",
                "example": "git for-each-ref --sort=-committerdate --format=\"%(committerdate:short) %(refname:short)\" refs/heads",
                "expected": "Fecha y rama por línea.",
                "note": ""
            },
            {
                "command": "git log --first-parent --oneline",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Sigue solo el primer padre, útil para leer historia de integración de una rama principal.",
                "example": "git log --first-parent --oneline main",
                "expected": "Historia lineal de merges/commits sobre el primer padre.",
                "note": ""
            },
            {
                "command": "git log --follow -- <path>",
                "level": "advanced",
                "description": "Sigue historial de un archivo a traves de renombres.",
                "example": "git log --follow -- src/app.ts",
                "expected": "Historial del archivo.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git log --pretty=format:\"%h %ad %an %s\" --date=short",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Personaliza el formato de salida del log.",
                "example": "git log --pretty=format:\"%h %ad %an %s\" --date=short",
                "expected": "Una línea formateada por commit.",
                "note": ""
            },
            {
                "command": "git log -G\"<regex>\" --oneline",
                "level": "advanced",
                "description": "Busca commits cuyo diff coincide con regex.",
                "example": "git log -G\"TODO|FIXME\" --oneline",
                "expected": "Commits coincidentes.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git log -S\"<text>\" --oneline",
                "level": "advanced",
                "description": "Busca commits que agregaron o quitaron un texto.",
                "example": "git log -S\"JWT_SECRET\" --oneline",
                "expected": "Commits relevantes.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git name-rev <commit>",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Busca un nombre simbólico comprensible para un commit.",
                "example": "git name-rev HEAD~5",
                "expected": "SHA tags/...~N o branch~N.",
                "note": ""
            },
            {
                "command": "git rev-list --objects --all",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Lista objetos alcanzables desde todas las refs junto con paths cuando aplica.",
                "example": "git rev-list --objects --all",
                "expected": "SHA y path por objeto.",
                "note": "Útil para análisis de repositorios grandes."
            },
            {
                "command": "git rev-parse --abbrev-ref --symbolic-full-name @{u}",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Muestra el upstream de la rama actual.",
                "example": "git rev-parse --abbrev-ref --symbolic-full-name @{u}",
                "expected": "origin/main o el upstream configurado.",
                "note": ""
            },
            {
                "command": "git show <commit>:<path>",
                "level": "advanced",
                "description": "Muestra un archivo tal como estaba en un commit.",
                "example": "git show HEAD~1:src/app.ts",
                "expected": "Contenido historico del archivo.",
                "note": "",
                "topic": "Historial y búsqueda"
            },
            {
                "command": "git show-ref",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Lista refs locales con sus object ids.",
                "example": "git show-ref",
                "expected": "SHA refs/heads/..., refs/tags/...",
                "note": ""
            },
            {
                "command": "git show-ref --verify refs/heads/<branch>",
                "level": "advanced",
                "topic": "Historial y búsqueda",
                "description": "Verifica que una ref local exacta exista.",
                "example": "git show-ref --verify refs/heads/main",
                "expected": "SHA + ref o exit code 1 si no existe.",
                "note": ""
            },
            {
                "command": "git apply --stat <patch>",
                "level": "basic",
                "topic": "Diff y patches",
                "description": "Muestra qué modificaría un patch sin aplicarlo.",
                "example": "git apply --stat fix.patch",
                "expected": "Resumen de archivos/líneas del patch.",
                "note": ""
            },
            {
                "command": "git diff",
                "level": "basic",
                "description": "Muestra diferencias no staged.",
                "example": "git diff",
                "expected": "Patch con lineas agregadas y eliminadas.",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git diff --cached",
                "level": "basic",
                "topic": "Diff y patches",
                "description": "Sinónimo habitual de git diff --staged.",
                "example": "git diff --cached",
                "expected": "Patch de cambios staged respecto a HEAD.",
                "note": ""
            },
            {
                "command": "git diff --name-status",
                "level": "basic",
                "topic": "Diff y patches",
                "description": "Lista rutas modificadas junto con estado A/M/D/R.",
                "example": "git diff --name-status main...HEAD",
                "expected": "M src/app.js, A src/new.js, etc.",
                "note": ""
            },
            {
                "command": "git diff --stat",
                "level": "basic",
                "description": "Resume cambios por archivo.",
                "example": "git diff --stat",
                "expected": "Archivo, inserciones y eliminaciones.",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git diff <branch1>..<branch2>",
                "level": "basic",
                "topic": "Diff y patches",
                "description": "Compara snapshots en los tips de dos ramas.",
                "example": "git diff main..feature/login",
                "expected": "Patch con diferencias entre ambos tips.",
                "note": ""
            },
            {
                "command": "git apply <patch>",
                "level": "intermediate",
                "topic": "Diff y patches",
                "description": "Aplica un patch al working tree sin crear commit.",
                "example": "git apply fix.patch",
                "expected": "Sin salida si aplica correctamente.",
                "note": ""
            },
            {
                "command": "git diff --check",
                "level": "intermediate",
                "topic": "Diff y patches",
                "description": "Detecta errores de whitespace en cambios.",
                "example": "git diff --check",
                "expected": "Sin salida si está limpio; líneas problemáticas si encuentra errores.",
                "note": ""
            },
            {
                "command": "git diff --name-only main..HEAD",
                "level": "intermediate",
                "description": "Lista archivos cambiados respecto de main.",
                "example": "git diff --name-only main..HEAD",
                "expected": "Una ruta por archivo.",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git diff --staged",
                "level": "intermediate",
                "description": "Muestra exactamente lo que entrara al proximo commit.",
                "example": "git diff --staged",
                "expected": "Patch de cambios staged.",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git diff --word-diff",
                "level": "intermediate",
                "topic": "Diff y patches",
                "description": "Muestra cambios a nivel de palabras.",
                "example": "git diff --word-diff",
                "expected": "Texto con palabras agregadas/eliminadas marcadas.",
                "note": ""
            },
            {
                "command": "git diff @{u}...HEAD",
                "level": "intermediate",
                "topic": "Diff y patches",
                "description": "Compara la rama actual contra su upstream desde el merge-base.",
                "example": "git diff @{u}...HEAD",
                "expected": "Patch con diferencias de tu rama respecto al upstream.",
                "note": ""
            },
            {
                "command": "git diff <branch1>...<branch2>",
                "level": "intermediate",
                "topic": "Diff y patches",
                "description": "Compara una rama con otra desde su merge-base.",
                "example": "git diff main...feature/login",
                "expected": "Patch de cambios introducidos por feature/login desde la divergencia.",
                "note": ""
            },
            {
                "command": "git difftool",
                "level": "intermediate",
                "topic": "Diff y patches",
                "description": "Abre una herramienta visual configurada para revisar diferencias.",
                "example": "git difftool main...HEAD",
                "expected": "Invoca el difftool por archivos con diferencias.",
                "note": ""
            },
            {
                "command": "git apply --check <patch>",
                "level": "advanced",
                "description": "Verifica si un patch puede aplicarse sin modificar nada.",
                "example": "git apply --check fix.patch",
                "expected": "Sin salida si aplica; errores si no.",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git apply --reverse <patch>",
                "level": "advanced",
                "topic": "Diff y patches",
                "description": "Aplica un patch en sentido inverso.",
                "example": "git apply --reverse fix.patch",
                "expected": "Sin salida si revierte correctamente los cambios del patch.",
                "note": ""
            },
            {
                "command": "git format-patch <base>..HEAD",
                "level": "advanced",
                "description": "Genera patches email-ready por commit.",
                "example": "git format-patch main..HEAD",
                "expected": "0001-*.patch, 0002-*.patch...",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git patch-id --stable",
                "level": "advanced",
                "topic": "Diff y patches",
                "description": "Calcula identificadores estables de patches desde stdin.",
                "example": "git show HEAD | git patch-id --stable",
                "expected": "patch-id y commit-id.",
                "note": ""
            },
            {
                "command": "git range-diff <old-range> <new-range>",
                "level": "advanced",
                "description": "Compara dos series de commits, útil tras rebase.",
                "example": "git range-diff main...feature@{1} main...feature",
                "expected": "Correspondencia/diff entre commits de ambas series.",
                "note": "",
                "topic": "Diff y patches"
            },
            {
                "command": "git submodule add <url> <path>",
                "level": "intermediate",
                "topic": "Submódulos",
                "description": "Agrega un repositorio como submódulo y actualiza .gitmodules.",
                "example": "git submodule add https://github.com/example/ui.git vendor/ui",
                "expected": "Cloning into ...; crea entrada en .gitmodules y path staged.",
                "note": ""
            },
            {
                "command": "git submodule init",
                "level": "intermediate",
                "topic": "Submódulos",
                "description": "Inicializa configuración local de submódulos ya declarados.",
                "example": "git submodule init",
                "expected": "Submodule ... registered for path ...",
                "note": ""
            },
            {
                "command": "git submodule status --recursive",
                "level": "intermediate",
                "topic": "Submódulos",
                "description": "Muestra commit/estado de submódulos recursivamente.",
                "example": "git submodule status --recursive",
                "expected": "SHA y path; prefijos indican estado.",
                "note": ""
            },
            {
                "command": "git submodule update",
                "level": "intermediate",
                "topic": "Submódulos",
                "description": "Checkout de cada submódulo al commit registrado por el superproyecto.",
                "example": "git submodule update",
                "expected": "Descarga/checkout cuando sea necesario.",
                "note": ""
            },
            {
                "command": "git submodule update --init --recursive",
                "level": "intermediate",
                "description": "Inicializa submodulos y anidados.",
                "example": "git submodule update --init --recursive",
                "expected": "Clones/checkouts de submodulos.",
                "note": "",
                "topic": "Submódulos"
            },
            {
                "command": "git submodule deinit -f <path>",
                "level": "advanced",
                "topic": "Submódulos",
                "description": "Desregistra localmente un submódulo y limpia su working tree.",
                "example": "git submodule deinit -f vendor/ui",
                "expected": "Cleared directory ... / Submodule ... unregistered.",
                "note": "No elimina por sí solo todas las referencias del repo; revisá .gitmodules e índice."
            },
            {
                "command": "git submodule foreach --recursive \"<command>\"",
                "level": "advanced",
                "topic": "Submódulos",
                "description": "Ejecuta un comando en cada submódulo recursivamente.",
                "example": "git submodule foreach --recursive \"git status --short\"",
                "expected": "Entering path... y salida del comando por submódulo.",
                "note": ""
            },
            {
                "command": "git submodule sync --recursive",
                "level": "advanced",
                "topic": "Submódulos",
                "description": "Sincroniza URLs de .gitmodules hacia configuración local, recursivamente.",
                "example": "git submodule sync --recursive",
                "expected": "Synchronizing submodule url for ...",
                "note": ""
            },
            {
                "command": "git submodule update --remote --merge",
                "level": "advanced",
                "topic": "Submódulos",
                "description": "Actualiza submódulos siguiendo su rama remota y mergea en la rama actual del submódulo.",
                "example": "git submodule update --remote --merge",
                "expected": "Fetch/merge dentro de los submódulos.",
                "note": ""
            },
            {
                "command": "git sparse-checkout add <path>",
                "level": "intermediate",
                "topic": "Worktrees y sparse",
                "description": "Agrega otra ruta al conjunto sparse.",
                "example": "git sparse-checkout add packages/api",
                "expected": "Actualiza working tree para incluir la nueva ruta.",
                "note": ""
            },
            {
                "command": "git sparse-checkout disable",
                "level": "intermediate",
                "topic": "Worktrees y sparse",
                "description": "Desactiva sparse-checkout y restaura working tree completo.",
                "example": "git sparse-checkout disable",
                "expected": "Materializa nuevamente todos los archivos trackeados.",
                "note": ""
            },
            {
                "command": "git sparse-checkout list",
                "level": "intermediate",
                "topic": "Worktrees y sparse",
                "description": "Lista directorios/patrones activos del sparse checkout.",
                "example": "git sparse-checkout list",
                "expected": "Rutas sparse configuradas.",
                "note": ""
            },
            {
                "command": "git worktree list",
                "level": "intermediate",
                "description": "Lista working trees del repo.",
                "example": "git worktree list",
                "expected": "Ruta, commit y rama.",
                "note": "",
                "topic": "Worktrees y sparse"
            },
            {
                "command": "git sparse-checkout init --cone",
                "level": "advanced",
                "description": "Activa sparse checkout optimizado por directorios.",
                "example": "git sparse-checkout init --cone",
                "expected": "Sin salida.",
                "note": "",
                "topic": "Worktrees y sparse"
            },
            {
                "command": "git sparse-checkout reapply",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Reaplica reglas sparse al working tree, útil después de operaciones que las alteran.",
                "example": "git sparse-checkout reapply",
                "expected": "Working tree vuelve a respetar los patrones sparse.",
                "note": ""
            },
            {
                "command": "git sparse-checkout set apps/web packages/ui",
                "level": "advanced",
                "description": "Materializa solo rutas elegidas.",
                "example": "git sparse-checkout set apps/web packages/ui",
                "expected": "Working tree reducido.",
                "note": "",
                "topic": "Worktrees y sparse"
            },
            {
                "command": "git worktree add -b <branch> <path> <start-point>",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Crea una nueva rama y working tree adicional desde un punto de inicio.",
                "example": "git worktree add -b hotfix ../app-hotfix origin/main",
                "expected": "Preparing worktree ... HEAD is now at ...",
                "note": ""
            },
            {
                "command": "git worktree add ../hotfix hotfix",
                "level": "advanced",
                "description": "Crea otro working tree para trabajar en paralelo.",
                "example": "git worktree add ../hotfix hotfix",
                "expected": "Preparing worktree ...",
                "note": "",
                "topic": "Worktrees y sparse"
            },
            {
                "command": "git worktree lock <path>",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Bloquea un worktree para impedir que prune lo elimine de metadatos.",
                "example": "git worktree lock ../app-usb",
                "expected": "Sin salida; worktree queda locked.",
                "note": ""
            },
            {
                "command": "git worktree move <old> <new>",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Mueve físicamente un worktree administrado.",
                "example": "git worktree move ../app-old ../app-new",
                "expected": "Sin salida; metadata queda actualizada.",
                "note": ""
            },
            {
                "command": "git worktree prune",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Elimina metadatos de worktrees que ya no existen.",
                "example": "git worktree prune",
                "expected": "Normalmente sin salida; limpia entradas obsoletas.",
                "note": ""
            },
            {
                "command": "git worktree remove <path>",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Elimina un working tree administrado por Git.",
                "example": "git worktree remove ../app-hotfix",
                "expected": "Sin salida; elimina el working tree si está limpio.",
                "note": "Usá --force solo si sabés que podés descartar cambios."
            },
            {
                "command": "git worktree repair",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Repara enlaces/metadatos de worktrees después de movimientos manuales.",
                "example": "git worktree repair",
                "expected": "Mensajes de reparación cuando detecta inconsistencias.",
                "note": ""
            },
            {
                "command": "git worktree unlock <path>",
                "level": "advanced",
                "topic": "Worktrees y sparse",
                "description": "Desbloquea un worktree previamente bloqueado.",
                "example": "git worktree unlock ../app-usb",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "git lfs install",
                "level": "intermediate",
                "description": "Inicializa Git LFS.",
                "example": "git lfs install",
                "expected": "Git LFS initialized.",
                "note": "",
                "topic": "Git LFS"
            },
            {
                "command": "git lfs ls-files",
                "level": "intermediate",
                "description": "Lista archivos gestionados por LFS.",
                "example": "git lfs ls-files",
                "expected": "OID y ruta.",
                "note": "",
                "topic": "Git LFS"
            },
            {
                "command": "git lfs track \"*.psd\"",
                "level": "intermediate",
                "description": "Configura un patron para LFS.",
                "example": "git lfs track \"*.psd\"",
                "expected": "Tracking \"*.psd\" y cambia .gitattributes.",
                "note": "",
                "topic": "Git LFS"
            },
            {
                "command": "git archive --format=tar.gz --prefix=<prefix>/ -o <file> <tree-ish>",
                "level": "advanced",
                "topic": "Archivos y releases",
                "description": "Genera un archivo tar.gz versionado con prefijo de directorio.",
                "example": "git archive --format=tar.gz --prefix=app-1.2.0/ -o app-1.2.0.tar.gz v1.2.0",
                "expected": "Crea app-1.2.0.tar.gz sin incluir .git.",
                "note": ""
            },
            {
                "command": "git archive --format=zip -o release.zip HEAD",
                "level": "advanced",
                "description": "Exporta HEAD a ZIP sin .git.",
                "example": "git archive --format=zip -o release.zip HEAD",
                "expected": "Crea release.zip.",
                "note": "",
                "topic": "Archivos y releases"
            },
            {
                "command": "git bisect good",
                "level": "intermediate",
                "topic": "Diagnóstico y búsqueda de bugs",
                "description": "Marca el commit actual como bueno durante bisect.",
                "example": "git bisect good",
                "expected": "Bisecting: N revisions left... o identifica el primer commit malo.",
                "note": ""
            },
            {
                "command": "git bisect bad",
                "level": "advanced",
                "description": "Marca revision actual como mala.",
                "example": "git bisect bad",
                "expected": "Git cambia a revision intermedia.",
                "note": "",
                "topic": "Diagnóstico y búsqueda de bugs"
            },
            {
                "command": "git bisect good <commit>",
                "level": "advanced",
                "description": "Marca revision conocida como buena.",
                "example": "git bisect good v1.0.0",
                "expected": "Git selecciona siguiente revision.",
                "note": "",
                "topic": "Diagnóstico y búsqueda de bugs"
            },
            {
                "command": "git bisect log",
                "level": "advanced",
                "topic": "Diagnóstico y búsqueda de bugs",
                "description": "Muestra las decisiones good/bad/skip de la sesión bisect actual.",
                "example": "git bisect log",
                "expected": "Script/comandos que reproducen las marcas realizadas.",
                "note": ""
            },
            {
                "command": "git bisect replay <file>",
                "level": "advanced",
                "topic": "Diagnóstico y búsqueda de bugs",
                "description": "Reproduce una sesión bisect a partir de un log guardado.",
                "example": "git bisect replay bisect.log",
                "expected": "Aplica marcas del archivo y posiciona bisect.",
                "note": ""
            },
            {
                "command": "git bisect reset",
                "level": "advanced",
                "description": "Finaliza bisect y vuelve al estado original.",
                "example": "git bisect reset",
                "expected": "Switched to branch ...",
                "note": "",
                "topic": "Diagnóstico y búsqueda de bugs"
            },
            {
                "command": "git bisect run npm test",
                "level": "advanced",
                "description": "Automatiza bisect usando exit code de tests.",
                "example": "git bisect run npm test",
                "expected": "Identifica first bad commit.",
                "note": "",
                "topic": "Diagnóstico y búsqueda de bugs"
            },
            {
                "command": "git bisect skip",
                "level": "advanced",
                "topic": "Diagnóstico y búsqueda de bugs",
                "description": "Indica que el commit actual no puede evaluarse y debe omitirse.",
                "example": "git bisect skip",
                "expected": "Git selecciona otro commit candidato o informa candidatos ambiguos.",
                "note": ""
            },
            {
                "command": "git bisect start",
                "level": "advanced",
                "description": "Inicia una busqueda binaria para encontrar el commit que introdujo un error.",
                "example": "git bisect start\ngit bisect bad\ngit bisect good v1.0.0",
                "expected": "Git selecciona commits intermedios hasta identificar el primer commit malo.",
                "note": "",
                "topic": "Diagnóstico y búsqueda de bugs"
            },
            {
                "command": "git gc",
                "level": "intermediate",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Ejecuta limpieza y optimización estándar del repositorio.",
                "example": "git gc",
                "expected": "Normalmente poca o ninguna salida.",
                "note": ""
            },
            {
                "command": "git bugreport",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Genera plantilla/reporte con información útil para reportar problemas de Git.",
                "example": "git bugreport",
                "expected": "Crea archivo de bug report y muestra su ubicación.",
                "note": ""
            },
            {
                "command": "git count-objects -vH",
                "level": "advanced",
                "description": "Muestra tamaño/cantidad de objetos y packs.",
                "example": "git count-objects -vH",
                "expected": "count, size, in-pack, packs, size-pack.",
                "note": "",
                "topic": "Mantenimiento y diagnóstico"
            },
            {
                "command": "git diagnose",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Recolecta información de diagnóstico del repositorio y sistema en un archivo zip.",
                "example": "git diagnose",
                "expected": "Genera un archivo git-diagnostics-....zip o equivalente.",
                "note": ""
            },
            {
                "command": "git fsck --full",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Verifica conectividad y validez de todos los objetos accesibles y extras.",
                "example": "git fsck --full",
                "expected": "Diagnóstico de objetos; sin errores si el repositorio está sano.",
                "note": ""
            },
            {
                "command": "git fsck --lost-found",
                "level": "advanced",
                "description": "Busca objetos/commits colgantes.",
                "example": "git fsck --lost-found",
                "expected": "dangling commit/blob/tree ...",
                "note": "",
                "topic": "Mantenimiento y diagnóstico"
            },
            {
                "command": "git fsck --unreachable",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Reporta objetos no alcanzables desde refs conocidas.",
                "example": "git fsck --unreachable",
                "expected": "unreachable commit/blob/tree ...",
                "note": ""
            },
            {
                "command": "git gc --aggressive",
                "level": "advanced",
                "description": "Compacta objetos buscando mayor compresion.",
                "example": "git gc --aggressive",
                "expected": "Progreso de compresion.",
                "note": "",
                "topic": "Mantenimiento y diagnóstico"
            },
            {
                "command": "git gc --prune=now",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Ejecuta garbage collection eliminando objetos no alcanzables elegibles inmediatamente.",
                "example": "git gc --prune=now",
                "expected": "Optimiza packs y poda objetos.",
                "note": "Puede eliminar objetos que de otro modo servirían para recuperación; no lo uses como rutina."
            },
            {
                "command": "git maintenance register",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Registra el repositorio en la configuración global de maintenance.",
                "example": "git maintenance register",
                "expected": "Sin salida; agrega maintenance.repo.",
                "note": ""
            },
            {
                "command": "git maintenance run",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Ejecuta tareas de mantenimiento configuradas para el repositorio.",
                "example": "git maintenance run",
                "expected": "Normalmente salida mínima; actualiza estructuras de optimización.",
                "note": ""
            },
            {
                "command": "git maintenance start",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Configura mantenimiento periódico en segundo plano para el repo.",
                "example": "git maintenance start",
                "expected": "Registra scheduling de maintenance según plataforma.",
                "note": ""
            },
            {
                "command": "git maintenance stop",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Detiene/desregistra mantenimiento periódico para el repo.",
                "example": "git maintenance stop",
                "expected": "Sin salida o confirmación mínima.",
                "note": ""
            },
            {
                "command": "git maintenance unregister",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Elimina el repositorio de la lista global de maintenance.",
                "example": "git maintenance unregister",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "git pack-refs --all --prune",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Empaqueta refs sueltas para optimizar repositorios con muchas referencias.",
                "example": "git pack-refs --all --prune",
                "expected": "Sin salida; actualiza packed-refs.",
                "note": ""
            },
            {
                "command": "git prune --dry-run",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Muestra objetos que prune eliminaría sin borrarlos.",
                "example": "git prune --dry-run",
                "expected": "Object ids candidatos a poda.",
                "note": ""
            },
            {
                "command": "git prune --expire now",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Elimina objetos no alcanzables con expiración inmediata.",
                "example": "git prune --expire now",
                "expected": "Normalmente salida mínima.",
                "note": "Muy destructivo para recuperación; preferí gc normal salvo mantenimiento controlado."
            },
            {
                "command": "git repack -Ad",
                "level": "advanced",
                "topic": "Mantenimiento y diagnóstico",
                "description": "Reempaqueta todos los objetos y elimina packs redundantes elegibles.",
                "example": "git repack -Ad",
                "expected": "Enumerating/Counting/Compressing objects...",
                "note": ""
            },
            {
                "command": "git bundle create repo.bundle --all",
                "level": "advanced",
                "description": "Empaqueta el repo en un archivo portable.",
                "example": "git bundle create repo.bundle --all",
                "expected": "Crea repo.bundle.",
                "note": "",
                "topic": "Bundles y migración"
            },
            {
                "command": "git bundle list-heads <bundle>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Lista refs incluidas en un bundle.",
                "example": "git bundle list-heads repo.bundle",
                "expected": "SHA y nombre de ref por línea.",
                "note": ""
            },
            {
                "command": "git bundle unbundle <bundle>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Importa objetos de un bundle y muestra refs disponibles.",
                "example": "git bundle unbundle repo.bundle",
                "expected": "SHA y refs contenidas/importadas.",
                "note": ""
            },
            {
                "command": "git bundle verify <bundle>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Verifica que un bundle sea válido y muestra prerequisitos/refs.",
                "example": "git bundle verify repo.bundle",
                "expected": "The bundle contains these refs... y verificación OK.",
                "note": ""
            },
            {
                "command": "git fast-export --all > <file>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Exporta historial/refs a un stream apto para migración o transformación.",
                "example": "git fast-export --all > repo.export",
                "expected": "Crea repo.export con stream de fast-export.",
                "note": ""
            },
            {
                "command": "git fast-import < <file>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Importa un stream generado por fast-export u otra herramienta compatible.",
                "example": "git fast-import < repo.export",
                "expected": "Estadísticas de importación y objetos/refs creados.",
                "note": "Usalo en un repositorio de destino controlado."
            },
            {
                "command": "git filter-branch -- --all",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Reescribe historial usando el mecanismo legacy filter-branch.",
                "example": "git filter-branch -- --all",
                "expected": "Reescritura de refs con warnings.",
                "note": "Git desaconseja filter-branch para muchos casos; preferí git filter-repo cuando esté disponible."
            },
            {
                "command": "git replace -d <object>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Elimina una replace ref.",
                "example": "git replace -d abc1234",
                "expected": "Deleted replace ref ...",
                "note": ""
            },
            {
                "command": "git replace -l",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Lista replace refs configuradas.",
                "example": "git replace -l",
                "expected": "Object ids reemplazados, uno por línea.",
                "note": ""
            },
            {
                "command": "git replace <object> <replacement>",
                "level": "advanced",
                "topic": "Bundles y migración",
                "description": "Crea una replace ref para que Git vea un objeto como reemplazado por otro sin reescribirlo.",
                "example": "git replace abc1234 def5678",
                "expected": "Sin salida; refs/replace/... queda creada.",
                "note": "Funcionalidad avanzada/local; no se transfiere como historial normal."
            },
            {
                "command": "git cat-file -p HEAD",
                "level": "advanced",
                "description": "Imprime contenido interno del objeto.",
                "example": "git cat-file -p HEAD",
                "expected": "tree, parent, author, committer, mensaje.",
                "note": "",
                "topic": "Internals / plumbing"
            },
            {
                "command": "git cat-file -s <object>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Muestra el tamaño en bytes de un objeto Git.",
                "example": "git cat-file -s HEAD^{tree}",
                "expected": "Tamaño numérico del objeto.",
                "note": ""
            },
            {
                "command": "git cat-file -t HEAD",
                "level": "advanced",
                "description": "Muestra tipo interno de objeto Git.",
                "example": "git cat-file -t HEAD",
                "expected": "commit.",
                "note": "",
                "topic": "Internals / plumbing"
            },
            {
                "command": "git check-ref-format --branch <branch>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Valida si un nombre es válido como rama.",
                "example": "git check-ref-format --branch feature/login",
                "expected": "Imprime el nombre si es válido; falla si no.",
                "note": ""
            },
            {
                "command": "git hash-object -w <file>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Calcula y escribe el blob en la object database.",
                "example": "git hash-object -w README.md",
                "expected": "Object id del blob almacenado.",
                "note": ""
            },
            {
                "command": "git hash-object <file>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Calcula el object id que tendría el contenido de un archivo sin almacenarlo.",
                "example": "git hash-object README.md",
                "expected": "SHA-1/SHA-256 del blob según object format.",
                "note": ""
            },
            {
                "command": "git hook run <hook-name>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Ejecuta manualmente un hook soportado por Git.",
                "example": "git hook run pre-commit",
                "expected": "Salida y exit code producidos por el hook.",
                "note": ""
            },
            {
                "command": "git interpret-trailers --in-place --trailer \"<key>: <value>\" <file>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Agrega/normaliza trailers estructurados en un mensaje.",
                "example": "git interpret-trailers --in-place --trailer \"Reviewed-by: Dev <dev@example.com>\" msg.txt",
                "expected": "Modifica msg.txt agregando el trailer.",
                "note": ""
            },
            {
                "command": "git multi-pack-index verify",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Verifica integridad del multi-pack-index.",
                "example": "git multi-pack-index verify",
                "expected": "Sin salida si es válido.",
                "note": ""
            },
            {
                "command": "git multi-pack-index write",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Escribe un multi-pack-index para optimizar búsqueda de objetos en múltiples packs.",
                "example": "git multi-pack-index write",
                "expected": "Sin salida; crea/actualiza multi-pack-index.",
                "note": ""
            },
            {
                "command": "git symbolic-ref HEAD refs/heads/<branch>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Cambia la referencia simbólica HEAD a una rama.",
                "example": "git symbolic-ref HEAD refs/heads/main",
                "expected": "Sin salida; HEAD pasa a apuntar simbólicamente a main.",
                "note": "Normalmente usá switch/checkout; esto es plumbing."
            },
            {
                "command": "git update-ref <ref> <new-object>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Actualiza una ref de forma segura a un nuevo object id.",
                "example": "git update-ref refs/heads/test abc1234",
                "expected": "Sin salida si actualiza correctamente.",
                "note": "Plumbing: una ref incorrecta puede reescribir historial."
            },
            {
                "command": "git verify-pack -v <idx>",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Inspecciona y verifica objetos de un pack index.",
                "example": "git verify-pack -v .git/objects/pack/pack-xxxx.idx",
                "expected": "Lista objetos, tamaños, offsets y resumen del pack.",
                "note": ""
            },
            {
                "command": "git write-tree",
                "level": "advanced",
                "topic": "Internals / plumbing",
                "description": "Crea un tree object a partir del estado actual del índice.",
                "example": "git write-tree",
                "expected": "Object id del tree creado.",
                "note": ""
            },
            {
                "command": "git ls-tree -r HEAD",
                "level": "advanced",
                "topic": "Otros",
                "description": "Lista recursivamente el tree de HEAD con modos y object ids.",
                "example": "git ls-tree -r HEAD",
                "expected": "mode type SHA<TAB>path por entrada.",
                "note": ""
            },
            {
                "command": "git reflog",
                "level": "advanced",
                "description": "Muestra movimientos recientes de HEAD; sirve para recuperar commits aparentemente perdidos.",
                "example": "git reflog",
                "expected": "HEAD@{0}: ...\nHEAD@{1}: ...",
                "note": "",
                "topic": "Otros"
            },
            {
                "command": "git reset --hard HEAD",
                "level": "advanced",
                "description": "Descarta cambios tracked y restaura exactamente HEAD.",
                "example": "git reset --hard HEAD",
                "expected": "HEAD is now at <hash> <message>",
                "note": "Destructivo: elimina cambios tracked no guardados.",
                "topic": "Otros"
            },
            {
                "command": "git reset --hard origin/main",
                "level": "advanced",
                "description": "Iguala HEAD e index al remoto descartando cambios.",
                "example": "git reset --hard origin/main",
                "expected": "HEAD is now at ...",
                "note": "Destructivo.",
                "topic": "Otros"
            },
            {
                "command": "git reset --soft HEAD~1",
                "level": "advanced",
                "description": "Deshace el ultimo commit conservando todos sus cambios staged.",
                "example": "git reset --soft HEAD~1",
                "expected": "Sin salida; HEAD retrocede un commit y cambios quedan staged.",
                "note": "",
                "topic": "Otros"
            }
        ]
    },
    {
        "id": "linux",
        "group": "terminals",
        "title": "Linux / Bash",
        "description": "Archivos, permisos, procesos, servicios, logs, red y administracion cotidiana.",
        "aliases": [
            "linux",
            "bash",
            "shell",
            "ubuntu",
            "debian"
        ],
        "commands": [
            {
                "command": "cd <path>",
                "level": "basic",
                "description": "Cambia el directorio actual.",
                "example": "cd /var/log",
                "expected": "Sin salida; pwd mostrara /var/log.",
                "note": ""
            },
            {
                "command": "cp -r <src> <dst>",
                "level": "basic",
                "description": "Copia directorios y contenido recursivamente.",
                "example": "cp -r ./config ./backup/config",
                "expected": "Sin salida normal; se crea la copia.",
                "note": ""
            },
            {
                "command": "crontab -l",
                "level": "basic",
                "description": "Lista cron jobs del usuario.",
                "example": "crontab -l",
                "expected": "Expresiones cron.",
                "note": ""
            },
            {
                "command": "df -h",
                "level": "basic",
                "description": "Muestra uso de espacio de sistemas de archivos.",
                "example": "df -h",
                "expected": "Filesystem Size Used Avail Use% Mounted on.",
                "note": ""
            },
            {
                "command": "du -sh <path>",
                "level": "basic",
                "description": "Calcula el tamano total de una ruta.",
                "example": "du -sh node_modules",
                "expected": "842M    node_modules",
                "note": ""
            },
            {
                "command": "env",
                "level": "basic",
                "description": "Lista variables de entorno.",
                "example": "env",
                "expected": "KEY=value.",
                "note": ""
            },
            {
                "command": "free -h",
                "level": "basic",
                "description": "Muestra RAM y swap.",
                "example": "free -h",
                "expected": "total, used, free, available.",
                "note": ""
            },
            {
                "command": "head -n 20 <file>",
                "level": "basic",
                "description": "Muestra las primeras N lineas de un archivo.",
                "example": "head -n 20 README.md",
                "expected": "Primeras 20 lineas.",
                "note": ""
            },
            {
                "command": "history | grep docker",
                "level": "basic",
                "description": "Busca en historial.",
                "example": "history | grep docker",
                "expected": "Comandos coincidentes.",
                "note": ""
            },
            {
                "command": "ip addr",
                "level": "basic",
                "description": "Muestra interfaces e IPs.",
                "example": "ip addr",
                "expected": "inet/inet6 por interfaz.",
                "note": ""
            },
            {
                "command": "ip route",
                "level": "basic",
                "description": "Muestra tabla de rutas.",
                "example": "ip route",
                "expected": "default via ...",
                "note": ""
            },
            {
                "command": "jobs -l",
                "level": "basic",
                "description": "Lista jobs del shell.",
                "example": "jobs -l",
                "expected": "Job, PID, estado, comando.",
                "note": ""
            },
            {
                "command": "ls -lah",
                "level": "basic",
                "description": "Lista archivos, incluidos ocultos, con permisos y tamanos legibles.",
                "example": "ls -lah",
                "expected": "Filas con permisos, usuario, grupo, tamano, fecha y nombre.",
                "note": ""
            },
            {
                "command": "man <command>",
                "level": "basic",
                "description": "Abre el manual de un comando.",
                "example": "man rsync",
                "expected": "Pagina de manual.",
                "note": ""
            },
            {
                "command": "mkdir -p <path>",
                "level": "basic",
                "description": "Crea directorios incluyendo padres inexistentes.",
                "example": "mkdir -p apps/api/logs",
                "expected": "Sin salida si termina correctamente.",
                "note": ""
            },
            {
                "command": "mv <src> <dst>",
                "level": "basic",
                "description": "Mueve o renombra archivos y directorios.",
                "example": "mv app.log app.old.log",
                "expected": "Sin salida si finaliza correctamente.",
                "note": ""
            },
            {
                "command": "ps aux",
                "level": "basic",
                "description": "Lista procesos con CPU, memoria y comando.",
                "example": "ps aux",
                "expected": "Tabla USER PID %CPU %MEM ... COMMAND.",
                "note": ""
            },
            {
                "command": "pwd",
                "level": "basic",
                "description": "Muestra la ruta absoluta del directorio actual.",
                "example": "pwd",
                "expected": "/home/user/project",
                "note": ""
            },
            {
                "command": "source ~/.bashrc",
                "level": "basic",
                "description": "Recarga configuracion del shell actual.",
                "example": "source ~/.bashrc",
                "expected": "Sin salida salvo scripts.",
                "note": ""
            },
            {
                "command": "tail -f <file>",
                "level": "basic",
                "description": "Sigue un archivo y muestra nuevas lineas en tiempo real.",
                "example": "tail -f /var/log/nginx/error.log",
                "expected": "Ultimas lineas y luego nuevas entradas hasta Ctrl+C.",
                "note": ""
            },
            {
                "command": "tail -f app.log",
                "level": "basic",
                "description": "Sigue un archivo en vivo.",
                "example": "tail -f app.log",
                "expected": "Nuevas lineas.",
                "note": ""
            },
            {
                "command": "top",
                "level": "basic",
                "description": "Monitor interactivo de procesos y recursos.",
                "example": "top",
                "expected": "Vista que se actualiza con carga, memoria y procesos; q para salir.",
                "note": ""
            },
            {
                "command": "awk -F, \"{print $1,$3}\" data.csv",
                "level": "intermediate",
                "description": "Extrae columnas con awk.",
                "example": "awk -F, \"{print $1,$3}\" data.csv",
                "expected": "Columnas seleccionadas.",
                "note": ""
            },
            {
                "command": "chmod +x <file>",
                "level": "intermediate",
                "description": "Agrega permiso de ejecucion.",
                "example": "chmod +x deploy.sh",
                "expected": "Sin salida; ls -l mostrara x en permisos.",
                "note": ""
            },
            {
                "command": "du -h --max-depth=1 . | sort -h",
                "level": "intermediate",
                "description": "Compara tamaños de carpetas.",
                "example": "du -h --max-depth=1 . | sort -h",
                "expected": "Tamaño por directorio.",
                "note": ""
            },
            {
                "command": "find . -type f -name \"*.log\"",
                "level": "intermediate",
                "description": "Busca archivos recursivamente.",
                "example": "find . -type f -name \"*.log\"",
                "expected": "Rutas coincidentes.",
                "note": ""
            },
            {
                "command": "find . -type f -size +100M",
                "level": "intermediate",
                "description": "Busca archivos grandes.",
                "example": "find . -type f -size +100M",
                "expected": "Rutas de archivos >100MB.",
                "note": ""
            },
            {
                "command": "find <path> -name \"pattern\"",
                "level": "intermediate",
                "description": "Busca archivos por nombre.",
                "example": "find . -name \"*.env\"",
                "expected": "Una ruta por coincidencia.",
                "note": ""
            },
            {
                "command": "grep -C 3 \"Exception\" app.log",
                "level": "intermediate",
                "description": "Muestra contexto alrededor de matches.",
                "example": "grep -C 3 \"Exception\" app.log",
                "expected": "Bloques de contexto.",
                "note": ""
            },
            {
                "command": "grep -RIn \"TODO\" src",
                "level": "intermediate",
                "description": "Busca texto recursivamente con numero de linea.",
                "example": "grep -RIn \"TODO\" src",
                "expected": "ruta:linea:contenido.",
                "note": ""
            },
            {
                "command": "grep -Rni \"text\" <path>",
                "level": "intermediate",
                "description": "Busca texto recursivamente mostrando linea y numero.",
                "example": "grep -Rni \"TODO\" src",
                "expected": "src/file.js:42: // TODO ...",
                "note": ""
            },
            {
                "command": "journalctl -u nginx -f",
                "level": "intermediate",
                "description": "Sigue logs de un servicio systemd.",
                "example": "journalctl -u nginx -f",
                "expected": "Logs en vivo.",
                "note": ""
            },
            {
                "command": "kill <pid>",
                "level": "intermediate",
                "description": "Envia SIGTERM a un proceso para pedir cierre ordenado.",
                "example": "kill 14220",
                "expected": "Sin salida si la senal fue enviada.",
                "note": ""
            },
            {
                "command": "less +F app.log",
                "level": "intermediate",
                "description": "Sigue log dentro de less.",
                "example": "less +F app.log",
                "expected": "Visor interactivo.",
                "note": ""
            },
            {
                "command": "lsof -i :3000",
                "level": "intermediate",
                "description": "Muestra proceso usando un puerto.",
                "example": "lsof -i :3000",
                "expected": "COMMAND PID USER ... NAME.",
                "note": ""
            },
            {
                "command": "nohup node server.js >app.log 2>&1 &",
                "level": "intermediate",
                "description": "Ejecuta proceso desacoplado del terminal.",
                "example": "nohup node server.js >app.log 2>&1 &",
                "expected": "Job/PID en background.",
                "note": ""
            },
            {
                "command": "pgrep -af node",
                "level": "intermediate",
                "description": "Busca procesos por patron.",
                "example": "pgrep -af node",
                "expected": "PID y comando.",
                "note": ""
            },
            {
                "command": "ps -ef --forest",
                "level": "intermediate",
                "description": "Muestra arbol de procesos.",
                "example": "ps -ef --forest",
                "expected": "Procesos padre/hijo.",
                "note": ""
            },
            {
                "command": "sed -n \"20,40p\" app.log",
                "level": "intermediate",
                "description": "Muestra un rango de lineas.",
                "example": "sed -n \"20,40p\" app.log",
                "expected": "Lineas 20 a 40.",
                "note": ""
            },
            {
                "command": "sort values.txt | uniq -c | sort -nr",
                "level": "intermediate",
                "description": "Cuenta valores unicos por frecuencia.",
                "example": "sort values.txt | uniq -c | sort -nr",
                "expected": "conteo valor.",
                "note": ""
            },
            {
                "command": "ss -lntp",
                "level": "intermediate",
                "description": "Lista TCP listeners con procesos.",
                "example": "ss -lntp",
                "expected": "State, Local Address, Process.",
                "note": ""
            },
            {
                "command": "systemctl enable --now docker",
                "level": "intermediate",
                "description": "Habilita e inicia un servicio.",
                "example": "sudo systemctl enable --now docker",
                "expected": "Symlink y servicio activo.",
                "note": ""
            },
            {
                "command": "systemctl restart <service>",
                "level": "intermediate",
                "description": "Reinicia un servicio systemd.",
                "example": "sudo systemctl restart nginx",
                "expected": "Normalmente sin salida; status confirma el resultado.",
                "note": ""
            },
            {
                "command": "systemctl status <service>",
                "level": "intermediate",
                "description": "Muestra estado y logs recientes de un servicio systemd.",
                "example": "sudo systemctl status nginx",
                "expected": "active (running), inactive, failed y ultimos mensajes.",
                "note": ""
            },
            {
                "command": "tar -czf <file.tar.gz> <path>",
                "level": "intermediate",
                "description": "Comprime una ruta como tar.gz.",
                "example": "tar -czf backup.tar.gz ./uploads",
                "expected": "Sin salida; se crea backup.tar.gz.",
                "note": ""
            },
            {
                "command": "tar -xzf <file.tar.gz>",
                "level": "intermediate",
                "description": "Extrae un tar.gz.",
                "example": "tar -xzf backup.tar.gz",
                "expected": "Sin salida; aparecen los archivos extraidos.",
                "note": ""
            },
            {
                "command": "type -a <command>",
                "level": "intermediate",
                "description": "Indica alias/builtin/funcion/ejecutable.",
                "example": "type -a python",
                "expected": "Definiciones y rutas.",
                "note": ""
            },
            {
                "command": "watch -n 2 \"df -h\"",
                "level": "intermediate",
                "description": "Reejecuta un comando periodicamente.",
                "example": "watch -n 2 \"df -h\"",
                "expected": "Pantalla refrescada.",
                "note": ""
            },
            {
                "command": "chmod 640 <file>",
                "level": "advanced",
                "description": "Define permisos numericos: owner rw, group r, others ninguno.",
                "example": "chmod 640 .env",
                "expected": "Sin salida; ls -l mostrara -rw-r-----.",
                "note": ""
            },
            {
                "command": "chown -R <user>:<group> <path>",
                "level": "advanced",
                "description": "Cambia propietario y grupo recursivamente.",
                "example": "sudo chown -R app:app /srv/app",
                "expected": "Sin salida si finaliza correctamente.",
                "note": ""
            },
            {
                "command": "disown -h %1",
                "level": "advanced",
                "description": "Evita SIGHUP al cerrar shell.",
                "example": "disown -h %1",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "journalctl -u <service> -f",
                "level": "advanced",
                "description": "Sigue logs de una unidad systemd en tiempo real.",
                "example": "sudo journalctl -u nginx -f",
                "expected": "Entradas del journal hasta Ctrl+C.",
                "note": ""
            },
            {
                "command": "kill -9 <pid>",
                "level": "advanced",
                "description": "Fuerza la terminacion inmediata con SIGKILL.",
                "example": "kill -9 14220",
                "expected": "Sin salida si el proceso se termina.",
                "note": "Usalo como ultimo recurso: no permite limpieza del proceso."
            },
            {
                "command": "ln -s <target> <link>",
                "level": "advanced",
                "description": "Crea un enlace simbolico.",
                "example": "ln -s /srv/app/current ./app-current",
                "expected": "Sin salida; ls -l muestra el destino del enlace.",
                "note": ""
            },
            {
                "command": "pkill -f \"node server.js\"",
                "level": "advanced",
                "description": "Finaliza procesos por patron.",
                "example": "pkill -f \"node server.js\"",
                "expected": "Sin salida.",
                "note": "Puede afectar varios procesos."
            },
            {
                "command": "rm -rf <path>",
                "level": "advanced",
                "description": "Elimina recursivamente sin confirmacion.",
                "example": "rm -rf ./dist",
                "expected": "Sin salida; el destino desaparece.",
                "note": "Muy destructivo. Revisa la ruta antes de ejecutar."
            },
            {
                "command": "xargs -P 8 -I{} curl -s -o /dev/null {}",
                "level": "advanced",
                "description": "Ejecuta trabajos paralelos desde stdin.",
                "example": "cat urls.txt | xargs -P 8 -I{} curl -s -o /dev/null {}",
                "expected": "Ejecuciones paralelas.",
                "note": ""
            }
        ]
    },
    {
        "id": "cmd",
        "group": "terminals",
        "title": "Windows CMD",
        "description": "Simbolo del sistema: archivos, procesos, servicios, red y variables.",
        "aliases": [
            "cmd",
            "command prompt",
            "windows terminal",
            "simbolo del sistema"
        ],
        "commands": [
            {
                "command": "cd",
                "level": "basic",
                "description": "Muestra el directorio actual.",
                "example": "cd",
                "expected": "C:\\Users\\User",
                "note": ""
            },
            {
                "command": "cd /d <path>",
                "level": "basic",
                "description": "Cambia de carpeta y tambien de unidad.",
                "example": "cd /d D:\\Projects\\Notebook",
                "expected": "El prompt cambia a D:\\Projects\\Notebook>.",
                "note": ""
            },
            {
                "command": "copy <src> <dst>",
                "level": "basic",
                "description": "Copia uno o mas archivos.",
                "example": "copy .env .env.backup",
                "expected": "1 file(s) copied.",
                "note": ""
            },
            {
                "command": "del /Q <file>",
                "level": "basic",
                "description": "Elimina archivos sin pedir confirmacion.",
                "example": "del /Q temp.log",
                "expected": "Sin salida si se elimina.",
                "note": ""
            },
            {
                "command": "dir /a",
                "level": "basic",
                "description": "Lista archivos incluidos ocultos y de sistema.",
                "example": "dir /a",
                "expected": "Listado con fechas, tamanos y nombres.",
                "note": ""
            },
            {
                "command": "ipconfig /all",
                "level": "basic",
                "description": "Muestra configuracion completa de adaptadores de red.",
                "example": "ipconfig /all",
                "expected": "IPv4, gateway, DNS, DHCP y MAC por adaptador.",
                "note": ""
            },
            {
                "command": "mkdir <folder>",
                "level": "basic",
                "description": "Crea una carpeta.",
                "example": "mkdir logs",
                "expected": "Sin salida; se crea logs.",
                "note": ""
            },
            {
                "command": "set",
                "level": "basic",
                "description": "Lista variables de entorno de la sesion CMD.",
                "example": "set",
                "expected": "NAME=value, una por linea.",
                "note": ""
            },
            {
                "command": "set NAME=value",
                "level": "basic",
                "description": "Define una variable solo para la sesion actual.",
                "example": "set NODE_ENV=development",
                "expected": "Sin salida; echo %NODE_ENV% muestra development.",
                "note": ""
            },
            {
                "command": "tasklist",
                "level": "basic",
                "description": "Lista procesos en ejecucion.",
                "example": "tasklist",
                "expected": "Image Name PID Session Name ...",
                "note": ""
            },
            {
                "command": "type <file>",
                "level": "basic",
                "description": "Imprime el contenido de un archivo de texto.",
                "example": "type package.json",
                "expected": "Contenido completo en consola.",
                "note": ""
            },
            {
                "command": "where <command>",
                "level": "basic",
                "description": "Muestra la ruta del ejecutable que resolvera Windows.",
                "example": "where node",
                "expected": "C:\\Program Files\\nodejs\\node.exe",
                "note": ""
            },
            {
                "command": "findstr /S /N /I \"text\" *.*",
                "level": "intermediate",
                "description": "Busca texto recursivamente mostrando numero de linea.",
                "example": "findstr /S /N /I \"TODO\" *.js",
                "expected": "ruta\\archivo.js:42:TODO ...",
                "note": ""
            },
            {
                "command": "netstat -ano",
                "level": "intermediate",
                "description": "Lista conexiones y puertos con PID.",
                "example": "netstat -ano",
                "expected": "Proto Local Address Foreign Address State PID.",
                "note": ""
            },
            {
                "command": "sc query <service>",
                "level": "intermediate",
                "description": "Consulta estado de un servicio de Windows.",
                "example": "sc query PostgreSQL",
                "expected": "STATE : 4 RUNNING u otro estado.",
                "note": ""
            },
            {
                "command": "systeminfo",
                "level": "intermediate",
                "description": "Muestra version de Windows, hardware, RAM y parches.",
                "example": "systeminfo",
                "expected": "Resumen detallado del sistema.",
                "note": ""
            },
            {
                "command": "taskkill /PID <pid> /F",
                "level": "intermediate",
                "description": "Fuerza el cierre de un proceso por PID.",
                "example": "taskkill /PID 1234 /F",
                "expected": "SUCCESS: The process with PID 1234 has been terminated.",
                "note": ""
            },
            {
                "command": "xcopy <src> <dst> /E /I /H",
                "level": "intermediate",
                "description": "Copia arboles de directorios incluyendo vacios y ocultos.",
                "example": "xcopy config backup\\config /E /I /H",
                "expected": "Lista archivos copiados y total.",
                "note": ""
            },
            {
                "command": "rmdir /S /Q <folder>",
                "level": "advanced",
                "description": "Elimina una carpeta completa sin confirmacion.",
                "example": "rmdir /S /Q dist",
                "expected": "Sin salida; la carpeta desaparece.",
                "note": ""
            },
            {
                "command": "robocopy <src> <dst> /MIR",
                "level": "advanced",
                "description": "Replica una carpeta haciendo mirror.",
                "example": "robocopy C:\\Data D:\\Backup\\Data /MIR",
                "expected": "Resumen de dirs/files copied/skipped/failed.",
                "note": "/MIR puede eliminar en destino lo que ya no existe en origen."
            }
        ]
    },
    {
        "id": "powershell",
        "group": "terminals",
        "title": "Windows PowerShell",
        "description": "Cmdlets para archivos, procesos, servicios, red, objetos y automatizacion en Windows.",
        "aliases": [
            "powershell",
            "pwsh",
            "windows powershell"
        ],
        "commands": [
            {
                "command": "$env:NAME=\"value\"",
                "level": "basic",
                "description": "Define una variable de entorno para la sesion actual.",
                "example": "$env:NODE_ENV=\"development\"",
                "expected": "Sin salida; $env:NODE_ENV devuelve development.",
                "note": ""
            },
            {
                "command": "Compress-Archive -Path dist\\* -DestinationPath dist.zip",
                "level": "basic",
                "description": "Crea ZIP.",
                "example": "Compress-Archive -Path dist\\* -DestinationPath dist.zip",
                "expected": "Archivo ZIP.",
                "note": ""
            },
            {
                "command": "Copy-Item <src> <dst> -Recurse",
                "level": "basic",
                "description": "Copia archivos o carpetas recursivamente.",
                "example": "Copy-Item .\\config .\\backup\\config -Recurse",
                "expected": "Sin salida normal.",
                "note": ""
            },
            {
                "command": "Expand-Archive dist.zip -DestinationPath dist",
                "level": "basic",
                "description": "Extrae ZIP.",
                "example": "Expand-Archive dist.zip -DestinationPath dist",
                "expected": "Archivos extraidos.",
                "note": ""
            },
            {
                "command": "Get-ChildItem -Force",
                "level": "basic",
                "description": "Lista contenido incluyendo archivos ocultos.",
                "example": "Get-ChildItem -Force",
                "expected": "Mode LastWriteTime Length Name.",
                "note": ""
            },
            {
                "command": "Get-ChildItem Env:",
                "level": "basic",
                "description": "Lista variables de entorno como objetos.",
                "example": "Get-ChildItem Env:",
                "expected": "Name Value.",
                "note": ""
            },
            {
                "command": "Get-Command *service*",
                "level": "basic",
                "description": "Busca comandos por patron.",
                "example": "Get-Command *service*",
                "expected": "CommandType, Name, Version, Source.",
                "note": ""
            },
            {
                "command": "Get-Command <name>",
                "level": "basic",
                "description": "Explica que ejecutable, alias, funcion o cmdlet resolvera PowerShell.",
                "example": "Get-Command node",
                "expected": "CommandType Name Version Source.",
                "note": ""
            },
            {
                "command": "Get-FileHash app.zip -Algorithm SHA256",
                "level": "basic",
                "description": "Calcula hash SHA256.",
                "example": "Get-FileHash app.zip -Algorithm SHA256",
                "expected": "Algorithm, Hash, Path.",
                "note": ""
            },
            {
                "command": "Get-Help <cmdlet> -Examples",
                "level": "basic",
                "description": "Muestra ejemplos oficiales instalados de un cmdlet.",
                "example": "Get-Help Get-ChildItem -Examples",
                "expected": "Ejemplos de uso y sintaxis.",
                "note": ""
            },
            {
                "command": "Get-Help <command> -Full",
                "level": "basic",
                "description": "Muestra ayuda completa de un cmdlet.",
                "example": "Get-Help Get-Process -Full",
                "expected": "Sintaxis, parametros y ejemplos.",
                "note": ""
            },
            {
                "command": "Get-Location",
                "level": "basic",
                "description": "Muestra la ubicacion actual.",
                "example": "Get-Location",
                "expected": "Path\n----\nC:\\Projects",
                "note": ""
            },
            {
                "command": "Get-Process",
                "level": "basic",
                "description": "Lista procesos como objetos PowerShell.",
                "example": "Get-Process",
                "expected": "Handles NPM(K) PM(K) WS(K) CPU(s) Id ProcessName.",
                "note": ""
            },
            {
                "command": "Get-Process -Id <pid>",
                "level": "basic",
                "description": "Consulta un proceso especifico.",
                "example": "Get-Process -Id 1234",
                "expected": "Fila con datos del proceso o error si no existe.",
                "note": ""
            },
            {
                "command": "Get-Process | Sort-Object CPU -Descending",
                "level": "basic",
                "description": "Ordena objetos por propiedad.",
                "example": "Get-Process | Sort-Object CPU -Descending",
                "expected": "Procesos ordenados.",
                "note": ""
            },
            {
                "command": "Get-Process | Where-Object { $_.CPU -gt 100 }",
                "level": "basic",
                "description": "Filtra objetos del pipeline.",
                "example": "Get-Process | Where-Object { $_.CPU -gt 100 }",
                "expected": "Procesos coincidentes.",
                "note": ""
            },
            {
                "command": "Get-Service",
                "level": "basic",
                "description": "Lista servicios y estado.",
                "example": "Get-Service",
                "expected": "Status Name DisplayName.",
                "note": ""
            },
            {
                "command": "Get-Service <name>",
                "level": "basic",
                "description": "Consulta un servicio.",
                "example": "Get-Service w32time",
                "expected": "Status, Name, DisplayName.",
                "note": ""
            },
            {
                "command": "Import-Csv data.csv",
                "level": "basic",
                "description": "Carga CSV como objetos.",
                "example": "Import-Csv data.csv",
                "expected": "Objetos por fila.",
                "note": ""
            },
            {
                "command": "Invoke-RestMethod https://api.example.com/health",
                "level": "basic",
                "description": "Llama REST y parsea JSON/XML.",
                "example": "Invoke-RestMethod https://api.example.com/health",
                "expected": "Objeto con respuesta.",
                "note": ""
            },
            {
                "command": "Move-Item <src> <dst>",
                "level": "basic",
                "description": "Mueve o renombra.",
                "example": "Move-Item .\\old.log .\\archive\\app.log",
                "expected": "Sin salida normal.",
                "note": ""
            },
            {
                "command": "New-Item -ItemType Directory -Path <path> -Force",
                "level": "basic",
                "description": "Crea un directorio y no falla si ya existe.",
                "example": "New-Item -ItemType Directory -Path .\\logs -Force",
                "expected": "DirectoryInfo con ruta creada/existente.",
                "note": ""
            },
            {
                "command": "Resolve-DnsName example.com",
                "level": "basic",
                "description": "Resuelve DNS.",
                "example": "Resolve-DnsName example.com",
                "expected": "Registros e IPs.",
                "note": ""
            },
            {
                "command": "Set-Location <path>",
                "level": "basic",
                "description": "Cambia el directorio actual.",
                "example": "Set-Location C:\\Projects\\Notebook",
                "expected": "Sin salida; Get-Location confirma el cambio.",
                "note": ""
            },
            {
                "command": "Test-NetConnection <host> -Port <port>",
                "level": "basic",
                "description": "Prueba DNS y conectividad TCP a un host/puerto.",
                "example": "Test-NetConnection localhost -Port 5432",
                "expected": "TcpTestSucceeded : True/False.",
                "note": ""
            },
            {
                "command": "Test-NetConnection localhost -Port 5432",
                "level": "basic",
                "description": "Prueba conectividad TCP.",
                "example": "Test-NetConnection localhost -Port 5432",
                "expected": "TcpTestSucceeded True/False.",
                "note": ""
            },
            {
                "command": "$data | ConvertTo-Json -Depth 10",
                "level": "intermediate",
                "description": "Serializa objetos a JSON.",
                "example": "$data | ConvertTo-Json -Depth 10",
                "expected": "JSON formateado.",
                "note": ""
            },
            {
                "command": "ConvertTo-Json / ConvertFrom-Json",
                "level": "intermediate",
                "description": "Convierte objetos PowerShell a JSON y viceversa.",
                "example": "$obj | ConvertTo-Json -Depth 5",
                "expected": "JSON con las propiedades del objeto.",
                "note": ""
            },
            {
                "command": "Get-ChildItem -Recurse -Filter \"*.log\"",
                "level": "intermediate",
                "description": "Busca archivos recursivamente.",
                "example": "Get-ChildItem . -Recurse -Filter \"*.log\"",
                "expected": "Objetos FileInfo.",
                "note": ""
            },
            {
                "command": "Get-CimInstance Win32_LogicalDisk",
                "level": "intermediate",
                "description": "Muestra discos y espacio.",
                "example": "Get-CimInstance Win32_LogicalDisk",
                "expected": "DeviceID, Size, FreeSpace.",
                "note": ""
            },
            {
                "command": "Get-CimInstance Win32_OperatingSystem",
                "level": "intermediate",
                "description": "Muestra informacion del sistema operativo.",
                "example": "Get-CimInstance Win32_OperatingSystem",
                "expected": "Version, build, memoria, boot time.",
                "note": ""
            },
            {
                "command": "Get-Content <file> -Tail 50 -Wait",
                "level": "intermediate",
                "description": "Sigue un log mostrando las ultimas lineas.",
                "example": "Get-Content .\\logs\\app.log -Tail 50 -Wait",
                "expected": "Ultimas 50 lineas y luego nuevas entradas.",
                "note": ""
            },
            {
                "command": "Get-Content app.log -Tail 50 -Wait",
                "level": "intermediate",
                "description": "Sigue un log en vivo.",
                "example": "Get-Content app.log -Tail 50 -Wait",
                "expected": "Ultimas lineas y nuevas entradas.",
                "note": ""
            },
            {
                "command": "Get-Content package.json -Raw | ConvertFrom-Json",
                "level": "intermediate",
                "description": "Parsea JSON a objeto PowerShell.",
                "example": "Get-Content package.json -Raw | ConvertFrom-Json",
                "expected": "PSCustomObject navegable.",
                "note": ""
            },
            {
                "command": "Get-ExecutionPolicy -List",
                "level": "intermediate",
                "description": "Muestra politicas de ejecucion por scope.",
                "example": "Get-ExecutionPolicy -List",
                "expected": "Scope ExecutionPolicy.",
                "note": ""
            },
            {
                "command": "Get-FileHash <file> -Algorithm SHA256",
                "level": "intermediate",
                "description": "Calcula el hash SHA-256 de un archivo.",
                "example": "Get-FileHash .\\release.zip -Algorithm SHA256",
                "expected": "Algorithm Hash Path.",
                "note": ""
            },
            {
                "command": "Get-Module -ListAvailable",
                "level": "intermediate",
                "description": "Lista modulos disponibles.",
                "example": "Get-Module -ListAvailable",
                "expected": "ModuleType, Version, Name.",
                "note": ""
            },
            {
                "command": "Get-NetTCPConnection -LocalPort 4000",
                "level": "intermediate",
                "description": "Muestra quien usa un puerto.",
                "example": "Get-NetTCPConnection -LocalPort 4000",
                "expected": "State, OwningProcess.",
                "note": ""
            },
            {
                "command": "Get-NetTCPConnection -LocalPort <port>",
                "level": "intermediate",
                "description": "Encuentra conexiones TCP que usan un puerto.",
                "example": "Get-NetTCPConnection -LocalPort 4000",
                "expected": "LocalAddress LocalPort RemoteAddress State OwningProcess.",
                "note": ""
            },
            {
                "command": "Get-Process | Export-Csv processes.csv -NoTypeInformation",
                "level": "intermediate",
                "description": "Exporta objetos a CSV.",
                "example": "Get-Process | Export-Csv processes.csv -NoTypeInformation",
                "expected": "Archivo CSV.",
                "note": ""
            },
            {
                "command": "Get-Process | Get-Member",
                "level": "intermediate",
                "description": "Inspecciona propiedades/metodos de objetos.",
                "example": "Get-Process | Get-Member",
                "expected": "TypeName y miembros.",
                "note": ""
            },
            {
                "command": "Get-Process | Measure-Object WorkingSet -Sum -Average",
                "level": "intermediate",
                "description": "Calcula agregados numericos.",
                "example": "Get-Process | Measure-Object WorkingSet -Sum -Average",
                "expected": "Count, Average, Sum.",
                "note": ""
            },
            {
                "command": "Get-ScheduledTask",
                "level": "intermediate",
                "description": "Lista tareas programadas.",
                "example": "Get-ScheduledTask",
                "expected": "TaskPath, TaskName, State.",
                "note": ""
            },
            {
                "command": "Get-Service | Group-Object Status",
                "level": "intermediate",
                "description": "Agrupa y cuenta objetos.",
                "example": "Get-Service | Group-Object Status",
                "expected": "Count, Name, Group.",
                "note": ""
            },
            {
                "command": "Install-Module Pester -Scope CurrentUser",
                "level": "intermediate",
                "description": "Instala modulo desde PSGallery.",
                "example": "Install-Module Pester -Scope CurrentUser",
                "expected": "Modulo instalado o prompt de confianza.",
                "note": ""
            },
            {
                "command": "Restart-Service <name>",
                "level": "intermediate",
                "description": "Reinicia un servicio.",
                "example": "Restart-Service postgresql-x64-16",
                "expected": "Sin salida si finaliza correctamente.",
                "note": ""
            },
            {
                "command": "Select-String -Path .\\*.log -Pattern \"ERROR|WARN\"",
                "level": "intermediate",
                "description": "Busca regex en archivos.",
                "example": "Select-String -Path .\\*.log -Pattern \"ERROR|WARN\"",
                "expected": "Ruta, linea y contenido.",
                "note": ""
            },
            {
                "command": "Select-String -Path <glob> -Pattern <text> -Recurse",
                "level": "intermediate",
                "description": "Busca texto en archivos.",
                "example": "Get-ChildItem . -Recurse -Filter *.ts | Select-String \"TODO\"",
                "expected": "Path:LineNumber:Line.",
                "note": ""
            },
            {
                "command": "Stop-Process -Id <pid> -Force",
                "level": "intermediate",
                "description": "Fuerza la terminacion de un proceso.",
                "example": "Stop-Process -Id 1234 -Force",
                "expected": "Sin salida si termina correctamente.",
                "note": ""
            },
            {
                "command": "Enter-PSSession -ComputerName SERVER01",
                "level": "advanced",
                "description": "Abre sesion remota.",
                "example": "Enter-PSSession -ComputerName SERVER01",
                "expected": "Prompt remoto.",
                "note": ""
            },
            {
                "command": "Get-WinEvent -LogName System -MaxEvents 20",
                "level": "advanced",
                "description": "Consulta Event Log.",
                "example": "Get-WinEvent -LogName System -MaxEvents 20",
                "expected": "Eventos recientes.",
                "note": ""
            },
            {
                "command": "Invoke-Command -ComputerName SERVER01 -ScriptBlock { Get-Service }",
                "level": "advanced",
                "description": "Ejecuta un bloque remotamente.",
                "example": "Invoke-Command -ComputerName SERVER01 -ScriptBlock { Get-Service }",
                "expected": "Objetos remotos.",
                "note": ""
            },
            {
                "command": "Receive-Job 1 -Wait -AutoRemoveJob",
                "level": "advanced",
                "description": "Recoge salida de job y lo elimina.",
                "example": "Receive-Job 1 -Wait -AutoRemoveJob",
                "expected": "Salida del job.",
                "note": ""
            },
            {
                "command": "Remove-Item <path> -Recurse -Force",
                "level": "advanced",
                "description": "Elimina recursivamente y fuerza elementos protegidos.",
                "example": "Remove-Item .\\dist -Recurse -Force",
                "expected": "Sin salida.",
                "note": "Destructivo: confirma bien la ruta."
            },
            {
                "command": "Set-ExecutionPolicy RemoteSigned -Scope CurrentUser",
                "level": "advanced",
                "description": "Permite scripts locales y exige firma a scripts descargados segun politica.",
                "example": "Set-ExecutionPolicy RemoteSigned -Scope CurrentUser",
                "expected": "Pide confirmacion y luego no imprime salida o muestra la nueva politica.",
                "note": ""
            },
            {
                "command": "Start-Job -ScriptBlock { Get-ChildItem C:\\ -Recurse }",
                "level": "advanced",
                "description": "Ejecuta trabajo en background.",
                "example": "Start-Job -ScriptBlock { Get-ChildItem C:\\ -Recurse }",
                "expected": "Objeto Job.",
                "note": ""
            }
        ]
    },
    {
        "id": "wsl",
        "group": "terminals",
        "title": "WSL",
        "description": "Gestion de distribuciones Linux dentro de Windows.",
        "aliases": [
            "wsl",
            "windows subsystem for linux"
        ],
        "commands": [
            {
                "command": "wsl --install",
                "level": "basic",
                "description": "Instala WSL y la distribucion predeterminada si el sistema lo soporta.",
                "example": "wsl --install",
                "expected": "Progreso de instalacion y posible solicitud de reinicio.",
                "note": ""
            },
            {
                "command": "wsl --install -d <distro>",
                "level": "basic",
                "description": "Instala una distribucion especifica.",
                "example": "wsl --install -d Ubuntu",
                "expected": "Descarga/instalacion y luego configuracion de usuario Linux.",
                "note": ""
            },
            {
                "command": "wsl --list --verbose",
                "level": "basic",
                "description": "Lista distribuciones y version WSL.",
                "example": "wsl -l -v",
                "expected": "NAME STATE VERSION.",
                "note": ""
            },
            {
                "command": "wsl --status",
                "level": "basic",
                "description": "Muestra configuracion general de WSL.",
                "example": "wsl --status",
                "expected": "Default Distribution, Default Version, kernel.",
                "note": ""
            },
            {
                "command": "wsl --update",
                "level": "basic",
                "description": "Actualiza el kernel/componentes de WSL.",
                "example": "wsl --update",
                "expected": "Checking for updates... / update completed.",
                "note": ""
            },
            {
                "command": "wsl -d <distro>",
                "level": "basic",
                "description": "Abre una distribucion concreta.",
                "example": "wsl -d Ubuntu",
                "expected": "Prompt de shell Linux.",
                "note": ""
            },
            {
                "command": "wsl --set-default <distro>",
                "level": "intermediate",
                "description": "Define la distribucion predeterminada.",
                "example": "wsl --set-default Ubuntu",
                "expected": "The operation completed successfully.",
                "note": ""
            },
            {
                "command": "wsl --set-version <distro> 2",
                "level": "intermediate",
                "description": "Convierte una distribucion a WSL 2.",
                "example": "wsl --set-version Ubuntu 2",
                "expected": "Conversion in progress... The operation completed successfully.",
                "note": ""
            },
            {
                "command": "wsl --shutdown",
                "level": "intermediate",
                "description": "Detiene todas las distribuciones y la VM ligera de WSL 2.",
                "example": "wsl --shutdown",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "wsl --terminate <distro>",
                "level": "intermediate",
                "description": "Detiene una distribucion especifica.",
                "example": "wsl --terminate Ubuntu",
                "expected": "The operation completed successfully.",
                "note": ""
            },
            {
                "command": "wsl --export <distro> <file.tar>",
                "level": "advanced",
                "description": "Exporta una distribucion completa a TAR.",
                "example": "wsl --export Ubuntu D:\\Backups\\ubuntu.tar",
                "expected": "Export in progress... The operation completed successfully.",
                "note": ""
            },
            {
                "command": "wsl --import <name> <install> <file.tar>",
                "level": "advanced",
                "description": "Importa una distribucion desde un TAR.",
                "example": "wsl --import UbuntuDev D:\\WSL\\UbuntuDev D:\\Backups\\ubuntu.tar",
                "expected": "The operation completed successfully.",
                "note": ""
            }
        ]
    },
    {
        "id": "npm",
        "group": "javascript",
        "title": "npm",
        "description": "Instalacion, scripts, paquetes, workspaces, cache, auditoria y publicacion.",
        "aliases": [
            "npm",
            "node package manager",
            "package.json"
        ],
        "commands": [
            {
                "command": "npm --version",
                "level": "basic",
                "description": "Muestra la version de npm.",
                "example": "npm --version",
                "expected": "10.x.x",
                "note": ""
            },
            {
                "command": "npm config get registry",
                "level": "basic",
                "description": "Muestra registry configurado.",
                "example": "npm config get registry",
                "expected": "URL del registry.",
                "note": ""
            },
            {
                "command": "npm config list",
                "level": "basic",
                "description": "Lista configuracion npm.",
                "example": "npm config list",
                "expected": "Configuracion y rutas.",
                "note": ""
            },
            {
                "command": "npm init -y",
                "level": "basic",
                "description": "Crea package.json con valores predeterminados.",
                "example": "npm init -y",
                "expected": "Wrote to .../package.json",
                "note": ""
            },
            {
                "command": "npm install",
                "level": "basic",
                "description": "Instala dependencias declaradas y actualiza lock cuando corresponde.",
                "example": "npm install",
                "expected": "added/changed packages, audited N packages.",
                "note": ""
            },
            {
                "command": "npm install -D <package>",
                "level": "basic",
                "description": "Instala una dependencia de desarrollo.",
                "example": "npm install -D eslint",
                "expected": "devDependencies y lock quedan actualizados.",
                "note": ""
            },
            {
                "command": "npm install <package>",
                "level": "basic",
                "description": "Instala una dependencia de produccion.",
                "example": "npm install axios",
                "expected": "added N packages ...; package.json queda actualizado.",
                "note": ""
            },
            {
                "command": "npm list --depth=0",
                "level": "basic",
                "description": "Lista dependencias directas instaladas.",
                "example": "npm list --depth=0",
                "expected": "Arbol con paquete@version.",
                "note": ""
            },
            {
                "command": "npm run",
                "level": "basic",
                "description": "Lista scripts disponibles de package.json.",
                "example": "npm run",
                "expected": "Lifecycle scripts / available via npm run-script.",
                "note": ""
            },
            {
                "command": "npm run <script>",
                "level": "basic",
                "description": "Ejecuta un script definido en package.json.",
                "example": "npm run build",
                "expected": "Salida del comando configurado en scripts.build.",
                "note": ""
            },
            {
                "command": "npm uninstall <package>",
                "level": "basic",
                "description": "Elimina un paquete del proyecto.",
                "example": "npm uninstall axios",
                "expected": "removed N packages ...",
                "note": ""
            },
            {
                "command": "npm view react",
                "level": "basic",
                "description": "Muestra metadata de paquete.",
                "example": "npm view react",
                "expected": "Version, dist-tags, deps, maintainers.",
                "note": ""
            },
            {
                "command": "npm whoami",
                "level": "basic",
                "description": "Muestra usuario autenticado.",
                "example": "npm whoami",
                "expected": "Usuario o ENEEDAUTH.",
                "note": ""
            },
            {
                "command": "npm audit",
                "level": "intermediate",
                "description": "Analiza vulnerabilidades conocidas en dependencias.",
                "example": "npm audit",
                "expected": "Resumen de vulnerabilidades y recomendaciones.",
                "note": ""
            },
            {
                "command": "npm audit --json",
                "level": "intermediate",
                "description": "Devuelve auditoria en JSON.",
                "example": "npm audit --json",
                "expected": "JSON de vulnerabilidades.",
                "note": ""
            },
            {
                "command": "npm audit fix",
                "level": "intermediate",
                "description": "Aplica actualizaciones compatibles para vulnerabilidades corregibles.",
                "example": "npm audit fix",
                "expected": "changed N packages; audit summary.",
                "note": ""
            },
            {
                "command": "npm cache verify",
                "level": "intermediate",
                "description": "Verifica integridad y compacta la cache.",
                "example": "npm cache verify",
                "expected": "Cache verified and compressed ...",
                "note": ""
            },
            {
                "command": "npm ci",
                "level": "intermediate",
                "description": "Instala exactamente package-lock.json desde cero; ideal para CI.",
                "example": "npm ci",
                "expected": "added N packages, audited N packages.",
                "note": "Falla si package.json y package-lock.json no coinciden."
            },
            {
                "command": "npm ci --omit=dev",
                "level": "intermediate",
                "description": "Instala lock exacto sin devDependencies.",
                "example": "npm ci --omit=dev",
                "expected": "Instalacion production-only.",
                "note": ""
            },
            {
                "command": "npm dedupe",
                "level": "intermediate",
                "description": "Reduce duplicacion en node_modules.",
                "example": "npm dedupe",
                "expected": "changed/removed packages.",
                "note": ""
            },
            {
                "command": "npm exec eslint -- src",
                "level": "intermediate",
                "description": "Ejecuta binario de paquete.",
                "example": "npm exec eslint -- src",
                "expected": "Salida de ESLint.",
                "note": ""
            },
            {
                "command": "npm explain <package>",
                "level": "intermediate",
                "description": "Explica por que un paquete esta instalado.",
                "example": "npm explain lodash",
                "expected": "Cadena de dependencias que requiere el paquete.",
                "note": ""
            },
            {
                "command": "npm install -E <package>",
                "level": "intermediate",
                "description": "Instala version exacta.",
                "example": "npm install -E typescript",
                "expected": "package.json sin ^/~.",
                "note": ""
            },
            {
                "command": "npm outdated",
                "level": "intermediate",
                "description": "Compara versiones current, wanted y latest.",
                "example": "npm outdated",
                "expected": "Package Current Wanted Latest Location.",
                "note": ""
            },
            {
                "command": "npm pack --dry-run",
                "level": "intermediate",
                "description": "Previsualiza contenido del paquete.",
                "example": "npm pack --dry-run",
                "expected": "Listado de archivos/tamaño.",
                "note": ""
            },
            {
                "command": "npm pkg get scripts",
                "level": "intermediate",
                "description": "Lee campos de package.json desde CLI.",
                "example": "npm pkg get scripts",
                "expected": "Objeto JSON con scripts.",
                "note": ""
            },
            {
                "command": "npm pkg set engines.node=\">=20\"",
                "level": "intermediate",
                "description": "Modifica package.json desde CLI.",
                "example": "npm pkg set engines.node=\">=20\"",
                "expected": "package.json actualizado.",
                "note": ""
            },
            {
                "command": "npm run <script> -- <args>",
                "level": "intermediate",
                "description": "Pasa argumentos adicionales al script.",
                "example": "npm run test -- --watch",
                "expected": "El script recibe --watch.",
                "note": ""
            },
            {
                "command": "npm update",
                "level": "intermediate",
                "description": "Actualiza paquetes respetando rangos semver.",
                "example": "npm update",
                "expected": "changed N packages, audited N packages.",
                "note": ""
            },
            {
                "command": "npm view react versions --json",
                "level": "intermediate",
                "description": "Lista todas las versiones publicadas.",
                "example": "npm view react versions --json",
                "expected": "Array JSON.",
                "note": ""
            },
            {
                "command": "npm audit fix --force",
                "level": "advanced",
                "description": "Permite upgrades major para remediar vulnerabilidades.",
                "example": "npm audit fix --force",
                "expected": "Warnings y cambios.",
                "note": "Puede introducir breaking changes."
            },
            {
                "command": "npm cache clean --force",
                "level": "advanced",
                "description": "Limpia la cache local forzadamente.",
                "example": "npm cache clean --force",
                "expected": "Warning using --force Recommended protections disabled.",
                "note": ""
            },
            {
                "command": "npm exec <package> -- <args>",
                "level": "advanced",
                "description": "Ejecuta un binario de un paquete local o temporal.",
                "example": "npm exec eslint -- src",
                "expected": "Salida de ESLint sobre src.",
                "note": ""
            },
            {
                "command": "npm publish",
                "level": "advanced",
                "description": "Publica el paquete actual en el registry configurado.",
                "example": "npm publish",
                "expected": "npm notice ... + package@version",
                "note": "Requiere autenticacion y nombre/version publicables."
            },
            {
                "command": "npm publish --dry-run",
                "level": "advanced",
                "description": "Simula publicacion.",
                "example": "npm publish --dry-run",
                "expected": "Contenido y metadata sin subir.",
                "note": ""
            },
            {
                "command": "npm run build --workspaces",
                "level": "advanced",
                "description": "Ejecuta script en todos los workspaces.",
                "example": "npm run build --workspaces",
                "expected": "Salida por workspace.",
                "note": ""
            },
            {
                "command": "npm version patch",
                "level": "advanced",
                "description": "Incrementa version patch y crea commit/tag si Git esta habilitado.",
                "example": "npm version patch",
                "expected": "v1.2.4",
                "note": ""
            },
            {
                "command": "npm workspace web run test",
                "level": "advanced",
                "description": "Ejecuta script en workspace concreto.",
                "example": "npm workspace web run test",
                "expected": "Salida del workspace.",
                "note": ""
            }
        ]
    },
    {
        "id": "yarn",
        "group": "javascript",
        "title": "Yarn",
        "description": "Dependencias, scripts, workspaces y diagnostico con Yarn.",
        "aliases": [
            "yarn",
            "yarnpkg"
        ],
        "commands": [
            {
                "command": "yarn --version",
                "level": "basic",
                "description": "Muestra la version instalada.",
                "example": "yarn --version",
                "expected": "1.x, 3.x o 4.x segun proyecto.",
                "note": ""
            },
            {
                "command": "yarn <script>",
                "level": "basic",
                "description": "Ejecuta un script de package.json.",
                "example": "yarn build",
                "expected": "Salida del script build.",
                "note": ""
            },
            {
                "command": "yarn add -D <package>",
                "level": "basic",
                "description": "Agrega dependencia de desarrollo.",
                "example": "yarn add -D eslint",
                "expected": "Saved new dependency.",
                "note": ""
            },
            {
                "command": "yarn add <package>",
                "level": "basic",
                "description": "Agrega dependencia de produccion.",
                "example": "yarn add axios",
                "expected": "Saved lockfile / added dependency.",
                "note": ""
            },
            {
                "command": "yarn init -y",
                "level": "basic",
                "description": "Crea package.json.",
                "example": "yarn init -y",
                "expected": "success Saved package.json.",
                "note": ""
            },
            {
                "command": "yarn install",
                "level": "basic",
                "description": "Instala dependencias segun package.json y lockfile.",
                "example": "yarn install",
                "expected": "Resolving/Fetching/Linking/Building ... Done.",
                "note": ""
            },
            {
                "command": "yarn remove <package>",
                "level": "basic",
                "description": "Elimina una dependencia.",
                "example": "yarn remove axios",
                "expected": "Removing module... Done.",
                "note": ""
            },
            {
                "command": "yarn run",
                "level": "basic",
                "description": "Lista scripts disponibles.",
                "example": "yarn run",
                "expected": "Commands available from binary scripts / package scripts.",
                "note": ""
            },
            {
                "command": "yarn cache clean",
                "level": "intermediate",
                "description": "Limpia cache de paquetes.",
                "example": "yarn cache clean",
                "expected": "success Cleared cache.",
                "note": ""
            },
            {
                "command": "yarn config get <key>",
                "level": "intermediate",
                "description": "Consulta configuración.",
                "example": "yarn config get npmRegistryServer",
                "expected": "Valor configurado.",
                "note": ""
            },
            {
                "command": "yarn install --immutable",
                "level": "intermediate",
                "description": "Falla si el lockfile necesita cambios; ideal para CI con Yarn moderno.",
                "example": "yarn install --immutable",
                "expected": "Éxito o error indicando lockfile inconsistente.",
                "note": ""
            },
            {
                "command": "yarn outdated",
                "level": "intermediate",
                "description": "Lista dependencias desactualizadas en Yarn Classic.",
                "example": "yarn outdated",
                "expected": "Package Current Wanted Latest ...",
                "note": ""
            },
            {
                "command": "yarn up <package>",
                "level": "intermediate",
                "description": "Actualiza una dependencia con Yarn Berry.",
                "example": "yarn up react",
                "expected": "Resolución actualizada.",
                "note": ""
            },
            {
                "command": "yarn upgrade <package>",
                "level": "intermediate",
                "description": "Actualiza un paquete segun la version/rango indicado.",
                "example": "yarn upgrade react",
                "expected": "Lockfile y dependencia actualizados.",
                "note": ""
            },
            {
                "command": "yarn why <package>",
                "level": "intermediate",
                "description": "Explica quien depende de un paquete.",
                "example": "yarn why lodash",
                "expected": "Reasons this module exists, dependents y tamano.",
                "note": ""
            },
            {
                "command": "yarn workspace <workspace> <script>",
                "level": "intermediate",
                "description": "Ejecuta script dentro de un workspace.",
                "example": "yarn workspace web build",
                "expected": "Salida del script del workspace.",
                "note": ""
            },
            {
                "command": "yarn config set <key> <value>",
                "level": "advanced",
                "description": "Define configuración de Yarn.",
                "example": "yarn config set enableGlobalCache false",
                "expected": "Configuración persistida.",
                "note": ""
            },
            {
                "command": "yarn dlx <package>",
                "level": "advanced",
                "description": "Descarga y ejecuta temporalmente un paquete con Yarn moderno.",
                "example": "yarn dlx create-vite",
                "expected": "Asistente/salida del paquete sin agregarlo a dependencies.",
                "note": ""
            },
            {
                "command": "yarn npm audit",
                "level": "advanced",
                "description": "Audita dependencias usando el registry npm en Yarn moderno.",
                "example": "yarn npm audit",
                "expected": "Reporte de advisories/vulnerabilidades.",
                "note": ""
            },
            {
                "command": "yarn workspace <name> <command>",
                "level": "advanced",
                "description": "Ejecuta un comando dentro de un workspace.",
                "example": "yarn workspace web build",
                "expected": "Salida del build del workspace web.",
                "note": ""
            },
            {
                "command": "yarn workspaces foreach -A run build",
                "level": "advanced",
                "description": "Ejecuta un script en todos los workspaces con Yarn moderno.",
                "example": "yarn workspaces foreach -A run build",
                "expected": "Una ejecucion por workspace.",
                "note": ""
            }
        ]
    },
    {
        "id": "pnpm",
        "group": "javascript",
        "title": "pnpm",
        "description": "Gestor de paquetes eficiente: store global, scripts y workspaces.",
        "aliases": [
            "pnpm",
            "package manager"
        ],
        "commands": [
            {
                "command": "pnpm --version",
                "level": "basic",
                "description": "Muestra la version de pnpm.",
                "example": "pnpm --version",
                "expected": "9.x.x o version instalada.",
                "note": ""
            },
            {
                "command": "pnpm add -D <package>",
                "level": "basic",
                "description": "Agrega dependencia de desarrollo.",
                "example": "pnpm add -D eslint",
                "expected": "devDependencies: + eslint ...",
                "note": ""
            },
            {
                "command": "pnpm add <package>",
                "level": "basic",
                "description": "Agrega dependencia.",
                "example": "pnpm add axios",
                "expected": "dependencies: + axios ...",
                "note": ""
            },
            {
                "command": "pnpm exec <command>",
                "level": "basic",
                "description": "Ejecuta binario de dependencia local.",
                "example": "pnpm exec eslint .",
                "expected": "Salida del binario.",
                "note": ""
            },
            {
                "command": "pnpm install",
                "level": "basic",
                "description": "Instala dependencias usando el store content-addressable.",
                "example": "pnpm install",
                "expected": "Packages: +N ... Done.",
                "note": ""
            },
            {
                "command": "pnpm list --depth 0",
                "level": "basic",
                "description": "Lista dependencias directas.",
                "example": "pnpm list --depth 0",
                "expected": "Tabla/arbol de paquetes directos.",
                "note": ""
            },
            {
                "command": "pnpm remove <package>",
                "level": "basic",
                "description": "Elimina dependencia.",
                "example": "pnpm remove axios",
                "expected": "Packages: -N ...",
                "note": ""
            },
            {
                "command": "pnpm run <script>",
                "level": "basic",
                "description": "Ejecuta un script del proyecto.",
                "example": "pnpm run build",
                "expected": "Salida del script build.",
                "note": ""
            },
            {
                "command": "pnpm --filter <workspace> run build",
                "level": "intermediate",
                "description": "Ejecuta script en workspace filtrado.",
                "example": "pnpm --filter web run build",
                "expected": "Salida de build del workspace.",
                "note": ""
            },
            {
                "command": "pnpm audit",
                "level": "intermediate",
                "description": "Audita dependencias vulnerables.",
                "example": "pnpm audit",
                "expected": "Advisories o resumen limpio.",
                "note": ""
            },
            {
                "command": "pnpm dlx <package>",
                "level": "intermediate",
                "description": "Ejecuta temporalmente un paquete sin instalarlo al proyecto.",
                "example": "pnpm dlx create-vite",
                "expected": "Asistente/salida del paquete.",
                "note": ""
            },
            {
                "command": "pnpm exec <binary>",
                "level": "intermediate",
                "description": "Ejecuta binario desde node_modules/.bin.",
                "example": "pnpm exec eslint src",
                "expected": "Salida de ESLint.",
                "note": ""
            },
            {
                "command": "pnpm install --frozen-lockfile",
                "level": "intermediate",
                "description": "Instala sin permitir cambios al lockfile.",
                "example": "pnpm install --frozen-lockfile",
                "expected": "Éxito o error por lock desactualizado.",
                "note": ""
            },
            {
                "command": "pnpm outdated",
                "level": "intermediate",
                "description": "Lista paquetes desactualizados.",
                "example": "pnpm outdated",
                "expected": "Package Current Latest ...",
                "note": ""
            },
            {
                "command": "pnpm store path",
                "level": "intermediate",
                "description": "Muestra ruta del content-addressable store.",
                "example": "pnpm store path",
                "expected": "Ruta absoluta.",
                "note": ""
            },
            {
                "command": "pnpm update",
                "level": "intermediate",
                "description": "Actualiza dependencias respetando rangos.",
                "example": "pnpm update",
                "expected": "Paquetes actualizados.",
                "note": ""
            },
            {
                "command": "pnpm why <package>",
                "level": "intermediate",
                "description": "Muestra por que una dependencia esta presente.",
                "example": "pnpm why lodash",
                "expected": "Arbol de dependencias solicitantes.",
                "note": ""
            },
            {
                "command": "pnpm --filter <name> <command>",
                "level": "advanced",
                "description": "Ejecuta un comando solo en workspaces seleccionados.",
                "example": "pnpm --filter web build",
                "expected": "Solo se ejecuta en el workspace web.",
                "note": ""
            },
            {
                "command": "pnpm -r run build",
                "level": "advanced",
                "description": "Ejecuta build recursivamente en los workspaces.",
                "example": "pnpm -r run build",
                "expected": "Salida de cada workspace.",
                "note": ""
            },
            {
                "command": "pnpm -r run test",
                "level": "advanced",
                "description": "Ejecuta test recursivamente en todos los workspaces.",
                "example": "pnpm -r run test",
                "expected": "Salida por paquete.",
                "note": ""
            },
            {
                "command": "pnpm store prune",
                "level": "advanced",
                "description": "Elimina paquetes no referenciados del store global.",
                "example": "pnpm store prune",
                "expected": "Removed all cached metadata files / pruned packages.",
                "note": ""
            }
        ]
    },
    {
        "id": "node",
        "group": "javascript",
        "title": "Node.js",
        "description": "Runtime, scripts, diagnostico, flags y utilidades del proceso.",
        "aliases": [
            "node",
            "nodejs",
            "javascript runtime"
        ],
        "commands": [
            {
                "command": "node",
                "level": "basic",
                "description": "Abre el REPL interactivo.",
                "example": "node",
                "expected": "Welcome to Node.js ...\n>",
                "note": ""
            },
            {
                "command": "node --check <file.js>",
                "level": "basic",
                "description": "Verifica sintaxis sin ejecutar el archivo.",
                "example": "node --check server.js",
                "expected": "Sin salida si es valido; SyntaxError si no.",
                "note": ""
            },
            {
                "command": "node --version",
                "level": "basic",
                "description": "Muestra la version de Node.js.",
                "example": "node --version",
                "expected": "v22.x.x o version instalada.",
                "note": ""
            },
            {
                "command": "node --watch app.js",
                "level": "basic",
                "description": "Reinicia automáticamente al cambiar archivos.",
                "example": "node --watch src/server.js",
                "expected": "Proceso reiniciado ante cambios.",
                "note": ""
            },
            {
                "command": "node -e \"<code>\"",
                "level": "basic",
                "description": "Ejecuta JavaScript inline.",
                "example": "node -e \"console.log(process.version)\"",
                "expected": "v22.x.x",
                "note": ""
            },
            {
                "command": "node -e \"console.log(process.cwd())\"",
                "level": "basic",
                "description": "Ejecuta JavaScript inline.",
                "example": "node -e \"console.log(process.cwd())\"",
                "expected": "Directorio actual.",
                "note": ""
            },
            {
                "command": "node -p \"<expression>\"",
                "level": "basic",
                "description": "Evalua e imprime el resultado de una expresion.",
                "example": "node -p \"process.platform\"",
                "expected": "win32, linux o darwin.",
                "note": ""
            },
            {
                "command": "node <file.js>",
                "level": "basic",
                "description": "Ejecuta un archivo JavaScript.",
                "example": "node server.js",
                "expected": "Salida del script o errores/excepciones.",
                "note": ""
            },
            {
                "command": "node --env-file=.env <file.js>",
                "level": "intermediate",
                "description": "Carga variables desde un archivo env en Node moderno.",
                "example": "node --env-file=.env server.js",
                "expected": "El proceso recibe process.env.*; salida normal del script.",
                "note": ""
            },
            {
                "command": "node --env-file=.env app.js",
                "level": "intermediate",
                "description": "Carga variables de entorno desde archivo en Node moderno.",
                "example": "node --env-file=.env dist/main.js",
                "expected": "Ejecuta app con variables cargadas.",
                "note": ""
            },
            {
                "command": "node --inspect <file.js>",
                "level": "intermediate",
                "description": "Inicia con inspector para depuracion.",
                "example": "node --inspect server.js",
                "expected": "Debugger listening on ws://127.0.0.1:9229/...",
                "note": ""
            },
            {
                "command": "node --inspect app.js",
                "level": "intermediate",
                "description": "Activa debugger Inspector.",
                "example": "node --inspect dist/main.js",
                "expected": "Debugger listening on ws://127.0.0.1:9229/...",
                "note": ""
            },
            {
                "command": "node --inspect-brk app.js",
                "level": "intermediate",
                "description": "Abre debugger y pausa antes de ejecutar.",
                "example": "node --inspect-brk dist/main.js",
                "expected": "Debugger listening y espera attach.",
                "note": ""
            },
            {
                "command": "node --test",
                "level": "intermediate",
                "description": "Ejecuta el test runner integrado de Node.",
                "example": "node --test",
                "expected": "TAP/resumen de tests pass/fail.",
                "note": ""
            },
            {
                "command": "node --test --test-name-pattern=\"auth\"",
                "level": "intermediate",
                "description": "Filtra tests por nombre.",
                "example": "node --test --test-name-pattern=\"login\"",
                "expected": "Solo tests coincidentes.",
                "note": ""
            },
            {
                "command": "node --trace-deprecation <file.js>",
                "level": "intermediate",
                "description": "Muestra stack de APIs deprecadas.",
                "example": "node --trace-deprecation server.js",
                "expected": "DeprecationWarning con stack.",
                "note": ""
            },
            {
                "command": "node --trace-deprecation app.js",
                "level": "intermediate",
                "description": "Traza APIs deprecadas.",
                "example": "node --trace-deprecation app.js",
                "expected": "Stack de deprecation warnings.",
                "note": ""
            },
            {
                "command": "node --trace-warnings <file.js>",
                "level": "intermediate",
                "description": "Imprime stack traces completos para warnings.",
                "example": "node --trace-warnings server.js",
                "expected": "Warning seguido de stack trace.",
                "note": ""
            },
            {
                "command": "node --trace-warnings app.js",
                "level": "intermediate",
                "description": "Muestra stack completo de warnings.",
                "example": "node --trace-warnings app.js",
                "expected": "Warning con stack.",
                "note": ""
            },
            {
                "command": "node --watch <file.js>",
                "level": "intermediate",
                "description": "Reinicia el script cuando cambian archivos observados.",
                "example": "node --watch server.js",
                "expected": "Running ...; Restarting ... al guardar.",
                "note": ""
            },
            {
                "command": "node -p \"process.versions\"",
                "level": "intermediate",
                "description": "Muestra versiones de runtimes/librerías embebidas.",
                "example": "node -p \"process.versions\"",
                "expected": "Objeto con node, v8, openssl, uv, etc.",
                "note": ""
            },
            {
                "command": "node --cpu-prof app.js",
                "level": "advanced",
                "description": "Genera perfil CPU compatible con DevTools.",
                "example": "node --cpu-prof dist/main.js",
                "expected": "Archivo .cpuprofile.",
                "note": ""
            },
            {
                "command": "node --heap-prof app.js",
                "level": "advanced",
                "description": "Genera perfil de heap.",
                "example": "node --heap-prof dist/main.js",
                "expected": "Archivo .heapprofile.",
                "note": ""
            },
            {
                "command": "node --inspect-brk <file.js>",
                "level": "advanced",
                "description": "Abre inspector y pausa antes de ejecutar codigo de usuario.",
                "example": "node --inspect-brk server.js",
                "expected": "Debugger listening ...; espera conexion del debugger.",
                "note": ""
            },
            {
                "command": "node --max-old-space-size=4096 <file.js>",
                "level": "advanced",
                "description": "Aumenta memoria maxima aproximada del heap V8.",
                "example": "node --max-old-space-size=4096 build.js",
                "expected": "Ejecucion normal con limite de heap mayor.",
                "note": ""
            },
            {
                "command": "node --prof app.js",
                "level": "advanced",
                "description": "Genera perfil V8 de CPU.",
                "example": "node --prof dist/main.js",
                "expected": "Archivo isolate-*.log.",
                "note": ""
            },
            {
                "command": "node --prof-process isolate-*.log",
                "level": "advanced",
                "description": "Procesa perfil V8 a informe legible.",
                "example": "node --prof-process isolate-0x*.log",
                "expected": "Ticks, funciones y hot paths.",
                "note": ""
            }
        ]
    },
    {
        "id": "typescript",
        "group": "javascript",
        "title": "TypeScript / tsc",
        "description": "Compilacion, chequeo de tipos, configuracion y diagnostico.",
        "aliases": [
            "typescript",
            "tsc",
            "tsconfig"
        ],
        "commands": [
            {
                "command": "npx tsc",
                "level": "basic",
                "description": "Compila segun tsconfig.json.",
                "example": "npx tsc",
                "expected": "Sin salida si compila; errores TSxxxx si falla.",
                "note": ""
            },
            {
                "command": "npx tsc --init",
                "level": "basic",
                "description": "Genera tsconfig.json inicial.",
                "example": "npx tsc --init",
                "expected": "Created a new tsconfig.json ...",
                "note": ""
            },
            {
                "command": "npx tsc --noEmit",
                "level": "basic",
                "description": "Valida tipos sin generar JavaScript.",
                "example": "npx tsc --noEmit",
                "expected": "Sin salida si todo esta correcto; lista errores si no.",
                "note": ""
            },
            {
                "command": "npx tsc --version",
                "level": "basic",
                "description": "Muestra la version de TypeScript del proyecto o temporal.",
                "example": "npx tsc --version",
                "expected": "Version 5.x.x",
                "note": ""
            },
            {
                "command": "npx tsc --pretty false",
                "level": "intermediate",
                "description": "Desactiva formato coloreado; util para CI/logs.",
                "example": "npx tsc --noEmit --pretty false",
                "expected": "Errores en texto plano.",
                "note": ""
            },
            {
                "command": "npx tsc --project <path>",
                "level": "intermediate",
                "description": "Usa un tsconfig especifico.",
                "example": "npx tsc --project tsconfig.build.json",
                "expected": "Salida de compilacion o errores.",
                "note": ""
            },
            {
                "command": "npx tsc --showConfig",
                "level": "intermediate",
                "description": "Muestra configuracion efectiva resuelta.",
                "example": "npx tsc --showConfig",
                "expected": "JSON con compilerOptions, files/include/exclude resueltos.",
                "note": ""
            },
            {
                "command": "npx tsc --watch",
                "level": "intermediate",
                "description": "Mantiene el compilador observando cambios.",
                "example": "npx tsc --watch",
                "expected": "Starting compilation in watch mode... Found 0 errors.",
                "note": ""
            },
            {
                "command": "npx tsc <file.ts> --target ES2022",
                "level": "intermediate",
                "description": "Compila un archivo con opciones directas.",
                "example": "npx tsc demo.ts --target ES2022",
                "expected": "demo.js generado o errores de tipos.",
                "note": ""
            },
            {
                "command": "npx tsc --build",
                "level": "advanced",
                "description": "Compila project references en modo build.",
                "example": "npx tsc --build",
                "expected": "Compila proyectos pendientes; sin salida si todo esta al dia.",
                "note": ""
            },
            {
                "command": "npx tsc --build --clean",
                "level": "advanced",
                "description": "Elimina outputs y metadata de project references.",
                "example": "npx tsc --build --clean",
                "expected": "Normalmente sin salida.",
                "note": ""
            },
            {
                "command": "npx tsc --extendedDiagnostics",
                "level": "advanced",
                "description": "Muestra tiempos, memoria y contadores internos de compilacion.",
                "example": "npx tsc --extendedDiagnostics",
                "expected": "Files, Lines, Memory used, Parse time, Check time, Total time.",
                "note": ""
            },
            {
                "command": "npx tsc --generateTrace trace",
                "level": "advanced",
                "description": "Genera trace para analizar performance del type checker.",
                "example": "npx tsc --generateTrace trace",
                "expected": "Directorio trace con JSON.",
                "note": ""
            },
            {
                "command": "npx tsc --listFiles",
                "level": "advanced",
                "description": "Lista archivos incluidos en la compilacion.",
                "example": "npx tsc --listFiles",
                "expected": "Una ruta por archivo, incluidas libs de TypeScript.",
                "note": ""
            },
            {
                "command": "npx tsc --traceResolution",
                "level": "advanced",
                "description": "Explica como resuelve imports y tipos.",
                "example": "npx tsc --traceResolution",
                "expected": "Trazas detalladas de busqueda/resolucion de modulos.",
                "note": ""
            }
        ]
    },
    {
        "id": "react",
        "group": "frameworks",
        "title": "React / Vite",
        "description": "Creacion, desarrollo, build, preview y diagnostico de apps React/Vite.",
        "aliases": [
            "react",
            "vite",
            "frontend"
        ],
        "commands": [
            {
                "command": "npm create vite@latest",
                "level": "basic",
                "description": "Crea un proyecto Vite mediante asistente.",
                "example": "npm create vite@latest",
                "expected": "Solicita nombre, framework y variante; genera proyecto.",
                "note": ""
            },
            {
                "command": "npm create vite@latest app -- --template react",
                "level": "basic",
                "description": "Crea directamente una app React JavaScript.",
                "example": "npm create vite@latest app -- --template react",
                "expected": "Scaffolding project in .../app.",
                "note": ""
            },
            {
                "command": "npm create vite@latest app -- --template react-ts",
                "level": "basic",
                "description": "Crea una app React + TypeScript.",
                "example": "npm create vite@latest app -- --template react-ts",
                "expected": "Scaffolding project ... Done.",
                "note": ""
            },
            {
                "command": "npm install react-router-dom",
                "level": "basic",
                "description": "Instala React Router para navegacion SPA.",
                "example": "npm install react-router-dom",
                "expected": "Paquete agregado y auditado.",
                "note": ""
            },
            {
                "command": "npm run build",
                "level": "basic",
                "description": "Genera el bundle de produccion.",
                "example": "npm run build",
                "expected": "vite building for production... dist/... gzip sizes.",
                "note": ""
            },
            {
                "command": "npm run dev",
                "level": "basic",
                "description": "Levanta el servidor de desarrollo Vite.",
                "example": "npm run dev",
                "expected": "Local: http://localhost:5173/ y HMR activo.",
                "note": ""
            },
            {
                "command": "npm run lint",
                "level": "basic",
                "description": "Ejecuta el script lint definido por el proyecto Vite/React.",
                "example": "npm run lint",
                "expected": "Errores/warnings de ESLint o salida limpia.",
                "note": ""
            },
            {
                "command": "npm run preview",
                "level": "basic",
                "description": "Sirve localmente el build generado para revisarlo.",
                "example": "npm run preview",
                "expected": "Local: http://localhost:4173/",
                "note": ""
            },
            {
                "command": "npx vite --port 3000",
                "level": "basic",
                "description": "Levanta Vite en un puerto concreto.",
                "example": "npx vite --port 3000",
                "expected": "Local: http://localhost:3000/",
                "note": ""
            },
            {
                "command": "npm install -D @vitejs/plugin-react",
                "level": "intermediate",
                "description": "Instala plugin oficial React de Vite cuando no esta presente.",
                "example": "npm install -D @vitejs/plugin-react",
                "expected": "devDependency agregada.",
                "note": ""
            },
            {
                "command": "npm test -- --watch",
                "level": "intermediate",
                "description": "Ejemplo comun para test runner configurado en package.json.",
                "example": "npm test -- --watch",
                "expected": "Runner permanece observando cambios.",
                "note": ""
            },
            {
                "command": "npx eslint src --fix",
                "level": "intermediate",
                "description": "Analiza y aplica fixes automaticos posibles en src.",
                "example": "npx eslint src --fix",
                "expected": "Sin salida si queda limpio; errores restantes si no.",
                "note": ""
            },
            {
                "command": "npx prettier . --write",
                "level": "intermediate",
                "description": "Formatea archivos soportados segun Prettier.",
                "example": "npx prettier . --write",
                "expected": "Lista archivos y tiempo de formateo.",
                "note": ""
            },
            {
                "command": "npx vite --force",
                "level": "intermediate",
                "description": "Ignora cache de pre-bundling y vuelve a optimizar dependencias.",
                "example": "npx vite --force",
                "expected": "Forced re-optimization of dependencies y servidor iniciado.",
                "note": ""
            },
            {
                "command": "npx vite --host 0.0.0.0",
                "level": "intermediate",
                "description": "Expone el dev server en interfaces de red.",
                "example": "npx vite --host 0.0.0.0",
                "expected": "Local y Network URLs.",
                "note": ""
            },
            {
                "command": "npx depcheck",
                "level": "advanced",
                "description": "Detecta dependencias potencialmente sin uso cuando depcheck esta disponible.",
                "example": "npx depcheck",
                "expected": "Unused dependencies / devDependencies / missing dependencies.",
                "note": ""
            }
        ]
    },
    {
        "id": "react-native",
        "group": "frameworks",
        "title": "React Native / Expo",
        "description": "Apps moviles React Native y Expo: desarrollo, dispositivos, builds y diagnostico.",
        "aliases": [
            "react native",
            "expo",
            "android",
            "ios",
            "mobile"
        ],
        "commands": [
            {
                "command": "adb devices",
                "level": "basic",
                "description": "Lista dispositivos/emuladores Android conectados.",
                "example": "adb devices",
                "expected": "List of devices attached\nemulator-5554 device",
                "note": ""
            },
            {
                "command": "npx create-expo-app@latest <app>",
                "level": "basic",
                "description": "Crea un proyecto Expo moderno.",
                "example": "npx create-expo-app@latest mobile-app",
                "expected": "Descarga template, instala dependencias y muestra siguientes pasos.",
                "note": ""
            },
            {
                "command": "npx expo install <package>",
                "level": "basic",
                "description": "Instala una version compatible de un paquete Expo.",
                "example": "npx expo install expo-camera",
                "expected": "Instala version compatible y actualiza package.json.",
                "note": ""
            },
            {
                "command": "npx expo start",
                "level": "basic",
                "description": "Inicia Metro/Expo dev server.",
                "example": "npx expo start",
                "expected": "QR, URL y atajos a/i/w.",
                "note": ""
            },
            {
                "command": "npx react-native run-android",
                "level": "basic",
                "description": "Compila e instala Android en RN CLI.",
                "example": "npx react-native run-android",
                "expected": "Gradle build y Launching the app.",
                "note": ""
            },
            {
                "command": "npx react-native run-ios",
                "level": "basic",
                "description": "Compila y abre iOS en RN CLI sobre macOS.",
                "example": "npx react-native run-ios",
                "expected": "Xcode build y app en simulador.",
                "note": ""
            },
            {
                "command": "npx react-native start",
                "level": "basic",
                "description": "Inicia Metro en proyectos React Native CLI.",
                "example": "npx react-native start",
                "expected": "Metro waiting on ...",
                "note": ""
            },
            {
                "command": "adb logcat",
                "level": "intermediate",
                "description": "Muestra logs del dispositivo Android en tiempo real.",
                "example": "adb logcat",
                "expected": "Flujo continuo de logs; Ctrl+C para salir.",
                "note": ""
            },
            {
                "command": "adb reverse tcp:8081 tcp:8081",
                "level": "intermediate",
                "description": "Redirige Metro al dispositivo Android por USB.",
                "example": "adb reverse tcp:8081 tcp:8081",
                "expected": "Sin salida si configura correctamente.",
                "note": ""
            },
            {
                "command": "npx expo run:android",
                "level": "intermediate",
                "description": "Compila y ejecuta proyecto nativo Android localmente.",
                "example": "npx expo run:android",
                "expected": "Gradle build, instalacion y apertura en dispositivo/emulador.",
                "note": ""
            },
            {
                "command": "npx expo run:ios",
                "level": "intermediate",
                "description": "Compila y ejecuta iOS localmente en macOS.",
                "example": "npx expo run:ios",
                "expected": "Xcode build e instalacion en simulador/dispositivo.",
                "note": ""
            },
            {
                "command": "npx expo start --tunnel",
                "level": "intermediate",
                "description": "Expone la app mediante tunnel para dispositivos fuera de la LAN.",
                "example": "npx expo start --tunnel",
                "expected": "Tunnel ready + QR/URL.",
                "note": ""
            },
            {
                "command": "npx expo start -c",
                "level": "intermediate",
                "description": "Inicia Expo limpiando cache de Metro.",
                "example": "npx expo start -c",
                "expected": "Starting project... cache cleared.",
                "note": ""
            },
            {
                "command": "npx expo-doctor",
                "level": "intermediate",
                "description": "Revisa compatibilidad y problemas de configuracion Expo.",
                "example": "npx expo-doctor",
                "expected": "Checks passed o lista de problemas/recomendaciones.",
                "note": ""
            },
            {
                "command": "npx react-native config",
                "level": "intermediate",
                "description": "Muestra configuración/autolinking.",
                "example": "npx react-native config",
                "expected": "JSON de proyecto/dependencies/platforms.",
                "note": ""
            },
            {
                "command": "npx react-native doctor",
                "level": "intermediate",
                "description": "Diagnostica Android SDK, JDK, Xcode y dependencias RN.",
                "example": "npx react-native doctor",
                "expected": "Checks con ✓/✖ y acciones sugeridas.",
                "note": ""
            },
            {
                "command": "npx react-native start --reset-cache",
                "level": "intermediate",
                "description": "Inicia Metro limpiando cache.",
                "example": "npx react-native start --reset-cache",
                "expected": "Metro con cache reiniciada.",
                "note": ""
            },
            {
                "command": "eas build --platform android",
                "level": "advanced",
                "description": "Solicita un build Android con EAS Build.",
                "example": "eas build --platform android",
                "expected": "Seleccion de profile/credenciales, upload y URL del build.",
                "note": ""
            },
            {
                "command": "eas build --platform ios",
                "level": "advanced",
                "description": "Solicita un build iOS con EAS.",
                "example": "eas build --platform ios",
                "expected": "Validacion de credenciales, upload y URL del build.",
                "note": ""
            },
            {
                "command": "eas submit --platform android",
                "level": "advanced",
                "description": "Envia un build Android a Google Play segun configuracion EAS.",
                "example": "eas submit --platform android",
                "expected": "Seleccion del build y progreso de submission.",
                "note": ""
            },
            {
                "command": "eas update --branch production",
                "level": "advanced",
                "description": "Publica OTA update en rama.",
                "example": "eas update --branch production",
                "expected": "Update group/ID.",
                "note": ""
            },
            {
                "command": "npx expo prebuild",
                "level": "advanced",
                "description": "Genera carpetas android/ios desde config Expo.",
                "example": "npx expo prebuild",
                "expected": "Created native directories / updated configs.",
                "note": ""
            },
            {
                "command": "npx expo prebuild --clean",
                "level": "advanced",
                "description": "Regenera android/ios desde cero.",
                "example": "npx expo prebuild --clean",
                "expected": "Elimina/regenera proyectos nativos.",
                "note": "Revisa cambios nativos antes de usarlo si tenes personalizaciones manuales."
            }
        ]
    },
    {
        "id": "nest",
        "group": "frameworks",
        "title": "NestJS",
        "description": "CLI, modulos, controladores, servicios, recursos, build y diagnostico de Nest.",
        "aliases": [
            "nest",
            "nestjs",
            "backend",
            "api"
        ],
        "commands": [
            {
                "command": "nest --version",
                "level": "basic",
                "description": "Muestra version del Nest CLI.",
                "example": "nest --version",
                "expected": "10.x.x / 11.x.x segun instalacion.",
                "note": ""
            },
            {
                "command": "nest build",
                "level": "basic",
                "description": "Compila TypeScript de Nest a dist.",
                "example": "nest build",
                "expected": "Sin salida relevante si compila; dist/ actualizado.",
                "note": ""
            },
            {
                "command": "nest g class <name>",
                "level": "basic",
                "description": "Genera clase.",
                "example": "nest g class common/result",
                "expected": "CREATE ...result.ts.",
                "note": ""
            },
            {
                "command": "nest g controller <name>",
                "level": "basic",
                "description": "Genera controlador y spec.",
                "example": "nest g controller users",
                "expected": "CREATE users.controller.ts y .spec.ts; UPDATE module.",
                "note": ""
            },
            {
                "command": "nest g module <name>",
                "level": "basic",
                "description": "Genera un modulo.",
                "example": "nest g module users",
                "expected": "CREATE src/users/users.module.ts / UPDATE app.module.ts cuando corresponde.",
                "note": ""
            },
            {
                "command": "nest g service <name>",
                "level": "basic",
                "description": "Genera servicio y spec.",
                "example": "nest g service users",
                "expected": "CREATE users.service.ts y .spec.ts; UPDATE module cuando corresponde.",
                "note": ""
            },
            {
                "command": "nest new <app>",
                "level": "basic",
                "description": "Crea una aplicacion Nest nueva.",
                "example": "nest new api",
                "expected": "Asistente de package manager, scaffolding e instalacion.",
                "note": ""
            },
            {
                "command": "nest new <name>",
                "level": "basic",
                "description": "Crea una aplicación Nest.",
                "example": "nest new api",
                "expected": "Scaffold y dependencias instaladas.",
                "note": ""
            },
            {
                "command": "nest start --watch",
                "level": "basic",
                "description": "Levanta Nest en modo watch.",
                "example": "nest start --watch",
                "expected": "Starting compilation in watch mode... Nest application successfully started.",
                "note": ""
            },
            {
                "command": "npm i -g @nestjs/cli",
                "level": "basic",
                "description": "Instala el CLI de Nest globalmente.",
                "example": "npm i -g @nestjs/cli",
                "expected": "Paquetes instalados; nest --version queda disponible.",
                "note": ""
            },
            {
                "command": "npm run start:dev",
                "level": "basic",
                "description": "Ejecuta el script de desarrollo tipico de Nest.",
                "example": "npm run start:dev",
                "expected": "Compilacion watch y logs de bootstrap.",
                "note": ""
            },
            {
                "command": "nest add @nestjs/swagger",
                "level": "intermediate",
                "description": "Agrega package/schematic compatible.",
                "example": "nest add @nestjs/swagger",
                "expected": "Dependencia/configuración según schematic.",
                "note": ""
            },
            {
                "command": "nest build --webpack",
                "level": "intermediate",
                "description": "Compila usando webpack builder.",
                "example": "nest build --webpack",
                "expected": "Bundle generado.",
                "note": ""
            },
            {
                "command": "nest g decorator <name>",
                "level": "intermediate",
                "description": "Genera decorador personalizado.",
                "example": "nest g decorator auth/current-user",
                "expected": "CREATE ...current-user.decorator.ts",
                "note": ""
            },
            {
                "command": "nest g filter <name>",
                "level": "intermediate",
                "description": "Genera exception filter.",
                "example": "nest g filter common/http-exception",
                "expected": "CREATE filter.",
                "note": ""
            },
            {
                "command": "nest g gateway <name>",
                "level": "intermediate",
                "description": "Genera WebSocket gateway.",
                "example": "nest g gateway events",
                "expected": "CREATE events.gateway.ts y spec.",
                "note": ""
            },
            {
                "command": "nest g guard <name>",
                "level": "intermediate",
                "description": "Genera un Guard.",
                "example": "nest g guard auth/jwt-auth",
                "expected": "CREATE ...jwt-auth.guard.ts",
                "note": ""
            },
            {
                "command": "nest g interceptor <name>",
                "level": "intermediate",
                "description": "Genera interceptor.",
                "example": "nest g interceptor common/logging",
                "expected": "CREATE ...logging.interceptor.ts",
                "note": ""
            },
            {
                "command": "nest g middleware <name>",
                "level": "intermediate",
                "description": "Genera middleware.",
                "example": "nest g middleware common/request-id",
                "expected": "CREATE middleware.",
                "note": ""
            },
            {
                "command": "nest g pipe <name>",
                "level": "intermediate",
                "description": "Genera Pipe.",
                "example": "nest g pipe common/parse-id",
                "expected": "CREATE ...parse-id.pipe.ts",
                "note": ""
            },
            {
                "command": "nest g provider <name>",
                "level": "intermediate",
                "description": "Genera provider injectable generico.",
                "example": "nest g provider mailer",
                "expected": "CREATE mailer.provider.ts",
                "note": ""
            },
            {
                "command": "nest g resource <name>",
                "level": "intermediate",
                "description": "Genera recurso CRUD mediante asistente.",
                "example": "nest g resource users",
                "expected": "Pregunta transport, CRUD y genera module/controller/service/dto/entities.",
                "note": ""
            },
            {
                "command": "nest info",
                "level": "intermediate",
                "description": "Muestra versiones de Nest, Node y paquetes principales.",
                "example": "nest info",
                "expected": "System Information / NestJS Packages.",
                "note": ""
            },
            {
                "command": "nest start --debug --watch",
                "level": "intermediate",
                "description": "Inicia watch con inspector.",
                "example": "nest start --debug --watch",
                "expected": "Debugger + servidor.",
                "note": ""
            },
            {
                "command": "node dist/main.js",
                "level": "advanced",
                "description": "Ejecuta directamente el build compilado.",
                "example": "node dist/main.js",
                "expected": "Logs de Nest y API escuchando.",
                "note": ""
            },
            {
                "command": "npm run test:cov",
                "level": "advanced",
                "description": "Ejecuta tests con cobertura cuando el script existe.",
                "example": "npm run test:cov",
                "expected": "Tabla de coverage por archivo.",
                "note": ""
            },
            {
                "command": "npm run test:e2e",
                "level": "advanced",
                "description": "Ejecuta suite e2e configurada por el proyecto.",
                "example": "npm run test:e2e",
                "expected": "Jest resumen de suites/tests e2e.",
                "note": ""
            }
        ]
    },
    {
        "id": "docker",
        "group": "devops",
        "title": "Docker",
        "description": "Imagenes, contenedores, redes, volumenes, logs, inspeccion y limpieza.",
        "aliases": [
            "docker",
            "container",
            "containers"
        ],
        "commands": [
            {
                "command": "docker --version",
                "level": "basic",
                "description": "Muestra la version del cliente Docker.",
                "example": "docker --version",
                "expected": "Docker version 27.x.x, build ...",
                "note": ""
            },
            {
                "command": "docker build -t <name:tag> .",
                "level": "basic",
                "description": "Construye una imagen desde Dockerfile.",
                "example": "docker build -t notebook-api:dev .",
                "expected": "Pasos de build y Successfully tagged ...",
                "note": ""
            },
            {
                "command": "docker images",
                "level": "basic",
                "description": "Lista imagenes locales.",
                "example": "docker images",
                "expected": "REPOSITORY TAG IMAGE ID CREATED SIZE.",
                "note": ""
            },
            {
                "command": "docker logs -f --tail 100 <container>",
                "level": "basic",
                "description": "Sigue logs desde ultimas lineas.",
                "example": "docker logs -f --tail 100 api",
                "expected": "Logs en vivo.",
                "note": ""
            },
            {
                "command": "docker logs -f <container>",
                "level": "basic",
                "description": "Sigue logs del contenedor.",
                "example": "docker logs -f api",
                "expected": "Logs historicos recientes y nuevos hasta Ctrl+C.",
                "note": ""
            },
            {
                "command": "docker network ls",
                "level": "basic",
                "description": "Lista redes Docker.",
                "example": "docker network ls",
                "expected": "NETWORK ID NAME DRIVER SCOPE.",
                "note": ""
            },
            {
                "command": "docker ps",
                "level": "basic",
                "description": "Lista contenedores en ejecucion.",
                "example": "docker ps",
                "expected": "CONTAINER ID IMAGE COMMAND STATUS PORTS NAMES.",
                "note": ""
            },
            {
                "command": "docker ps -a",
                "level": "basic",
                "description": "Lista todos los contenedores, incluidos detenidos.",
                "example": "docker ps -a",
                "expected": "Contenedores running/exited/created.",
                "note": ""
            },
            {
                "command": "docker pull <image>",
                "level": "basic",
                "description": "Descarga una imagen del registry.",
                "example": "docker pull postgres:16",
                "expected": "Pull complete / Status: Downloaded newer image ...",
                "note": ""
            },
            {
                "command": "docker restart <container>",
                "level": "basic",
                "description": "Reinicia un contenedor.",
                "example": "docker restart api",
                "expected": "api",
                "note": ""
            },
            {
                "command": "docker rm <container>",
                "level": "basic",
                "description": "Elimina un contenedor detenido.",
                "example": "docker rm api",
                "expected": "api",
                "note": ""
            },
            {
                "command": "docker run --name <name> -p <host>:<container> <image>",
                "level": "basic",
                "description": "Crea y ejecuta un contenedor publicando un puerto.",
                "example": "docker run --name web -p 8080:80 nginx",
                "expected": "ID del contenedor; logs si corre foreground.",
                "note": ""
            },
            {
                "command": "docker run -d <image>",
                "level": "basic",
                "description": "Ejecuta en segundo plano.",
                "example": "docker run -d nginx",
                "expected": "ID largo del contenedor.",
                "note": ""
            },
            {
                "command": "docker start <container>",
                "level": "basic",
                "description": "Inicia un contenedor existente.",
                "example": "docker start api",
                "expected": "api",
                "note": ""
            },
            {
                "command": "docker stop <container>",
                "level": "basic",
                "description": "Solicita detencion ordenada del contenedor.",
                "example": "docker stop api",
                "expected": "api",
                "note": ""
            },
            {
                "command": "docker volume ls",
                "level": "basic",
                "description": "Lista volumenes Docker.",
                "example": "docker volume ls",
                "expected": "DRIVER VOLUME NAME.",
                "note": ""
            },
            {
                "command": "docker build --no-cache -t <name> .",
                "level": "intermediate",
                "description": "Construye ignorando cache de capas.",
                "example": "docker build --no-cache -t notebook-api:dev .",
                "expected": "Todos los pasos se ejecutan nuevamente.",
                "note": ""
            },
            {
                "command": "docker build --no-cache -t api:clean .",
                "level": "intermediate",
                "description": "Build sin cache.",
                "example": "docker build --no-cache -t api:clean .",
                "expected": "Todos los layers reconstruidos.",
                "note": ""
            },
            {
                "command": "docker cp <container>:/app/logs ./logs",
                "level": "intermediate",
                "description": "Copia archivos desde container.",
                "example": "docker cp api:/app/logs ./logs",
                "expected": "Successfully copied...",
                "note": ""
            },
            {
                "command": "docker exec -it <container> sh",
                "level": "intermediate",
                "description": "Abre una shell interactiva dentro de un contenedor.",
                "example": "docker exec -it api sh",
                "expected": "Prompt dentro del contenedor.",
                "note": ""
            },
            {
                "command": "docker history <image>",
                "level": "intermediate",
                "description": "Muestra layers y tamaños.",
                "example": "docker history node:20-alpine",
                "expected": "Layer, comando, tamaño.",
                "note": ""
            },
            {
                "command": "docker info",
                "level": "intermediate",
                "description": "Muestra estado del daemon, storage, runtimes, recursos y configuracion.",
                "example": "docker info",
                "expected": "Containers, Images, Server Version, Storage Driver ...",
                "note": ""
            },
            {
                "command": "docker inspect <container>",
                "level": "intermediate",
                "description": "Devuelve configuracion/estado completo.",
                "example": "docker inspect api",
                "expected": "JSON con State, Config, NetworkSettings, Mounts.",
                "note": ""
            },
            {
                "command": "docker inspect <object>",
                "level": "intermediate",
                "description": "Devuelve JSON detallado de contenedor, imagen, red o volumen.",
                "example": "docker inspect api",
                "expected": "Array JSON con State, Config, NetworkSettings, Mounts ...",
                "note": ""
            },
            {
                "command": "docker load -i api.tar",
                "level": "intermediate",
                "description": "Importa imagen desde tar.",
                "example": "docker load -i api.tar",
                "expected": "Loaded image: ...",
                "note": ""
            },
            {
                "command": "docker network inspect <network>",
                "level": "intermediate",
                "description": "Inspecciona red.",
                "example": "docker network inspect bridge",
                "expected": "Subnet, gateway, containers.",
                "note": ""
            },
            {
                "command": "docker rm -f <container>",
                "level": "intermediate",
                "description": "Fuerza la eliminacion incluso si esta ejecutandose.",
                "example": "docker rm -f api",
                "expected": "api",
                "note": ""
            },
            {
                "command": "docker rmi <image>",
                "level": "intermediate",
                "description": "Elimina una imagen local si no esta en uso.",
                "example": "docker rmi my-api:dev",
                "expected": "Untagged / Deleted ...",
                "note": ""
            },
            {
                "command": "docker save -o api.tar api:1.0",
                "level": "intermediate",
                "description": "Exporta imagen a tar.",
                "example": "docker save -o api.tar api:1.0",
                "expected": "api.tar creado.",
                "note": ""
            },
            {
                "command": "docker stats",
                "level": "intermediate",
                "description": "Monitoriza CPU, memoria y red de contenedores.",
                "example": "docker stats",
                "expected": "Tabla que se actualiza en vivo; Ctrl+C para salir.",
                "note": ""
            },
            {
                "command": "docker system df",
                "level": "intermediate",
                "description": "Muestra espacio consumido por imagenes, contenedores y cache.",
                "example": "docker system df",
                "expected": "TYPE TOTAL ACTIVE SIZE RECLAIMABLE.",
                "note": ""
            },
            {
                "command": "docker top <container>",
                "level": "intermediate",
                "description": "Muestra procesos dentro del container.",
                "example": "docker top api",
                "expected": "PID y comando.",
                "note": ""
            },
            {
                "command": "docker volume inspect <volume>",
                "level": "intermediate",
                "description": "Inspecciona un volume.",
                "example": "docker volume inspect pgdata",
                "expected": "JSON con mountpoint/options.",
                "note": ""
            },
            {
                "command": "docker build --target development -t api:dev .",
                "level": "advanced",
                "description": "Construye target de multi-stage.",
                "example": "docker build --target development -t api:dev .",
                "expected": "Imagen del stage.",
                "note": ""
            },
            {
                "command": "docker buildx build --platform linux/amd64,linux/arm64 -t org/app:1.0 --push .",
                "level": "advanced",
                "description": "Build multi-arquitectura y publica.",
                "example": "docker buildx build --platform linux/amd64,linux/arm64 -t org/app:1.0 --push .",
                "expected": "Build y manifest publicado.",
                "note": ""
            },
            {
                "command": "docker diff <container>",
                "level": "advanced",
                "description": "Muestra cambios del filesystem del container.",
                "example": "docker diff api",
                "expected": "A/C/D + ruta.",
                "note": ""
            },
            {
                "command": "docker image prune -a",
                "level": "advanced",
                "description": "Elimina imagenes no usadas.",
                "example": "docker image prune -a",
                "expected": "Imagenes eliminadas y espacio.",
                "note": "Puede requerir re-pull/rebuild."
            },
            {
                "command": "docker system df -v",
                "level": "advanced",
                "description": "Detalla uso de disco Docker.",
                "example": "docker system df -v",
                "expected": "Uso por image/container/volume/cache.",
                "note": ""
            },
            {
                "command": "docker system prune",
                "level": "advanced",
                "description": "Elimina recursos no utilizados.",
                "example": "docker system prune",
                "expected": "Lista recursos y pide confirmacion; muestra Total reclaimed space.",
                "note": "Revisa antes: puede borrar cache, redes y contenedores detenidos."
            },
            {
                "command": "docker system prune -a --volumes",
                "level": "advanced",
                "description": "Limpieza agresiva incluyendo imagenes no usadas y volumenes.",
                "example": "docker system prune -a --volumes",
                "expected": "Muestra recursos eliminados y espacio recuperado.",
                "note": "Muy destructivo para entornos locales con volumenes importantes."
            },
            {
                "command": "docker volume prune",
                "level": "advanced",
                "description": "Elimina volumes no usados.",
                "example": "docker volume prune",
                "expected": "Volumes borrados.",
                "note": "Puede borrar datos persistentes no referenciados."
            }
        ]
    },
    {
        "id": "compose",
        "group": "devops",
        "title": "Docker Compose",
        "description": "Stacks multi-contenedor con compose.yaml: lifecycle, logs, build y diagnostico.",
        "aliases": [
            "docker compose",
            "compose",
            "docker-compose"
        ],
        "commands": [
            {
                "command": "docker compose down",
                "level": "basic",
                "description": "Detiene y elimina contenedores/red creada por Compose.",
                "example": "docker compose down",
                "expected": "Stopping/Removing ... Network ... Removed.",
                "note": ""
            },
            {
                "command": "docker compose logs -f",
                "level": "basic",
                "description": "Sigue logs combinados.",
                "example": "docker compose logs -f",
                "expected": "service | log line ...",
                "note": ""
            },
            {
                "command": "docker compose logs -f <service>",
                "level": "basic",
                "description": "Sigue logs de un servicio concreto.",
                "example": "docker compose logs -f api",
                "expected": "api | ...",
                "note": ""
            },
            {
                "command": "docker compose ps",
                "level": "basic",
                "description": "Muestra estado de servicios.",
                "example": "docker compose ps",
                "expected": "NAME IMAGE COMMAND SERVICE CREATED STATUS PORTS.",
                "note": ""
            },
            {
                "command": "docker compose pull",
                "level": "basic",
                "description": "Descarga imagenes definidas en el compose.",
                "example": "docker compose pull",
                "expected": "Pulling/Downloaded por servicio.",
                "note": ""
            },
            {
                "command": "docker compose restart <service>",
                "level": "basic",
                "description": "Reinicia un servicio.",
                "example": "docker compose restart api",
                "expected": "Restarting api ... Started.",
                "note": ""
            },
            {
                "command": "docker compose up",
                "level": "basic",
                "description": "Crea/inicia servicios y muestra logs en foreground.",
                "example": "docker compose up",
                "expected": "Logs combinados de los servicios.",
                "note": ""
            },
            {
                "command": "docker compose up -d",
                "level": "basic",
                "description": "Levanta servicios en segundo plano.",
                "example": "docker compose up -d",
                "expected": "[+] Running N/N ... Started.",
                "note": ""
            },
            {
                "command": "docker compose build --no-cache",
                "level": "intermediate",
                "description": "Reconstruye servicios sin cache.",
                "example": "docker compose build --no-cache",
                "expected": "Pasos completos de build.",
                "note": ""
            },
            {
                "command": "docker compose config",
                "level": "intermediate",
                "description": "Valida y muestra configuracion Compose resuelta.",
                "example": "docker compose config",
                "expected": "YAML normalizado con variables/interpolaciones resueltas.",
                "note": ""
            },
            {
                "command": "docker compose exec <service> sh",
                "level": "intermediate",
                "description": "Abre shell en un servicio en ejecucion.",
                "example": "docker compose exec api sh",
                "expected": "Prompt dentro del contenedor del servicio.",
                "note": ""
            },
            {
                "command": "docker compose up -d --build",
                "level": "intermediate",
                "description": "Reconstruye imagenes y levanta el stack.",
                "example": "docker compose up -d --build",
                "expected": "Build steps y luego servicios Started.",
                "note": ""
            },
            {
                "command": "docker compose down -v",
                "level": "advanced",
                "description": "Tambien elimina volumenes declarados/anexos del proyecto.",
                "example": "docker compose down -v",
                "expected": "Removing volume ...",
                "note": "Puede borrar datos persistentes como bases de datos."
            },
            {
                "command": "docker compose run --rm <service> <cmd>",
                "level": "advanced",
                "description": "Ejecuta un comando one-off y elimina el contenedor al terminar.",
                "example": "docker compose run --rm api npm run migration",
                "expected": "Salida del comando y contenedor temporal eliminado.",
                "note": ""
            }
        ]
    },
    {
        "id": "kubernetes",
        "group": "devops",
        "title": "Kubernetes / kubectl",
        "description": "Clusters, pods, deployments, servicios, logs, rollout y diagnostico.",
        "aliases": [
            "kubernetes",
            "kubectl",
            "k8s"
        ],
        "commands": [
            {
                "command": "kubectl apply -f <file>",
                "level": "basic",
                "description": "Crea o actualiza recursos declarativos.",
                "example": "kubectl apply -f deployment.yaml",
                "expected": "deployment.apps/api configured/created.",
                "note": ""
            },
            {
                "command": "kubectl config current-context",
                "level": "basic",
                "description": "Muestra el contexto activo.",
                "example": "kubectl config current-context",
                "expected": "nombre-del-contexto",
                "note": ""
            },
            {
                "command": "kubectl config get-contexts",
                "level": "basic",
                "description": "Lista contextos configurados.",
                "example": "kubectl config get-contexts",
                "expected": "CURRENT NAME CLUSTER AUTHINFO NAMESPACE.",
                "note": ""
            },
            {
                "command": "kubectl get all",
                "level": "basic",
                "description": "Lista recursos principales del namespace.",
                "example": "kubectl get all",
                "expected": "Pods, services, deployments, replicasets, etc.",
                "note": ""
            },
            {
                "command": "kubectl get pods",
                "level": "basic",
                "description": "Lista pods del namespace actual.",
                "example": "kubectl get pods",
                "expected": "NAME READY STATUS RESTARTS AGE.",
                "note": ""
            },
            {
                "command": "kubectl get pods -A",
                "level": "basic",
                "description": "Lista pods de todos los namespaces.",
                "example": "kubectl get pods -A",
                "expected": "NAMESPACE NAME READY STATUS ...",
                "note": ""
            },
            {
                "command": "kubectl get pods -o wide",
                "level": "basic",
                "description": "Lista pods con IP y nodo.",
                "example": "kubectl get pods -o wide",
                "expected": "IP, NODE y detalles.",
                "note": ""
            },
            {
                "command": "kubectl logs -f <pod>",
                "level": "basic",
                "description": "Sigue logs en tiempo real.",
                "example": "kubectl logs -f api-abc123",
                "expected": "Flujo de logs hasta Ctrl+C.",
                "note": ""
            },
            {
                "command": "kubectl logs <pod>",
                "level": "basic",
                "description": "Muestra logs de un pod con un contenedor.",
                "example": "kubectl logs api-abc123",
                "expected": "Logs de la aplicacion.",
                "note": ""
            },
            {
                "command": "kubectl rollout status deployment/api",
                "level": "basic",
                "description": "Observa rollout.",
                "example": "kubectl rollout status deployment/api",
                "expected": "Successfully rolled out o progreso.",
                "note": ""
            },
            {
                "command": "kubectl version --client",
                "level": "basic",
                "description": "Muestra version del cliente kubectl.",
                "example": "kubectl version --client",
                "expected": "Client Version: v1.x.x ...",
                "note": ""
            },
            {
                "command": "kubectl config use-context <context>",
                "level": "intermediate",
                "description": "Cambia el contexto activo.",
                "example": "kubectl config use-context minikube",
                "expected": "Switched to context \"minikube\".",
                "note": ""
            },
            {
                "command": "kubectl delete -f <file>",
                "level": "intermediate",
                "description": "Elimina recursos definidos en un manifiesto.",
                "example": "kubectl delete -f deployment.yaml",
                "expected": "deployment.apps \"api\" deleted.",
                "note": ""
            },
            {
                "command": "kubectl describe pod <pod>",
                "level": "intermediate",
                "description": "Muestra estado, eventos, probes, volumenes y contenedores de un pod.",
                "example": "kubectl describe pod api-abc123",
                "expected": "Name, Namespace, Containers, Conditions, Events.",
                "note": ""
            },
            {
                "command": "kubectl diff -f k8s/",
                "level": "intermediate",
                "description": "Previsualiza cambios de manifests.",
                "example": "kubectl diff -f k8s/",
                "expected": "Diff de recursos.",
                "note": ""
            },
            {
                "command": "kubectl exec -it <pod> -- sh",
                "level": "intermediate",
                "description": "Abre shell en un pod.",
                "example": "kubectl exec -it api-abc123 -- sh",
                "expected": "Prompt dentro del contenedor.",
                "note": ""
            },
            {
                "command": "kubectl explain deployment.spec.strategy",
                "level": "intermediate",
                "description": "Muestra documentacion del schema.",
                "example": "kubectl explain deployment.spec.strategy",
                "expected": "FIELD y DESCRIPTION.",
                "note": ""
            },
            {
                "command": "kubectl get deployment api -o yaml",
                "level": "intermediate",
                "description": "Obtiene recurso actual como YAML.",
                "example": "kubectl get deployment api -o yaml",
                "expected": "Manifest completo.",
                "note": ""
            },
            {
                "command": "kubectl get events --sort-by=.metadata.creationTimestamp",
                "level": "intermediate",
                "description": "Lista eventos ordenados.",
                "example": "kubectl get events --sort-by=.metadata.creationTimestamp",
                "expected": "Eventos recientes.",
                "note": ""
            },
            {
                "command": "kubectl logs -f <pod> -c <container> --tail=100",
                "level": "intermediate",
                "description": "Sigue logs de container especifico.",
                "example": "kubectl logs -f api-abc -c api --tail=100",
                "expected": "Logs en vivo.",
                "note": ""
            },
            {
                "command": "kubectl logs <pod> --previous",
                "level": "intermediate",
                "description": "Muestra logs de instancia anterior.",
                "example": "kubectl logs api-abc --previous",
                "expected": "Logs previos.",
                "note": ""
            },
            {
                "command": "kubectl logs <pod> -c <container>",
                "level": "intermediate",
                "description": "Muestra logs de un contenedor especifico.",
                "example": "kubectl logs api-abc123 -c api",
                "expected": "Logs solo del contenedor api.",
                "note": ""
            },
            {
                "command": "kubectl port-forward svc/<service> <local>:<remote>",
                "level": "intermediate",
                "description": "Expone temporalmente un servicio al equipo local.",
                "example": "kubectl port-forward svc/api 4000:4000",
                "expected": "Forwarding from 127.0.0.1:4000 -> 4000.",
                "note": ""
            },
            {
                "command": "kubectl port-forward svc/postgres 5432:5432",
                "level": "intermediate",
                "description": "Tuneliza un Service a localhost.",
                "example": "kubectl port-forward svc/postgres 5432:5432",
                "expected": "Forwarding from 127.0.0.1:5432.",
                "note": ""
            },
            {
                "command": "kubectl rollout history deployment/<name>",
                "level": "intermediate",
                "description": "Muestra revisiones de un deployment.",
                "example": "kubectl rollout history deployment/api",
                "expected": "REVISION CHANGE-CAUSE.",
                "note": ""
            },
            {
                "command": "kubectl rollout history deployment/api",
                "level": "intermediate",
                "description": "Muestra revisiones.",
                "example": "kubectl rollout history deployment/api",
                "expected": "REVISION y CHANGE-CAUSE.",
                "note": ""
            },
            {
                "command": "kubectl rollout status deployment/<name>",
                "level": "intermediate",
                "description": "Espera y reporta estado del rollout.",
                "example": "kubectl rollout status deployment/api",
                "expected": "deployment \"api\" successfully rolled out.",
                "note": ""
            },
            {
                "command": "kubectl scale deployment <name> --replicas=<n>",
                "level": "intermediate",
                "description": "Cambia replicas de un deployment.",
                "example": "kubectl scale deployment api --replicas=3",
                "expected": "deployment.apps/api scaled.",
                "note": ""
            },
            {
                "command": "kubectl scale deployment/api --replicas=4",
                "level": "intermediate",
                "description": "Cambia replicas.",
                "example": "kubectl scale deployment/api --replicas=4",
                "expected": "scaled.",
                "note": ""
            },
            {
                "command": "kubectl set image deployment/api api=org/api:2.0",
                "level": "intermediate",
                "description": "Actualiza imagen.",
                "example": "kubectl set image deployment/api api=org/api:2.0",
                "expected": "image updated.",
                "note": ""
            },
            {
                "command": "kubectl auth can-i --list",
                "level": "advanced",
                "description": "Lista permisos RBAC efectivos.",
                "example": "kubectl auth can-i --list",
                "expected": "Recursos y verbs.",
                "note": ""
            },
            {
                "command": "kubectl drain node-1 --ignore-daemonsets --delete-emptydir-data",
                "level": "advanced",
                "description": "Evacua pods de un nodo.",
                "example": "kubectl drain node-1 --ignore-daemonsets --delete-emptydir-data",
                "expected": "Evictions y node drained.",
                "note": "Operacion disruptiva."
            },
            {
                "command": "kubectl rollout undo deployment/<name>",
                "level": "advanced",
                "description": "Revierte a la revision anterior.",
                "example": "kubectl rollout undo deployment/api",
                "expected": "deployment.apps/api rolled back.",
                "note": ""
            },
            {
                "command": "kubectl rollout undo deployment/api",
                "level": "advanced",
                "description": "Revierte deployment.",
                "example": "kubectl rollout undo deployment/api",
                "expected": "rolled back.",
                "note": ""
            },
            {
                "command": "kubectl top pods",
                "level": "advanced",
                "description": "Muestra CPU/memoria si metrics-server esta disponible.",
                "example": "kubectl top pods",
                "expected": "NAME CPU(cores) MEMORY(bytes).",
                "note": ""
            },
            {
                "command": "kubectl uncordon node-1",
                "level": "advanced",
                "description": "Vuelve schedulable un nodo.",
                "example": "kubectl uncordon node-1",
                "expected": "node uncordoned.",
                "note": ""
            }
        ]
    },
    {
        "id": "terraform",
        "group": "devops",
        "title": "Terraform",
        "description": "Infraestructura como codigo: init, plan, apply, state, imports y diagnostico.",
        "aliases": [
            "terraform",
            "iac",
            "infrastructure as code"
        ],
        "commands": [
            {
                "command": "terraform fmt",
                "level": "basic",
                "description": "Formatea archivos .tf del directorio.",
                "example": "terraform fmt",
                "expected": "Nombres de archivos modificados o sin salida.",
                "note": ""
            },
            {
                "command": "terraform init",
                "level": "basic",
                "description": "Inicializa providers, backend y modulos.",
                "example": "terraform init",
                "expected": "Terraform has been successfully initialized!",
                "note": ""
            },
            {
                "command": "terraform output",
                "level": "basic",
                "description": "Muestra outputs del estado.",
                "example": "terraform output",
                "expected": "name = value",
                "note": ""
            },
            {
                "command": "terraform plan",
                "level": "basic",
                "description": "Calcula cambios sin aplicarlos.",
                "example": "terraform plan",
                "expected": "Plan: N to add, N to change, N to destroy.",
                "note": ""
            },
            {
                "command": "terraform validate",
                "level": "basic",
                "description": "Valida sintaxis y consistencia interna.",
                "example": "terraform validate",
                "expected": "Success! The configuration is valid.",
                "note": ""
            },
            {
                "command": "terraform version",
                "level": "basic",
                "description": "Muestra version de Terraform y plataforma.",
                "example": "terraform version",
                "expected": "Terraform v1.x.x on windows_amd64/linux_amd64.",
                "note": ""
            },
            {
                "command": "terraform apply",
                "level": "intermediate",
                "description": "Calcula y aplica cambios tras confirmacion.",
                "example": "terraform apply",
                "expected": "Plan + prompt yes; Apply complete! Resources: ...",
                "note": ""
            },
            {
                "command": "terraform apply tfplan",
                "level": "intermediate",
                "description": "Aplica un plan guardado sin recalcularlo.",
                "example": "terraform apply tfplan",
                "expected": "Apply complete! Resources: ...",
                "note": ""
            },
            {
                "command": "terraform fmt -check -recursive",
                "level": "intermediate",
                "description": "Comprueba formato sin modificar.",
                "example": "terraform fmt -check -recursive",
                "expected": "Rutas mal formateadas o exit 0.",
                "note": ""
            },
            {
                "command": "terraform fmt -recursive",
                "level": "intermediate",
                "description": "Formatea .tf recursivamente.",
                "example": "terraform fmt -recursive",
                "expected": "Lista archivos reformateados.",
                "note": ""
            },
            {
                "command": "terraform init -upgrade",
                "level": "intermediate",
                "description": "Actualiza módulos/providers dentro de constraints.",
                "example": "terraform init -upgrade",
                "expected": "Providers/modules actualizados.",
                "note": ""
            },
            {
                "command": "terraform output -json",
                "level": "intermediate",
                "description": "Exporta outputs como JSON.",
                "example": "terraform output -json",
                "expected": "JSON.",
                "note": ""
            },
            {
                "command": "terraform plan -out=tfplan",
                "level": "intermediate",
                "description": "Guarda el plan binario para aplicarlo exactamente.",
                "example": "terraform plan -out=tfplan",
                "expected": "Saved the plan to: tfplan.",
                "note": ""
            },
            {
                "command": "terraform providers",
                "level": "intermediate",
                "description": "Muestra requisitos/árbol de providers.",
                "example": "terraform providers",
                "expected": "Providers required by configuration/state.",
                "note": ""
            },
            {
                "command": "terraform show tfplan",
                "level": "intermediate",
                "description": "Muestra un plan guardado.",
                "example": "terraform show tfplan",
                "expected": "Plan legible.",
                "note": ""
            },
            {
                "command": "terraform state list",
                "level": "intermediate",
                "description": "Lista direcciones de recursos en state.",
                "example": "terraform state list",
                "expected": "module.app.aws_instance.web ...",
                "note": ""
            },
            {
                "command": "terraform workspace list",
                "level": "intermediate",
                "description": "Lista workspaces.",
                "example": "terraform workspace list",
                "expected": "Workspaces y actual marcado con *.",
                "note": ""
            },
            {
                "command": "terraform workspace new <name>",
                "level": "intermediate",
                "description": "Crea workspace.",
                "example": "terraform workspace new staging",
                "expected": "Created and switched to workspace.",
                "note": ""
            },
            {
                "command": "terraform apply -auto-approve",
                "level": "advanced",
                "description": "Aplica sin confirmación interactiva.",
                "example": "terraform apply -auto-approve",
                "expected": "Cambios aplicados.",
                "note": "Usar con extremo cuidado, especialmente en CI."
            },
            {
                "command": "terraform console",
                "level": "advanced",
                "description": "Abre REPL para expresiones HCL.",
                "example": "terraform console",
                "expected": "Prompt > y resultados.",
                "note": ""
            },
            {
                "command": "terraform destroy",
                "level": "advanced",
                "description": "Destruye recursos gestionados tras confirmacion.",
                "example": "terraform destroy",
                "expected": "Plan de destruccion + prompt; Destroy complete!",
                "note": "Operacion destructiva."
            },
            {
                "command": "terraform force-unlock <lock-id>",
                "level": "advanced",
                "description": "Libera lock de state atascado.",
                "example": "terraform force-unlock 1234-...",
                "expected": "State lock released.",
                "note": "Confirmar que ningún apply real esté corriendo."
            },
            {
                "command": "terraform import <address> <id>",
                "level": "advanced",
                "description": "Asocia un recurso existente al state.",
                "example": "terraform import aws_s3_bucket.logs my-existing-bucket",
                "expected": "Import successful!",
                "note": ""
            },
            {
                "command": "terraform show -json tfplan",
                "level": "advanced",
                "description": "Exporta plan a JSON para automatización.",
                "example": "terraform show -json tfplan > plan.json",
                "expected": "JSON del plan.",
                "note": ""
            },
            {
                "command": "terraform state mv <source> <dest>",
                "level": "advanced",
                "description": "Mueve dirección dentro del state sin recrear infraestructura.",
                "example": "terraform state mv aws_instance.old aws_instance.web",
                "expected": "Successfully moved ...",
                "note": ""
            },
            {
                "command": "terraform state rm <address>",
                "level": "advanced",
                "description": "Deja de gestionar un recurso sin destruirlo.",
                "example": "terraform state rm aws_s3_bucket.legacy",
                "expected": "Removed ...",
                "note": "El recurso queda real pero fuera del state."
            },
            {
                "command": "terraform state show <address>",
                "level": "advanced",
                "description": "Muestra atributos almacenados de un recurso.",
                "example": "terraform state show aws_instance.web",
                "expected": "Bloque con atributos del recurso.",
                "note": ""
            }
        ]
    },
    {
        "id": "aws",
        "group": "cloud",
        "title": "AWS CLI",
        "description": "Identidad, S3, EC2, logs, parametros y diagnostico basico de AWS CLI.",
        "aliases": [
            "aws",
            "aws cli",
            "amazon web services"
        ],
        "commands": [
            {
                "command": "aws --version",
                "level": "basic",
                "description": "Muestra version de AWS CLI.",
                "example": "aws --version",
                "expected": "aws-cli/2.x.x Python/...",
                "note": ""
            },
            {
                "command": "aws configure",
                "level": "basic",
                "description": "Configura access key, secret, region y output en el perfil default.",
                "example": "aws configure",
                "expected": "Prompts AWS Access Key ID, Secret, region, output.",
                "note": ""
            },
            {
                "command": "aws configure list",
                "level": "basic",
                "description": "Muestra de donde se resuelven credenciales y region.",
                "example": "aws configure list",
                "expected": "Name Value Type Location.",
                "note": ""
            },
            {
                "command": "aws configure list-profiles",
                "level": "basic",
                "description": "Lista perfiles locales configurados.",
                "example": "aws configure list-profiles",
                "expected": "default\nwork\nproduction",
                "note": ""
            },
            {
                "command": "aws s3 cp <file> s3://<bucket>/<key>",
                "level": "basic",
                "description": "Sube archivo a S3.",
                "example": "aws s3 cp build.zip s3://releases/app.zip",
                "expected": "upload: ... to s3://...",
                "note": ""
            },
            {
                "command": "aws s3 cp <src> <dst>",
                "level": "basic",
                "description": "Copia archivo local/S3 en cualquier direccion.",
                "example": "aws s3 cp release.zip s3://my-bucket/releases/release.zip",
                "expected": "upload: ./release.zip to s3://...",
                "note": ""
            },
            {
                "command": "aws s3 ls",
                "level": "basic",
                "description": "Lista buckets accesibles.",
                "example": "aws s3 ls",
                "expected": "fecha hora bucket-name.",
                "note": ""
            },
            {
                "command": "aws s3 ls s3://<bucket>/ --recursive",
                "level": "basic",
                "description": "Lista objetos recursivamente.",
                "example": "aws s3 ls s3://my-bucket/backups/ --recursive",
                "expected": "Fecha, tamaño, key.",
                "note": ""
            },
            {
                "command": "aws s3 ls s3://<bucket>/<prefix>",
                "level": "basic",
                "description": "Lista objetos bajo un prefijo.",
                "example": "aws s3 ls s3://my-bucket/backups/",
                "expected": "fecha tamano nombre.",
                "note": ""
            },
            {
                "command": "aws sts get-caller-identity",
                "level": "basic",
                "description": "Confirma que identidad AWS esta usando la CLI.",
                "example": "aws sts get-caller-identity",
                "expected": "JSON con UserId, Account y Arn.",
                "note": ""
            },
            {
                "command": "aws cloudformation describe-stacks --stack-name <name>",
                "level": "intermediate",
                "description": "Muestra estado/outputs de stack.",
                "example": "aws cloudformation describe-stacks --stack-name notebook-prod",
                "expected": "JSON Stacks.",
                "note": ""
            },
            {
                "command": "aws ec2 describe-instances",
                "level": "intermediate",
                "description": "Lista detalles de instancias EC2 visibles.",
                "example": "aws ec2 describe-instances",
                "expected": "JSON Reservations/Instances.",
                "note": ""
            },
            {
                "command": "aws ec2 describe-instances --query \"Reservations[].Instances[].{Id:InstanceId,State:State.Name,IP:PublicIpAddress}\" --output table",
                "level": "intermediate",
                "description": "Resume EC2 en tabla.",
                "example": "aws ec2 describe-instances --query \"Reservations[].Instances[].{Id:InstanceId,State:State.Name}\" --output table",
                "expected": "Tabla legible.",
                "note": ""
            },
            {
                "command": "aws ecr describe-images --repository-name <repo>",
                "level": "intermediate",
                "description": "Lista imágenes/tags/digests ECR.",
                "example": "aws ecr describe-images --repository-name api",
                "expected": "JSON imageDetails.",
                "note": ""
            },
            {
                "command": "aws iam get-user",
                "level": "intermediate",
                "description": "Muestra usuario IAM de credenciales user.",
                "example": "aws iam get-user",
                "expected": "JSON User o error si usa role.",
                "note": ""
            },
            {
                "command": "aws lambda list-functions",
                "level": "intermediate",
                "description": "Lista funciones Lambda.",
                "example": "aws lambda list-functions",
                "expected": "JSON con Functions.",
                "note": ""
            },
            {
                "command": "aws logs tail <group> --follow",
                "level": "intermediate",
                "description": "Sigue CloudWatch Logs de un log group.",
                "example": "aws logs tail /aws/lambda/my-fn --follow",
                "expected": "Eventos con timestamp hasta Ctrl+C.",
                "note": ""
            },
            {
                "command": "aws logs tail <log-group> --follow",
                "level": "intermediate",
                "description": "Sigue CloudWatch Logs.",
                "example": "aws logs tail /aws/lambda/api --follow",
                "expected": "Eventos en vivo.",
                "note": ""
            },
            {
                "command": "aws s3 sync <src> <dst>",
                "level": "intermediate",
                "description": "Sincroniza directorios local/S3.",
                "example": "aws s3 sync ./dist s3://my-bucket/site/",
                "expected": "upload/delete lines segun cambios.",
                "note": ""
            },
            {
                "command": "aws secretsmanager list-secrets",
                "level": "intermediate",
                "description": "Lista metadata de secrets.",
                "example": "aws secretsmanager list-secrets",
                "expected": "ARN/Name/description; no valores.",
                "note": ""
            },
            {
                "command": "aws sts get-caller-identity --profile <profile>",
                "level": "intermediate",
                "description": "Verifica identidad de un perfil especifico.",
                "example": "aws sts get-caller-identity --profile production",
                "expected": "JSON con Account/Arn del perfil.",
                "note": ""
            },
            {
                "command": "aws cloudformation describe-stack-events --stack-name <name>",
                "level": "advanced",
                "description": "Diagnostica eventos/fallos de deploy.",
                "example": "aws cloudformation describe-stack-events --stack-name notebook-prod",
                "expected": "Eventos ordenados.",
                "note": ""
            },
            {
                "command": "aws ec2 describe-instances --query \"Reservations[].Instances[].{Id:InstanceId,State:State.Name}\" --output table",
                "level": "advanced",
                "description": "Filtra instancias con JMESPath y salida tabla.",
                "example": "aws ec2 describe-instances --query \"Reservations[].Instances[].{Id:InstanceId,State:State.Name}\" --output table",
                "expected": "Tabla con Id y State.",
                "note": ""
            },
            {
                "command": "aws ecr get-login-password --region <region> | docker login --username AWS --password-stdin <registry>",
                "level": "advanced",
                "description": "Autentica Docker contra ECR sin exponer password en argumentos.",
                "example": "aws ecr get-login-password --region us-east-1 | docker login --username AWS --password-stdin 123456789.dkr.ecr.us-east-1.amazonaws.com",
                "expected": "Login Succeeded.",
                "note": ""
            },
            {
                "command": "aws lambda invoke --function-name <name> --payload <base64-or-json> out.json",
                "level": "advanced",
                "description": "Invoca Lambda manualmente.",
                "example": "aws lambda invoke --function-name health out.json",
                "expected": "StatusCode y archivo out.json.",
                "note": ""
            },
            {
                "command": "aws s3 sync <dir> s3://<bucket>/<prefix> --delete",
                "level": "advanced",
                "description": "Sincroniza directorio y elimina objetos sobrantes.",
                "example": "aws s3 sync dist s3://site/ --delete",
                "expected": "upload/delete lines.",
                "note": "Revisar destino; --delete es destructivo."
            },
            {
                "command": "aws secretsmanager get-secret-value --secret-id <name>",
                "level": "advanced",
                "description": "Recupera valor de un secret autorizado.",
                "example": "aws secretsmanager get-secret-value --secret-id notebook/prod/db",
                "expected": "JSON SecretString/SecretBinary.",
                "note": "Evitar imprimir secretos en logs/terminal compartida."
            },
            {
                "command": "aws ssm get-parameter --name <name> --with-decryption",
                "level": "advanced",
                "description": "Lee un parametro SSM SecureString desencriptado si tenes permiso.",
                "example": "aws ssm get-parameter --name /app/db/url --with-decryption",
                "expected": "JSON Parameter con Value.",
                "note": "Evita imprimir secretos en logs compartidos."
            }
        ]
    },
    {
        "id": "github",
        "group": "version-control",
        "title": "GitHub CLI / gh",
        "description": "Repos, pull requests, issues, releases, workflows y autenticacion desde terminal.",
        "aliases": [
            "github cli",
            "gh",
            "github"
        ],
        "commands": [
            {
                "command": "gh --version",
                "level": "basic",
                "description": "Muestra version de GitHub CLI.",
                "example": "gh --version",
                "expected": "gh version 2.x.x ...",
                "note": ""
            },
            {
                "command": "gh auth login",
                "level": "basic",
                "description": "Inicia flujo de autenticacion con GitHub.",
                "example": "gh auth login",
                "expected": "Asistente de host, protocolo y metodo de autenticacion.",
                "note": ""
            },
            {
                "command": "gh auth status",
                "level": "basic",
                "description": "Muestra cuentas autenticadas y scopes.",
                "example": "gh auth status",
                "expected": "Logged in to github.com account ...",
                "note": ""
            },
            {
                "command": "gh issue create",
                "level": "basic",
                "description": "Abre asistente para crear issue.",
                "example": "gh issue create",
                "expected": "Prompts y URL del issue creado.",
                "note": ""
            },
            {
                "command": "gh issue list",
                "level": "basic",
                "description": "Lista issues.",
                "example": "gh issue list",
                "expected": "ID TITLE LABELS UPDATED.",
                "note": ""
            },
            {
                "command": "gh pr list",
                "level": "basic",
                "description": "Lista pull requests.",
                "example": "gh pr list",
                "expected": "ID TITLE BRANCH AUTHOR STATE.",
                "note": ""
            },
            {
                "command": "gh pr status",
                "level": "basic",
                "description": "Resume PRs relevantes para el repositorio y usuario.",
                "example": "gh pr status",
                "expected": "Current branch, Created by you, Requesting a code review.",
                "note": ""
            },
            {
                "command": "gh pr view <number>",
                "level": "basic",
                "description": "Muestra detalle de una PR.",
                "example": "gh pr view 42",
                "expected": "Titulo, estado, autor, body, checks/reviews.",
                "note": ""
            },
            {
                "command": "gh repo clone <owner/repo>",
                "level": "basic",
                "description": "Clona un repositorio por identificador GitHub.",
                "example": "gh repo clone openai/example",
                "expected": "Cloning into ... y progreso Git.",
                "note": ""
            },
            {
                "command": "gh repo view --web",
                "level": "basic",
                "description": "Abre el repositorio actual en el navegador.",
                "example": "gh repo view --web",
                "expected": "Opening github.com/... in your browser.",
                "note": ""
            },
            {
                "command": "gh pr checkout <number>",
                "level": "intermediate",
                "description": "Trae y cambia a la rama de una PR.",
                "example": "gh pr checkout 42",
                "expected": "Switched to branch ...",
                "note": ""
            },
            {
                "command": "gh pr create --fill",
                "level": "intermediate",
                "description": "Crea PR usando titulo/body desde commits cuando es posible.",
                "example": "gh pr create --fill",
                "expected": "URL de la pull request creada.",
                "note": ""
            },
            {
                "command": "gh run list",
                "level": "intermediate",
                "description": "Lista ejecuciones recientes de GitHub Actions.",
                "example": "gh run list",
                "expected": "STATUS TITLE WORKFLOW BRANCH EVENT ID ELAPSED AGE.",
                "note": ""
            },
            {
                "command": "gh run watch <id>",
                "level": "intermediate",
                "description": "Sigue una ejecucion de Actions hasta finalizar.",
                "example": "gh run watch 123456789",
                "expected": "Jobs/steps actualizandose y resultado final.",
                "note": ""
            },
            {
                "command": "gh pr merge <number> --squash",
                "level": "advanced",
                "description": "Fusiona una PR mediante squash.",
                "example": "gh pr merge 42 --squash",
                "expected": "Confirmacion/progreso; PR merged.",
                "note": ""
            },
            {
                "command": "gh release create <tag> <files>",
                "level": "advanced",
                "description": "Crea release y adjunta archivos.",
                "example": "gh release create v1.2.0 dist/app.zip --generate-notes",
                "expected": "URL de la release creada.",
                "note": ""
            },
            {
                "command": "gh workflow run <workflow>",
                "level": "advanced",
                "description": "Dispara workflow_dispatch.",
                "example": "gh workflow run deploy.yml -f environment=staging",
                "expected": "Created workflow_dispatch event ...",
                "note": ""
            }
        ]
    },
    {
        "id": "ssh",
        "group": "access-network",
        "title": "SSH / SCP / rsync",
        "description": "Acceso remoto, transferencia segura, llaves, tunnels y sincronizacion.",
        "aliases": [
            "ssh",
            "scp",
            "rsync",
            "remote"
        ],
        "commands": [
            {
                "command": "scp -r <dir> <user>@<host>:<path>",
                "level": "basic",
                "description": "Copia directorio recursivamente.",
                "example": "scp -r dist deploy@server:/var/www/app",
                "expected": "Progreso de archivos.",
                "note": ""
            },
            {
                "command": "scp -r <folder> <user>@<host>:<path>",
                "level": "basic",
                "description": "Copia una carpeta recursivamente.",
                "example": "scp -r dist deploy@example.com:/srv/app/",
                "expected": "Progreso por archivo.",
                "note": ""
            },
            {
                "command": "scp <file> <user>@<host>:<path>",
                "level": "basic",
                "description": "Copia un archivo al servidor por SSH.",
                "example": "scp release.zip deploy@example.com:/tmp/",
                "expected": "Progreso 100% y velocidad.",
                "note": ""
            },
            {
                "command": "scp <user>@<host>:<file> .",
                "level": "basic",
                "description": "Descarga un archivo remoto.",
                "example": "scp deploy@example.com:/var/log/app.log .",
                "expected": "Progreso y archivo local creado.",
                "note": ""
            },
            {
                "command": "ssh -p <port> <user>@<host>",
                "level": "basic",
                "description": "Conecta a un puerto SSH no estandar.",
                "example": "ssh -p 2222 deploy@example.com",
                "expected": "Sesion remota si el puerto responde.",
                "note": ""
            },
            {
                "command": "ssh -V",
                "level": "basic",
                "description": "Muestra versión OpenSSH client.",
                "example": "ssh -V",
                "expected": "OpenSSH_x.x, OpenSSL...",
                "note": ""
            },
            {
                "command": "ssh <user>@<host>",
                "level": "basic",
                "description": "Abre una sesion SSH remota.",
                "example": "ssh deploy@example.com",
                "expected": "Prompt remoto tras autenticacion; primer acceso puede pedir confirmar fingerprint.",
                "note": ""
            },
            {
                "command": "ssh-add -l",
                "level": "basic",
                "description": "Lista identidades cargadas en ssh-agent.",
                "example": "ssh-add -l",
                "expected": "fingerprint tipo comentario por clave.",
                "note": ""
            },
            {
                "command": "ssh-keygen -t ed25519 -C \"<email>\"",
                "level": "basic",
                "description": "Genera par de claves Ed25519.",
                "example": "ssh-keygen -t ed25519 -C \"dev@example.com\"",
                "expected": "Ruta, fingerprint y randomart.",
                "note": ""
            },
            {
                "command": "ssh-keygen -t ed25519 -C \"email\"",
                "level": "basic",
                "description": "Genera par de claves Ed25519.",
                "example": "ssh-keygen -t ed25519 -C \"dev@example.com\"",
                "expected": "Prompts de ruta/passphrase y fingerprint.",
                "note": ""
            },
            {
                "command": "rsync -avh --progress <src>/ <user>@<host>:<dest>/",
                "level": "intermediate",
                "description": "Sincroniza eficientemente preservando metadata.",
                "example": "rsync -avh --progress dist/ deploy@server:/var/www/app/",
                "expected": "Lista de archivos, bytes y speedup.",
                "note": ""
            },
            {
                "command": "rsync -avhn --delete <src>/ <user>@<host>:<dest>/",
                "level": "intermediate",
                "description": "Simula sincronización destructiva sin cambiar nada.",
                "example": "rsync -avhn --delete dist/ deploy@server:/var/www/app/",
                "expected": "Qué copiaría/eliminaría.",
                "note": ""
            },
            {
                "command": "rsync -avz <src>/ <user>@<host>:<dst>/",
                "level": "intermediate",
                "description": "Sincroniza eficientemente contenido por SSH.",
                "example": "rsync -avz dist/ deploy@example.com:/srv/app/",
                "expected": "sending incremental file list ... sent/received bytes.",
                "note": ""
            },
            {
                "command": "ssh -i <key> <user>@<host>",
                "level": "intermediate",
                "description": "Usa una clave privada especifica.",
                "example": "ssh -i ~/.ssh/id_ed25519 deploy@example.com",
                "expected": "Sesion remota o Permission denied.",
                "note": ""
            },
            {
                "command": "ssh -v <user>@<host>",
                "level": "intermediate",
                "description": "Muestra diagnostico detallado de conexion.",
                "example": "ssh -v deploy@example.com",
                "expected": "debug1: ... negociacion, llaves y autenticacion.",
                "note": ""
            },
            {
                "command": "ssh-add <key>",
                "level": "intermediate",
                "description": "Agrega una clave privada al ssh-agent.",
                "example": "ssh-add ~/.ssh/id_ed25519",
                "expected": "Identity added: ...",
                "note": ""
            },
            {
                "command": "ssh-copy-id <user>@<host>",
                "level": "intermediate",
                "description": "Instala la clave publica en authorized_keys remoto en sistemas compatibles.",
                "example": "ssh-copy-id deploy@example.com",
                "expected": "Number of key(s) added: 1.",
                "note": ""
            },
            {
                "command": "ssh-keygen -lf <public-key>",
                "level": "intermediate",
                "description": "Muestra fingerprint de una clave pública.",
                "example": "ssh-keygen -lf ~/.ssh/id_ed25519.pub",
                "expected": "Bits, SHA256 fingerprint, comment, tipo.",
                "note": ""
            },
            {
                "command": "rsync -avh --delete <src>/ <user>@<host>:<dest>/",
                "level": "advanced",
                "description": "Hace destino espejo eliminando archivos que ya no existen en origen.",
                "example": "rsync -avh --delete dist/ deploy@server:/var/www/app/",
                "expected": "Cambios y deletes.",
                "note": "Revisar con --dry-run primero."
            },
            {
                "command": "rsync -avz --delete <src>/ <dst>/",
                "level": "advanced",
                "description": "Hace mirror eliminando en destino archivos que ya no estan en origen.",
                "example": "rsync -avz --delete dist/ deploy@example.com:/srv/app/",
                "expected": "Lista cambios y eliminaciones.",
                "note": "Revisa la ruta: --delete elimina contenido sobrante del destino."
            },
            {
                "command": "ssh -D 1080 <user>@<host>",
                "level": "advanced",
                "description": "Crea proxy SOCKS dinámico.",
                "example": "ssh -D 1080 deploy@server",
                "expected": "SOCKS en localhost:1080.",
                "note": ""
            },
            {
                "command": "ssh -L 5433:localhost:5432 <user>@<host>",
                "level": "advanced",
                "description": "Crea port forward local hacia recurso remoto.",
                "example": "ssh -L 5433:localhost:5432 deploy@db-server",
                "expected": "Sesión/túnel; localhost:5433 apunta al remoto.",
                "note": ""
            },
            {
                "command": "ssh -L <local>:<target>:<remote> <user>@<host>",
                "level": "advanced",
                "description": "Crea port forwarding local a traves del servidor SSH.",
                "example": "ssh -L 5433:localhost:5432 deploy@example.com",
                "expected": "Sesion SSH abierta; localhost:5433 apunta al 5432 remoto.",
                "note": ""
            },
            {
                "command": "ssh -N -L <local>:<target>:<remote> <user>@<host>",
                "level": "advanced",
                "description": "Mantiene solo el tunnel sin abrir shell remota.",
                "example": "ssh -N -L 5433:localhost:5432 deploy@example.com",
                "expected": "Permanece en foreground sin prompt hasta Ctrl+C.",
                "note": ""
            },
            {
                "command": "ssh -R 8080:localhost:3000 <user>@<host>",
                "level": "advanced",
                "description": "Crea reverse tunnel desde host remoto hacia local.",
                "example": "ssh -R 8080:localhost:3000 deploy@server",
                "expected": "Puerto remoto 8080 reenviado.",
                "note": ""
            },
            {
                "command": "ssh -R <remote>:<target>:<local> <user>@<host>",
                "level": "advanced",
                "description": "Crea reverse tunnel desde remoto hacia un servicio local.",
                "example": "ssh -R 9000:localhost:3000 deploy@example.com",
                "expected": "Sesion activa; puerto remoto 9000 reenvia a local:3000.",
                "note": ""
            }
        ]
    },
    {
        "id": "curl",
        "group": "access-network",
        "title": "cURL / HTTP",
        "description": "Requests HTTP, headers, JSON, auth, archivos, tiempos y diagnostico.",
        "aliases": [
            "curl",
            "http",
            "api",
            "request"
        ],
        "commands": [
            {
                "command": "curl -H \"Authorization: Bearer <token>\" <url>",
                "level": "basic",
                "description": "Envia Bearer token.",
                "example": "curl -H \"Authorization: Bearer $TOKEN\" https://example.com/api/me",
                "expected": "Recurso protegido o 401/403.",
                "note": ""
            },
            {
                "command": "curl -H \"Content-Type: application/json\" -d '<json>' <url>",
                "level": "basic",
                "description": "Envia JSON en el body.",
                "example": "curl -H \"Content-Type: application/json\" -d '{\"name\":\"Ada\"}' https://example.com/api/users",
                "expected": "JSON de recurso creado o error HTTP.",
                "note": ""
            },
            {
                "command": "curl -i <url>",
                "level": "basic",
                "description": "Incluye headers de respuesta.",
                "example": "curl -i https://example.com/api/health",
                "expected": "HTTP/1.1 200 OK + headers + body.",
                "note": ""
            },
            {
                "command": "curl -I <url>",
                "level": "basic",
                "description": "Solicita solo headers con HEAD.",
                "example": "curl -I https://example.com",
                "expected": "Status y headers sin body.",
                "note": ""
            },
            {
                "command": "curl -L <url>",
                "level": "basic",
                "description": "Sigue redirecciones HTTP.",
                "example": "curl -L http://example.com",
                "expected": "Termina mostrando body del destino final.",
                "note": ""
            },
            {
                "command": "curl -o <file> <url>",
                "level": "basic",
                "description": "Guarda respuesta en un archivo.",
                "example": "curl -o release.zip https://example.com/release.zip",
                "expected": "Progreso; release.zip creado.",
                "note": ""
            },
            {
                "command": "curl -O <url>",
                "level": "basic",
                "description": "Guarda usando el nombre remoto.",
                "example": "curl -O https://example.com/files/release.zip",
                "expected": "Progreso y release.zip local.",
                "note": ""
            },
            {
                "command": "curl -sS <url>",
                "level": "basic",
                "description": "Modo silencioso pero conserva errores.",
                "example": "curl -sS https://api.example.com/health",
                "expected": "Solo body o error.",
                "note": ""
            },
            {
                "command": "curl -u <user>:<pass> <url>",
                "level": "basic",
                "description": "Usa HTTP Basic Auth.",
                "example": "curl -u dev:secret https://example.com/private",
                "expected": "Body si credenciales son validas; 401 si no.",
                "note": ""
            },
            {
                "command": "curl -u <user>:<password> <url>",
                "level": "basic",
                "description": "Usa HTTP Basic Auth.",
                "example": "curl -u admin:secret https://example.com/private",
                "expected": "Respuesta o 401.",
                "note": ""
            },
            {
                "command": "curl -X POST <url>",
                "level": "basic",
                "description": "Fuerza metodo POST.",
                "example": "curl -X POST https://example.com/api/jobs",
                "expected": "Respuesta del endpoint; muchos POST requieren body/headers.",
                "note": ""
            },
            {
                "command": "curl -X POST <url> -H \"Content-Type: application/json\" -d '{\"name\":\"Ada\"}'",
                "level": "basic",
                "description": "Envía JSON por POST.",
                "example": "curl -X POST http://localhost:4000/users -H \"Content-Type: application/json\" -d '{\"name\":\"Ada\"}'",
                "expected": "Status/body JSON del endpoint.",
                "note": ""
            },
            {
                "command": "curl <url>",
                "level": "basic",
                "description": "Hace GET y escribe el body en stdout.",
                "example": "curl https://example.com/api/health",
                "expected": "Body HTTP, por ejemplo {\"status\":\"ok\"}.",
                "note": ""
            },
            {
                "command": "curl --connect-timeout 5 --max-time 20 <url>",
                "level": "intermediate",
                "description": "Limita tiempo de conexion y total.",
                "example": "curl --connect-timeout 5 --max-time 20 https://example.com",
                "expected": "Respuesta normal o error curl 28 por timeout.",
                "note": ""
            },
            {
                "command": "curl --connect-timeout 5 --max-time 30 <url>",
                "level": "intermediate",
                "description": "Configura timeouts de conexión y total.",
                "example": "curl --connect-timeout 5 --max-time 30 https://api.example.com",
                "expected": "Respuesta o timeout con exit code.",
                "note": ""
            },
            {
                "command": "curl --data-urlencode \"q=<text>\" <url>",
                "level": "intermediate",
                "description": "Codifica parámetros form/query correctamente.",
                "example": "curl --get --data-urlencode \"q=hola mundo\" https://example.com/search",
                "expected": "Respuesta de búsqueda.",
                "note": ""
            },
            {
                "command": "curl --fail-with-body <url>",
                "level": "intermediate",
                "description": "Devuelve codigo de salida no cero en errores HTTP conservando body.",
                "example": "curl --fail-with-body https://example.com/api/missing",
                "expected": "Body de error y exit code 22 para 4xx/5xx.",
                "note": ""
            },
            {
                "command": "curl -F \"file=@<path>\" <url>",
                "level": "intermediate",
                "description": "Envia multipart/form-data con archivo.",
                "example": "curl -F \"file=@report.pdf\" https://example.com/api/upload",
                "expected": "Respuesta del endpoint de upload.",
                "note": ""
            },
            {
                "command": "curl -v <url>",
                "level": "intermediate",
                "description": "Muestra negociacion DNS/TLS, request y response headers.",
                "example": "curl -v https://example.com",
                "expected": "Lineas * de diagnostico, > request, < response y body.",
                "note": ""
            },
            {
                "command": "curl --cacert <ca.pem> <url>",
                "level": "advanced",
                "description": "Valida TLS usando una CA específica.",
                "example": "curl --cacert company-ca.pem https://internal.example.com",
                "expected": "Respuesta TLS válida o error de certificado.",
                "note": ""
            },
            {
                "command": "curl --cert <client.pem> --key <key.pem> <url>",
                "level": "advanced",
                "description": "Usa certificado cliente mTLS.",
                "example": "curl --cert client.pem --key client-key.pem https://mtls.example.com",
                "expected": "Respuesta autenticada por certificado.",
                "note": ""
            },
            {
                "command": "curl --http2 -I <url>",
                "level": "advanced",
                "description": "Fuerza/intenta HTTP/2.",
                "example": "curl --http2 -I https://example.com",
                "expected": "Headers y negociación HTTP/2.",
                "note": ""
            },
            {
                "command": "curl --resolve <host>:443:<ip> https://<host>/",
                "level": "advanced",
                "description": "Fuerza resolución DNS para probar un host/IP concreto.",
                "example": "curl --resolve api.example.com:443:203.0.113.10 https://api.example.com/health",
                "expected": "Respuesta usando esa IP pero SNI/Host correctos.",
                "note": ""
            },
            {
                "command": "curl --retry 5 --retry-all-errors <url>",
                "level": "advanced",
                "description": "Reintenta errores transitorios.",
                "example": "curl --retry 5 --retry-all-errors https://example.com/api/job",
                "expected": "Respuesta final o error despues de agotar reintentos.",
                "note": ""
            },
            {
                "command": "curl -w \"%{http_code} %{time_total}\\n\" -o /dev/null -s <url>",
                "level": "advanced",
                "description": "Mide status y tiempo total sin imprimir body.",
                "example": "curl -w \"%{http_code} %{time_total}\\n\" -o /dev/null -s https://example.com",
                "expected": "200 0.184321",
                "note": ""
            }
        ]
    },
    {
        "id": "postgres",
        "group": "databases",
        "title": "PostgreSQL / psql",
        "description": "Conexion, bases, roles, schemas, consultas, backup y diagnostico.",
        "aliases": [
            "postgres",
            "postgresql",
            "psql",
            "sql"
        ],
        "commands": [
            {
                "command": "\\c <database>",
                "level": "basic",
                "description": "Cambia de base en psql.",
                "example": "\\c notebook",
                "expected": "You are now connected to database \"notebook\" ...",
                "note": ""
            },
            {
                "command": "\\d <table>",
                "level": "basic",
                "description": "Describe columnas, tipos, indices y constraints de una tabla.",
                "example": "\\d users",
                "expected": "Table \"public.users\" ... Columns / Indexes / constraints.",
                "note": ""
            },
            {
                "command": "\\dt",
                "level": "basic",
                "description": "Lista tablas visibles del schema actual.",
                "example": "\\dt",
                "expected": "Schema Name Type Owner.",
                "note": ""
            },
            {
                "command": "\\l",
                "level": "basic",
                "description": "Lista bases de datos dentro de psql.",
                "example": "\\l",
                "expected": "Name Owner Encoding Collate ...",
                "note": ""
            },
            {
                "command": "\\timing",
                "level": "basic",
                "description": "Activa/desactiva tiempo de cada consulta.",
                "example": "\\timing",
                "expected": "Timing is on.",
                "note": ""
            },
            {
                "command": "\\timing on",
                "level": "basic",
                "description": "Muestra duración de consultas.",
                "example": "\\timing on",
                "expected": "Timing is on.",
                "note": ""
            },
            {
                "command": "\\x",
                "level": "basic",
                "description": "Activa/desactiva expanded display para filas anchas.",
                "example": "\\x",
                "expected": "Expanded display is on/off.",
                "note": ""
            },
            {
                "command": "\\x auto",
                "level": "basic",
                "description": "Activa expanded display automático.",
                "example": "\\x auto",
                "expected": "Expanded display is used automatically.",
                "note": ""
            },
            {
                "command": "createdb -U <user> <db>",
                "level": "basic",
                "description": "Crea una base desde la CLI.",
                "example": "createdb -U postgres notebook_test",
                "expected": "Sin salida si se crea correctamente.",
                "note": ""
            },
            {
                "command": "psql --version",
                "level": "basic",
                "description": "Muestra version del cliente psql.",
                "example": "psql --version",
                "expected": "psql (PostgreSQL) 16.x",
                "note": ""
            },
            {
                "command": "psql -h <host> -U <user> -d <db>",
                "level": "basic",
                "description": "Abre consola psql contra una base.",
                "example": "psql -h localhost -U postgres -d notebook",
                "expected": "Password prompt y luego notebook=#.",
                "note": ""
            },
            {
                "command": "\\dn",
                "level": "intermediate",
                "description": "Lista schemas.",
                "example": "\\dn",
                "expected": "Name Owner.",
                "note": ""
            },
            {
                "command": "\\du",
                "level": "intermediate",
                "description": "Lista roles y atributos.",
                "example": "\\du",
                "expected": "Role name Attributes Member of.",
                "note": ""
            },
            {
                "command": "pg_dump -h <host> -U <user> -d <db> -Fc -f <file>",
                "level": "intermediate",
                "description": "Genera backup formato custom.",
                "example": "pg_dump -h localhost -U postgres -d notebook -Fc -f notebook.dump",
                "expected": "Sin salida normal; notebook.dump creado.",
                "note": ""
            },
            {
                "command": "pg_dump -h <host> -U <user> -Fc -d <db> -f <backup.dump>",
                "level": "intermediate",
                "description": "Crea backup custom format.",
                "example": "pg_dump -h localhost -U postgres -Fc -d notebook -f notebook.dump",
                "expected": "Archivo dump; progreso normalmente silencioso.",
                "note": ""
            },
            {
                "command": "SELECT pg_database_size(current_database());",
                "level": "intermediate",
                "description": "Muestra tamano de la base actual en bytes.",
                "example": "SELECT pg_size_pretty(pg_database_size(current_database()));",
                "expected": "pg_size_pretty\n----------------\n 128 MB",
                "note": ""
            },
            {
                "command": "SELECT pg_size_pretty(pg_database_size(current_database()));",
                "level": "intermediate",
                "description": "Muestra tamaño de base actual.",
                "example": "SELECT pg_size_pretty(pg_database_size(current_database()));",
                "expected": "Ej. 128 MB.",
                "note": ""
            },
            {
                "command": "SELECT pg_size_pretty(pg_total_relation_size('<table>'));",
                "level": "intermediate",
                "description": "Muestra tamaño total tabla+índices.",
                "example": "SELECT pg_size_pretty(pg_total_relation_size('users'));",
                "expected": "Tamaño legible.",
                "note": ""
            },
            {
                "command": "dropdb -U <user> <db>",
                "level": "advanced",
                "description": "Elimina una base.",
                "example": "dropdb -U postgres notebook_test",
                "expected": "Sin salida.",
                "note": "Operacion destructiva e irreversible sin backup."
            },
            {
                "command": "EXPLAIN (ANALYZE, BUFFERS) <query>;",
                "level": "advanced",
                "description": "Incluye uso de buffers para diagnosticar I/O.",
                "example": "EXPLAIN (ANALYZE, BUFFERS) SELECT * FROM orders WHERE user_id=42;",
                "expected": "Plan + shared hit/read/dirtied/written.",
                "note": ""
            },
            {
                "command": "EXPLAIN ANALYZE <query>;",
                "level": "advanced",
                "description": "Ejecuta consulta y muestra plan real con tiempos/filas.",
                "example": "EXPLAIN ANALYZE SELECT * FROM users WHERE email = 'a@b.com';",
                "expected": "Plan de ejecucion con actual time, rows y loops.",
                "note": ""
            },
            {
                "command": "pg_dumpall -U <user> --globals-only > globals.sql",
                "level": "advanced",
                "description": "Respalda roles/tablespaces globales.",
                "example": "pg_dumpall -U postgres --globals-only > globals.sql",
                "expected": "Archivo SQL con globals.",
                "note": ""
            },
            {
                "command": "pg_restore -h <host> -U <user> -d <db> <backup.dump>",
                "level": "advanced",
                "description": "Restaura custom-format dump.",
                "example": "pg_restore -h localhost -U postgres -d notebook_restore notebook.dump",
                "expected": "Objetos restaurados o errores.",
                "note": ""
            },
            {
                "command": "pg_restore -h <host> -U <user> -d <db> <file>",
                "level": "advanced",
                "description": "Restaura un backup custom en una base existente.",
                "example": "pg_restore -h localhost -U postgres -d notebook_restore notebook.dump",
                "expected": "Progreso/errores; sin salida si todo va bien.",
                "note": ""
            },
            {
                "command": "REINDEX TABLE <table>;",
                "level": "advanced",
                "description": "Reconstruye índices de una tabla.",
                "example": "REINDEX TABLE users;",
                "expected": "REINDEX.",
                "note": ""
            },
            {
                "command": "SELECT * FROM pg_stat_activity;",
                "level": "advanced",
                "description": "Muestra sesiones y consultas activas.",
                "example": "SELECT pid, usename, state, query FROM pg_stat_activity;",
                "expected": "Filas por backend/conexion.",
                "note": ""
            },
            {
                "command": "SELECT pg_terminate_backend(<pid>);",
                "level": "advanced",
                "description": "Termina una sesión backend concreta.",
                "example": "SELECT pg_terminate_backend(12345);",
                "expected": "true/false.",
                "note": "Puede abortar transacciones del proceso."
            },
            {
                "command": "VACUUM (ANALYZE) <table>;",
                "level": "advanced",
                "description": "Recupera espacio reutilizable y actualiza estadisticas.",
                "example": "VACUUM (ANALYZE) users;",
                "expected": "VACUUM",
                "note": ""
            }
        ]
    },
    {
        "id": "mysql",
        "group": "databases",
        "title": "MySQL / MariaDB",
        "description": "Conexion, bases, tablas, usuarios, procesos y backup.",
        "aliases": [
            "mysql",
            "mariadb",
            "sql"
        ],
        "commands": [
            {
                "command": "DESCRIBE <table>;",
                "level": "basic",
                "description": "Muestra columnas, tipos, null, keys y defaults.",
                "example": "DESCRIBE users;",
                "expected": "Field Type Null Key Default Extra.",
                "note": ""
            },
            {
                "command": "mysql --version",
                "level": "basic",
                "description": "Muestra version del cliente.",
                "example": "mysql --version",
                "expected": "mysql Ver 8.x... o mariadb ...",
                "note": ""
            },
            {
                "command": "mysql -h <host> -u <user> -p",
                "level": "basic",
                "description": "Abre sesion y solicita password.",
                "example": "mysql -h localhost -u root -p",
                "expected": "Enter password: y luego mysql>.",
                "note": ""
            },
            {
                "command": "SHOW DATABASES;",
                "level": "basic",
                "description": "Lista bases de datos.",
                "example": "SHOW DATABASES;",
                "expected": "Tabla Database.",
                "note": ""
            },
            {
                "command": "SHOW TABLES;",
                "level": "basic",
                "description": "Lista tablas de la base seleccionada.",
                "example": "SHOW TABLES;",
                "expected": "Tables_in_notebook.",
                "note": ""
            },
            {
                "command": "USE <database>;",
                "level": "basic",
                "description": "Selecciona una base.",
                "example": "USE notebook;",
                "expected": "Database changed",
                "note": ""
            },
            {
                "command": "EXPLAIN <query>;",
                "level": "intermediate",
                "description": "Muestra plan estimado de una consulta.",
                "example": "EXPLAIN SELECT * FROM users WHERE email='a@b.com';",
                "expected": "Tabla con type, possible_keys, key, rows, Extra.",
                "note": ""
            },
            {
                "command": "mysqldump -h <host> -u <user> -p <db> > backup.sql",
                "level": "intermediate",
                "description": "Exporta esquema y datos a SQL.",
                "example": "mysqldump -h localhost -u root -p notebook > notebook.sql",
                "expected": "Password prompt; backup queda en notebook.sql.",
                "note": ""
            },
            {
                "command": "SHOW CREATE TABLE <table>;",
                "level": "intermediate",
                "description": "Muestra DDL exacto de tabla.",
                "example": "SHOW CREATE TABLE users;",
                "expected": "CREATE TABLE completo.",
                "note": ""
            },
            {
                "command": "SHOW CREATE TABLE <table>\\G",
                "level": "intermediate",
                "description": "Muestra DDL completo de una tabla.",
                "example": "SHOW CREATE TABLE users\\G",
                "expected": "Create Table: CREATE TABLE ...",
                "note": ""
            },
            {
                "command": "SHOW GRANTS FOR 'user'@'host';",
                "level": "intermediate",
                "description": "Muestra permisos efectivos de un usuario.",
                "example": "SHOW GRANTS FOR 'app'@'localhost';",
                "expected": "Una o mas sentencias GRANT.",
                "note": ""
            },
            {
                "command": "SHOW INDEX FROM <table>;",
                "level": "intermediate",
                "description": "Lista índices.",
                "example": "SHOW INDEX FROM users;",
                "expected": "Key_name, column, cardinality, type.",
                "note": ""
            },
            {
                "command": "SHOW PROCESSLIST;",
                "level": "intermediate",
                "description": "Muestra conexiones/consultas activas.",
                "example": "SHOW PROCESSLIST;",
                "expected": "Id User Host db Command Time State Info.",
                "note": ""
            },
            {
                "command": "ANALYZE TABLE <table>;",
                "level": "advanced",
                "description": "Actualiza estadísticas del optimizador.",
                "example": "ANALYZE TABLE users;",
                "expected": "Table, Op, Msg_type, Msg_text.",
                "note": ""
            },
            {
                "command": "CREATE USER 'name'@'host' IDENTIFIED BY 'password';",
                "level": "advanced",
                "description": "Crea un usuario MySQL.",
                "example": "CREATE USER 'app'@'localhost' IDENTIFIED BY 'strong-password';",
                "expected": "Query OK, 0 rows affected.",
                "note": ""
            },
            {
                "command": "GRANT <privileges> ON <db>.* TO 'user'@'host';",
                "level": "advanced",
                "description": "Otorga permisos sobre una base.",
                "example": "GRANT SELECT,INSERT,UPDATE ON notebook.* TO 'app'@'localhost';",
                "expected": "Query OK, 0 rows affected.",
                "note": ""
            },
            {
                "command": "KILL <connection-id>;",
                "level": "advanced",
                "description": "Termina una conexión/query.",
                "example": "KILL 123;",
                "expected": "Query OK.",
                "note": "Puede abortar trabajo en curso."
            },
            {
                "command": "mysql -h <host> -u <user> -p <db> < backup.sql",
                "level": "advanced",
                "description": "Restaura un dump SQL.",
                "example": "mysql -h localhost -u root -p notebook_restore < notebook.sql",
                "expected": "Password prompt; sin salida normal.",
                "note": ""
            }
        ]
    },
    {
        "id": "redis",
        "group": "databases",
        "title": "Redis CLI",
        "description": "Claves, TTL, hashes, listas, sets, streams basicos y diagnostico.",
        "aliases": [
            "redis",
            "redis-cli",
            "cache"
        ],
        "commands": [
            {
                "command": "DBSIZE",
                "level": "basic",
                "description": "Cuenta claves de la DB seleccionada.",
                "example": "DBSIZE",
                "expected": "Número entero.",
                "note": ""
            },
            {
                "command": "DEL <key>",
                "level": "basic",
                "description": "Elimina una o mas claves.",
                "example": "DEL session:123",
                "expected": "(integer) 1",
                "note": ""
            },
            {
                "command": "GET <key>",
                "level": "basic",
                "description": "Obtiene un string.",
                "example": "GET app:mode",
                "expected": "\"development\" o (nil).",
                "note": ""
            },
            {
                "command": "HGETALL <key>",
                "level": "basic",
                "description": "Obtiene todos los campos de un hash.",
                "example": "HGETALL user:1",
                "expected": "Pares field/value.",
                "note": ""
            },
            {
                "command": "HSET <key> <field> <value>",
                "level": "basic",
                "description": "Escribe campo de un hash.",
                "example": "HSET user:1 email dev@example.com",
                "expected": "(integer) 1 si campo nuevo, 0 si actualiza.",
                "note": ""
            },
            {
                "command": "INFO",
                "level": "basic",
                "description": "Muestra métricas/estado del servidor.",
                "example": "INFO",
                "expected": "Secciones server, clients, memory, stats, persistence, etc.",
                "note": ""
            },
            {
                "command": "PING",
                "level": "basic",
                "description": "Comprueba conectividad.",
                "example": "PING",
                "expected": "PONG.",
                "note": ""
            },
            {
                "command": "redis-cli --version",
                "level": "basic",
                "description": "Muestra versión redis-cli.",
                "example": "redis-cli --version",
                "expected": "redis-cli X.Y.Z.",
                "note": ""
            },
            {
                "command": "redis-cli -h <host> -p <port>",
                "level": "basic",
                "description": "Abre consola interactiva contra un servidor.",
                "example": "redis-cli -h localhost -p 6379",
                "expected": "localhost:6379>",
                "note": ""
            },
            {
                "command": "redis-cli ping",
                "level": "basic",
                "description": "Comprueba conectividad con Redis.",
                "example": "redis-cli ping",
                "expected": "PONG",
                "note": ""
            },
            {
                "command": "SET <key> <value>",
                "level": "basic",
                "description": "Guarda un string.",
                "example": "SET app:mode development",
                "expected": "OK",
                "note": ""
            },
            {
                "command": "SETEX <key> <seconds> <value>",
                "level": "basic",
                "description": "Guarda string con expiracion.",
                "example": "SETEX session:123 3600 active",
                "expected": "OK",
                "note": ""
            },
            {
                "command": "TTL <key>",
                "level": "basic",
                "description": "Muestra segundos restantes de expiracion.",
                "example": "TTL session:123",
                "expected": "3592; -1 sin expiracion; -2 si no existe.",
                "note": ""
            },
            {
                "command": "TYPE <key>",
                "level": "basic",
                "description": "Muestra tipo Redis de una clave.",
                "example": "TYPE user:1",
                "expected": "string, hash, list, set, zset, stream o none.",
                "note": ""
            },
            {
                "command": "INFO memory",
                "level": "intermediate",
                "description": "Muestra metricas de memoria.",
                "example": "INFO memory",
                "expected": "# Memory\nused_memory:...",
                "note": ""
            },
            {
                "command": "INFO stats",
                "level": "intermediate",
                "description": "Muestra estadisticas generales.",
                "example": "INFO stats",
                "expected": "# Stats\ntotal_connections_received:...",
                "note": ""
            },
            {
                "command": "MEMORY USAGE <key>",
                "level": "intermediate",
                "description": "Estima bytes usados por clave.",
                "example": "MEMORY USAGE session:42",
                "expected": "Bytes.",
                "note": ""
            },
            {
                "command": "SCAN 0 MATCH <pattern> COUNT 100",
                "level": "intermediate",
                "description": "Itera claves sin bloquear como KEYS.",
                "example": "SCAN 0 MATCH user:* COUNT 100",
                "expected": "Cursor siguiente + claves encontradas.",
                "note": ""
            },
            {
                "command": "BGSAVE",
                "level": "advanced",
                "description": "Dispara snapshot RDB en background.",
                "example": "BGSAVE",
                "expected": "Background saving started.",
                "note": ""
            },
            {
                "command": "CLIENT LIST",
                "level": "advanced",
                "description": "Lista clientes conectados.",
                "example": "CLIENT LIST",
                "expected": "Una línea por conexión con addr/age/flags/cmd.",
                "note": ""
            },
            {
                "command": "CONFIG GET maxmemory",
                "level": "advanced",
                "description": "Consulta configuración runtime.",
                "example": "CONFIG GET maxmemory",
                "expected": "Clave y valor.",
                "note": ""
            },
            {
                "command": "FLUSHDB",
                "level": "advanced",
                "description": "Borra todas las claves de DB actual.",
                "example": "FLUSHDB",
                "expected": "OK.",
                "note": "Destructivo; verificar entorno."
            },
            {
                "command": "MONITOR",
                "level": "advanced",
                "description": "Imprime todos los comandos recibidos en tiempo real.",
                "example": "MONITOR",
                "expected": "OK y luego una linea por comando.",
                "note": "Puede generar mucho output y afectar rendimiento; usar temporalmente."
            },
            {
                "command": "SLOWLOG GET 10",
                "level": "advanced",
                "description": "Muestra últimas consultas lentas.",
                "example": "SLOWLOG GET 10",
                "expected": "Entradas con ID, timestamp, duración, command.",
                "note": ""
            }
        ]
    },
    {
        "id": "python",
        "group": "python",
        "title": "Python / pip / venv",
        "description": "Runtime Python, entornos virtuales, paquetes, tests y diagnostico.",
        "aliases": [
            "python",
            "python3",
            "pip",
            "venv",
            "pytest"
        ],
        "commands": [
            {
                "command": ".venv\\Scripts\\Activate.ps1",
                "level": "basic",
                "description": "Activa venv en PowerShell de Windows.",
                "example": ".venv\\Scripts\\Activate.ps1",
                "expected": "El prompt suele mostrar (.venv).",
                "note": ""
            },
            {
                "command": "deactivate",
                "level": "basic",
                "description": "Sale del entorno virtual activo.",
                "example": "deactivate",
                "expected": "Desaparece el prefijo del venv.",
                "note": ""
            },
            {
                "command": "python --version",
                "level": "basic",
                "description": "Muestra version activa de Python.",
                "example": "python --version",
                "expected": "Python 3.12.x",
                "note": ""
            },
            {
                "command": "python -m <module>",
                "level": "basic",
                "description": "Ejecuta un modulo usando el interprete actual.",
                "example": "python -m http.server 8000",
                "expected": "Serving HTTP on ... port 8000 ...",
                "note": ""
            },
            {
                "command": "python -m pip freeze",
                "level": "basic",
                "description": "Lista paquetes instalados en formato requirements.",
                "example": "python -m pip freeze",
                "expected": "package==version, una linea por paquete.",
                "note": ""
            },
            {
                "command": "python -m pip freeze > requirements.txt",
                "level": "basic",
                "description": "Guarda dependencias exactas del entorno.",
                "example": "python -m pip freeze > requirements.txt",
                "expected": "Sin salida; requirements.txt actualizado.",
                "note": ""
            },
            {
                "command": "python -m pip install -r requirements.txt",
                "level": "basic",
                "description": "Instala dependencias listadas.",
                "example": "python -m pip install -r requirements.txt",
                "expected": "Collecting/Requirement already satisfied/Successfully installed.",
                "note": ""
            },
            {
                "command": "python -m pip install -U pip",
                "level": "basic",
                "description": "Actualiza pip del intérprete activo.",
                "example": "python -m pip install -U pip",
                "expected": "Versión instalada/actualizada.",
                "note": ""
            },
            {
                "command": "python -m pip install <package>",
                "level": "basic",
                "description": "Instala paquete usando pip del interprete activo.",
                "example": "python -m pip install pandas",
                "expected": "Successfully installed pandas-...",
                "note": ""
            },
            {
                "command": "python -m pip show <package>",
                "level": "basic",
                "description": "Muestra metadata y ubicacion de un paquete.",
                "example": "python -m pip show pandas",
                "expected": "Name, Version, Location, Requires ...",
                "note": ""
            },
            {
                "command": "python -m pip uninstall <package>",
                "level": "basic",
                "description": "Desinstala paquete.",
                "example": "python -m pip uninstall pandas",
                "expected": "Files to be removed + Proceed? y Successfully uninstalled.",
                "note": ""
            },
            {
                "command": "python -m venv .venv",
                "level": "basic",
                "description": "Crea un entorno virtual en .venv.",
                "example": "python -m venv .venv",
                "expected": "Sin salida; se crea .venv.",
                "note": ""
            },
            {
                "command": "python <file.py>",
                "level": "basic",
                "description": "Ejecuta un script.",
                "example": "python app.py",
                "expected": "Salida del script o traceback si falla.",
                "note": ""
            },
            {
                "command": "source .venv/bin/activate",
                "level": "basic",
                "description": "Activa venv en Bash/Linux/macOS.",
                "example": "source .venv/bin/activate",
                "expected": "El prompt suele mostrar (.venv).",
                "note": ""
            },
            {
                "command": "python -m compileall .",
                "level": "intermediate",
                "description": "Compila .py a bytecode y detecta errores sintácticos.",
                "example": "python -m compileall src",
                "expected": "Listing/Compiling o errores.",
                "note": ""
            },
            {
                "command": "python -m compileall <path>",
                "level": "intermediate",
                "description": "Compila .py a bytecode y detecta errores sintacticos.",
                "example": "python -m compileall src",
                "expected": "Listing/Compiling ...; SyntaxError si hay fallos.",
                "note": ""
            },
            {
                "command": "python -m coverage report -m",
                "level": "intermediate",
                "description": "Muestra coverage por archivo/líneas faltantes.",
                "example": "python -m coverage report -m",
                "expected": "Name, Stmts, Miss, Cover, Missing.",
                "note": ""
            },
            {
                "command": "python -m coverage run -m pytest",
                "level": "intermediate",
                "description": "Ejecuta tests midiendo coverage.",
                "example": "python -m coverage run -m pytest",
                "expected": "Tests + archivo .coverage.",
                "note": ""
            },
            {
                "command": "python -m pip check",
                "level": "intermediate",
                "description": "Verifica dependencias incompatibles/faltantes.",
                "example": "python -m pip check",
                "expected": "No broken requirements found o conflictos.",
                "note": ""
            },
            {
                "command": "python -m pip list --outdated",
                "level": "intermediate",
                "description": "Lista paquetes con versiones nuevas.",
                "example": "python -m pip list --outdated",
                "expected": "Package Version Latest Type.",
                "note": ""
            },
            {
                "command": "python -m pytest",
                "level": "intermediate",
                "description": "Ejecuta pytest si esta instalado.",
                "example": "python -m pytest",
                "expected": "collected N items ... passed/failed.",
                "note": ""
            },
            {
                "command": "python -m pytest -k \"<expression>\"",
                "level": "intermediate",
                "description": "Filtra tests por nombre.",
                "example": "python -m pytest -k \"login and not slow\"",
                "expected": "Solo tests coincidentes.",
                "note": ""
            },
            {
                "command": "python -m pytest -q",
                "level": "intermediate",
                "description": "Ejecuta pytest con salida compacta.",
                "example": "python -m pytest -q",
                "expected": ".... [100%]\nN passed in ...s",
                "note": ""
            },
            {
                "command": "python -m unittest",
                "level": "intermediate",
                "description": "Ejecuta unittest discovery basico.",
                "example": "python -m unittest",
                "expected": "Dots/F/E y resumen Ran N tests.",
                "note": ""
            },
            {
                "command": "ruff check .",
                "level": "intermediate",
                "description": "Lint rápido de Python.",
                "example": "ruff check .",
                "expected": "Violaciones por archivo/línea o All checks passed.",
                "note": ""
            },
            {
                "command": "ruff format .",
                "level": "intermediate",
                "description": "Formatea Python.",
                "example": "ruff format .",
                "expected": "N files reformatted/left unchanged.",
                "note": ""
            },
            {
                "command": "mypy .",
                "level": "advanced",
                "description": "Chequeo estático de tipos.",
                "example": "mypy src",
                "expected": "Success o errores de tipos.",
                "note": ""
            },
            {
                "command": "python -m cProfile -s cumulative <script.py>",
                "level": "advanced",
                "description": "Perfila CPU ordenando por tiempo acumulado.",
                "example": "python -m cProfile -s cumulative app.py",
                "expected": "Tabla ncalls/tottime/cumtime/function.",
                "note": ""
            },
            {
                "command": "python -m pdb <file.py>",
                "level": "advanced",
                "description": "Ejecuta un script bajo el debugger pdb.",
                "example": "python -m pdb app.py",
                "expected": "> file.py(line)...\n(Pdb)",
                "note": ""
            },
            {
                "command": "python -m pytest -k <pattern>",
                "level": "advanced",
                "description": "Ejecuta tests cuyo nombre coincide con expresion.",
                "example": "python -m pytest -k auth",
                "expected": "selected/deselected y resultados.",
                "note": ""
            },
            {
                "command": "python -m pytest -x --pdb",
                "level": "advanced",
                "description": "Detiene al primer fallo y abre debugger post-mortem.",
                "example": "python -m pytest -x --pdb",
                "expected": "Prompt pdb en el fallo.",
                "note": ""
            },
            {
                "command": "ruff check . --fix",
                "level": "advanced",
                "description": "Corrige automáticamente reglas seguras.",
                "example": "ruff check . --fix",
                "expected": "Cantidad de errores corregidos/restantes.",
                "note": ""
            }
        ]
    },
    {
        "id": "network",
        "group": "access-network",
        "title": "Red / Diagnostico",
        "description": "DNS, conectividad, rutas, puertos y diagnostico multiplataforma.",
        "aliases": [
            "network",
            "dns",
            "ping",
            "traceroute",
            "nslookup",
            "dig"
        ],
        "commands": [
            {
                "command": "arp -a",
                "level": "basic",
                "description": "Muestra cache ARP vecina.",
                "example": "arp -a",
                "expected": "Interface / Internet Address / Physical Address / Type.",
                "note": ""
            },
            {
                "command": "dig +short <host>",
                "level": "basic",
                "description": "Devuelve respuesta DNS compacta.",
                "example": "dig +short example.com",
                "expected": "Una o mas IPs/CNAMEs.",
                "note": ""
            },
            {
                "command": "ip addr",
                "level": "basic",
                "description": "Linux: muestra interfaces y direcciones IP.",
                "example": "ip addr",
                "expected": "Interfaces con inet/inet6, state y MAC.",
                "note": ""
            },
            {
                "command": "ip route",
                "level": "basic",
                "description": "Linux: muestra tabla de rutas.",
                "example": "ip route",
                "expected": "default via ... dev ... y rutas locales.",
                "note": ""
            },
            {
                "command": "nslookup <host>",
                "level": "basic",
                "description": "Consulta DNS usando el resolver configurado.",
                "example": "nslookup example.com",
                "expected": "Server/Address y Name/Address del host.",
                "note": ""
            },
            {
                "command": "ping -c 4 <host>",
                "level": "basic",
                "description": "Linux/macOS: envia 4 pings.",
                "example": "ping -c 4 example.com",
                "expected": "4 paquetes y estadisticas.",
                "note": ""
            },
            {
                "command": "ping -n 4 <host>",
                "level": "basic",
                "description": "Windows: envia exactamente 4 pings.",
                "example": "ping -n 4 example.com",
                "expected": "4 replies/timeouts y estadisticas.",
                "note": ""
            },
            {
                "command": "ping <host>",
                "level": "basic",
                "description": "Prueba alcance ICMP y latencia.",
                "example": "ping 8.8.8.8",
                "expected": "Replies con time/TTL o timeout; resumen de perdida.",
                "note": ""
            },
            {
                "command": "Test-NetConnection <host> -Port <port>",
                "level": "basic",
                "description": "PowerShell: prueba un puerto TCP.",
                "example": "Test-NetConnection example.com -Port 443",
                "expected": "TcpTestSucceeded : True/False.",
                "note": ""
            },
            {
                "command": "dig <host>",
                "level": "intermediate",
                "description": "Consulta DNS con detalle en sistemas que tienen dig.",
                "example": "dig example.com",
                "expected": "HEADER, QUESTION, ANSWER, query time, server.",
                "note": ""
            },
            {
                "command": "ipconfig /flushdns",
                "level": "intermediate",
                "description": "Windows: limpia cache DNS local.",
                "example": "ipconfig /flushdns",
                "expected": "Successfully flushed the DNS Resolver Cache.",
                "note": ""
            },
            {
                "command": "nc -vz <host> <port>",
                "level": "intermediate",
                "description": "Netcat: prueba conexion TCP sin enviar datos.",
                "example": "nc -vz localhost 5432",
                "expected": "Connection to localhost 5432 port [tcp/postgresql] succeeded!",
                "note": ""
            },
            {
                "command": "netstat -ano | findstr :<port>",
                "level": "intermediate",
                "description": "Windows: encuentra PID que usa un puerto.",
                "example": "netstat -ano | findstr :4000",
                "expected": "TCP ...:4000 ... LISTENING 1234",
                "note": ""
            },
            {
                "command": "nslookup -type=MX <domain>",
                "level": "intermediate",
                "description": "Consulta registros MX.",
                "example": "nslookup -type=MX example.com",
                "expected": "mail exchanger = ...",
                "note": ""
            },
            {
                "command": "route print",
                "level": "intermediate",
                "description": "Windows: muestra interfaces y tabla de rutas.",
                "example": "route print",
                "expected": "Interface List + IPv4/IPv6 Route Table.",
                "note": ""
            },
            {
                "command": "traceroute <host>",
                "level": "intermediate",
                "description": "Linux/macOS: muestra ruta por hops.",
                "example": "traceroute example.com",
                "expected": "Hops con tiempos o * en timeouts.",
                "note": ""
            },
            {
                "command": "tracert <host>",
                "level": "intermediate",
                "description": "Windows: muestra saltos de red hasta destino.",
                "example": "tracert example.com",
                "expected": "Numero de hop, latencias y router/IP.",
                "note": ""
            },
            {
                "command": "ss -lntp",
                "level": "advanced",
                "description": "Linux: lista sockets TCP escuchando con procesos.",
                "example": "sudo ss -lntp",
                "expected": "State Recv-Q Send-Q Local Address:Port Process.",
                "note": ""
            }
        ]
    },
    {
        "id": "processes",
        "group": "system-tools",
        "title": "Procesos / Puertos",
        "description": "Encontrar procesos por nombre o puerto, detenerlos y revisar recursos.",
        "aliases": [
            "process",
            "pid",
            "port",
            "taskkill",
            "lsof"
        ],
        "commands": [
            {
                "command": "Get-Process <name>",
                "level": "basic",
                "description": "PowerShell: obtiene procesos por nombre.",
                "example": "Get-Process node",
                "expected": "Filas de procesos node.",
                "note": ""
            },
            {
                "command": "ps -ef | grep <name>",
                "level": "basic",
                "description": "Busca procesos por texto en Linux.",
                "example": "ps -ef | grep node",
                "expected": "Lineas de procesos cuyo comando contiene node.",
                "note": ""
            },
            {
                "command": "tasklist | findstr /I <name>",
                "level": "basic",
                "description": "CMD: filtra tasklist por nombre.",
                "example": "tasklist | findstr /I node",
                "expected": "node.exe PID ...",
                "note": ""
            },
            {
                "command": "fuser <port>/tcp",
                "level": "intermediate",
                "description": "Linux: muestra PIDs que usan un puerto TCP.",
                "example": "fuser 3000/tcp",
                "expected": "3000/tcp: 14220",
                "note": ""
            },
            {
                "command": "Get-NetTCPConnection -State Listen",
                "level": "intermediate",
                "description": "PowerShell: lista sockets TCP escuchando.",
                "example": "Get-NetTCPConnection -State Listen",
                "expected": "LocalAddress LocalPort State OwningProcess.",
                "note": ""
            },
            {
                "command": "Get-Process <name> | Stop-Process",
                "level": "intermediate",
                "description": "PowerShell: detiene todos los procesos con ese nombre.",
                "example": "Get-Process node | Stop-Process",
                "expected": "Sin salida normal.",
                "note": ""
            },
            {
                "command": "lsof -i :<port>",
                "level": "intermediate",
                "description": "Linux/macOS: muestra procesos que usan un puerto.",
                "example": "lsof -i :3000",
                "expected": "COMMAND PID USER FD TYPE DEVICE SIZE/OFF NODE NAME.",
                "note": ""
            },
            {
                "command": "pgrep -af <name>",
                "level": "intermediate",
                "description": "Busca PIDs y command line completa.",
                "example": "pgrep -af node",
                "expected": "14220 node server.js",
                "note": ""
            },
            {
                "command": "taskkill /IM <name.exe> /F",
                "level": "intermediate",
                "description": "CMD: fuerza cierre de procesos por imagen.",
                "example": "taskkill /IM node.exe /F",
                "expected": "SUCCESS por cada proceso terminado.",
                "note": ""
            },
            {
                "command": "fuser -k <port>/tcp",
                "level": "advanced",
                "description": "Linux: termina procesos que usan un puerto.",
                "example": "fuser -k 3000/tcp",
                "expected": "3000/tcp: 14220",
                "note": ""
            },
            {
                "command": "pkill -f <pattern>",
                "level": "advanced",
                "description": "Termina procesos cuyo command line coincide.",
                "example": "pkill -f \"node server.js\"",
                "expected": "Sin salida si envia la senal.",
                "note": ""
            },
            {
                "command": "wmic process where processid=<pid> get CommandLine",
                "level": "advanced",
                "description": "En Windows antiguos, muestra command line de un PID si WMIC esta disponible.",
                "example": "wmic process where processid=1234 get CommandLine",
                "expected": "CommandLine\nnode server.js",
                "note": "WMIC esta deprecado en Windows modernos; preferi PowerShell/CIM."
            }
        ]
    },
    {
        "id": "packages",
        "group": "system-tools",
        "title": "Gestores del sistema",
        "description": "Instalar y actualizar herramientas con winget, Chocolatey, apt, dnf y Homebrew.",
        "aliases": [
            "winget",
            "choco",
            "apt",
            "dnf",
            "brew",
            "package manager"
        ],
        "commands": [
            {
                "command": "apt install <package>",
                "level": "basic",
                "description": "Instala paquete Debian/Ubuntu.",
                "example": "sudo apt install nginx",
                "expected": "Plan, descarga e instalación.",
                "note": ""
            },
            {
                "command": "apt list --upgradable",
                "level": "basic",
                "description": "Lista paquetes actualizables.",
                "example": "apt list --upgradable",
                "expected": "Paquete/versiones.",
                "note": ""
            },
            {
                "command": "apt update",
                "level": "basic",
                "description": "Actualiza índices de paquetes Debian/Ubuntu.",
                "example": "sudo apt update",
                "expected": "Repos consultados y packages upgradable.",
                "note": ""
            },
            {
                "command": "brew install <formula>",
                "level": "basic",
                "description": "Instala formula.",
                "example": "brew install jq",
                "expected": "Pouring/linking y resumen.",
                "note": ""
            },
            {
                "command": "brew install <package>",
                "level": "basic",
                "description": "Instala paquete con Homebrew.",
                "example": "brew install node",
                "expected": "Downloading/Pouring ... Summary.",
                "note": ""
            },
            {
                "command": "brew outdated",
                "level": "basic",
                "description": "Lista paquetes desactualizados.",
                "example": "brew outdated",
                "expected": "Nombres.",
                "note": ""
            },
            {
                "command": "brew search <name>",
                "level": "basic",
                "description": "Busca formulae/casks en Homebrew.",
                "example": "brew search node",
                "expected": "Coincidencias de formulae/casks.",
                "note": ""
            },
            {
                "command": "choco install <package> -y",
                "level": "basic",
                "description": "Instala un paquete Chocolatey sin prompt.",
                "example": "choco install git -y",
                "expected": "Download/install y Chocolatey installed ...",
                "note": ""
            },
            {
                "command": "choco search <name>",
                "level": "basic",
                "description": "Busca paquetes Chocolatey.",
                "example": "choco search nodejs",
                "expected": "Paquetes y versiones.",
                "note": ""
            },
            {
                "command": "dnf install <package>",
                "level": "basic",
                "description": "Instala paquete Fedora/RHEL moderno.",
                "example": "sudo dnf install nginx",
                "expected": "Resolución/instalación.",
                "note": ""
            },
            {
                "command": "sudo apt install <package>",
                "level": "basic",
                "description": "Instala paquete en Debian/Ubuntu.",
                "example": "sudo apt install nginx",
                "expected": "Plan de paquetes, confirmacion y configuracion.",
                "note": ""
            },
            {
                "command": "sudo apt update",
                "level": "basic",
                "description": "Actualiza indice de paquetes Debian/Ubuntu.",
                "example": "sudo apt update",
                "expected": "Hit/Get ... Reading package lists... Done.",
                "note": ""
            },
            {
                "command": "sudo dnf install <package>",
                "level": "basic",
                "description": "Instala en Fedora/RHEL modernos.",
                "example": "sudo dnf install git",
                "expected": "Dependencies resolved... Complete!",
                "note": ""
            },
            {
                "command": "winget install --id <id>",
                "level": "basic",
                "description": "Instala paquete por ID.",
                "example": "winget install --id Microsoft.VisualStudioCode",
                "expected": "Progreso y Successfully installed.",
                "note": ""
            },
            {
                "command": "winget install <id>",
                "level": "basic",
                "description": "Instala un paquete por ID.",
                "example": "winget install Microsoft.VisualStudioCode",
                "expected": "Descarga, instalacion y Successfully installed.",
                "note": ""
            },
            {
                "command": "winget list",
                "level": "basic",
                "description": "Lista software detectado.",
                "example": "winget list",
                "expected": "Name/Id/Version/Source.",
                "note": ""
            },
            {
                "command": "winget search <name>",
                "level": "basic",
                "description": "Busca paquetes en Windows Package Manager.",
                "example": "winget search vscode",
                "expected": "Name Id Version Match Source.",
                "note": ""
            },
            {
                "command": "winget upgrade",
                "level": "basic",
                "description": "Lista actualizaciones disponibles.",
                "example": "winget upgrade",
                "expected": "Name Id Version Available Source.",
                "note": ""
            },
            {
                "command": "apt autoremove",
                "level": "intermediate",
                "description": "Elimina dependencias ya no requeridas.",
                "example": "sudo apt autoremove",
                "expected": "Paquetes a eliminar/espacio.",
                "note": ""
            },
            {
                "command": "brew cleanup",
                "level": "intermediate",
                "description": "Elimina versiones antiguas y cache innecesaria.",
                "example": "brew cleanup",
                "expected": "Removing ... y espacio recuperado.",
                "note": ""
            },
            {
                "command": "brew update && brew upgrade",
                "level": "intermediate",
                "description": "Actualiza Homebrew y paquetes instalados.",
                "example": "brew update && brew upgrade",
                "expected": "Updated Homebrew... upgrading packages.",
                "note": ""
            },
            {
                "command": "choco upgrade all -y",
                "level": "intermediate",
                "description": "Actualiza todos los paquetes Chocolatey.",
                "example": "choco upgrade all -y",
                "expected": "Resultado por paquete.",
                "note": ""
            },
            {
                "command": "dnf history",
                "level": "intermediate",
                "description": "Muestra historial transaccional.",
                "example": "dnf history",
                "expected": "ID, command, date, action, altered.",
                "note": ""
            },
            {
                "command": "sudo apt upgrade",
                "level": "intermediate",
                "description": "Actualiza paquetes instalados en Debian/Ubuntu.",
                "example": "sudo apt upgrade",
                "expected": "Lista y progreso de upgrades.",
                "note": ""
            },
            {
                "command": "winget export -o packages.json",
                "level": "intermediate",
                "description": "Exporta lista declarativa de paquetes.",
                "example": "winget export -o packages.json",
                "expected": "Archivo exportado.",
                "note": ""
            },
            {
                "command": "winget upgrade --all",
                "level": "intermediate",
                "description": "Actualiza todos los paquetes compatibles.",
                "example": "winget upgrade --all",
                "expected": "Progreso y resultado por paquete.",
                "note": ""
            },
            {
                "command": "winget import -i packages.json",
                "level": "advanced",
                "description": "Instala paquetes desde export.",
                "example": "winget import -i packages.json",
                "expected": "Progreso/resultado por paquete.",
                "note": ""
            }
        ]
    },
    {
        "id": "go",
        "group": "languages",
        "title": "Go",
        "description": "Toolchain Go: modulos, tests, build y profiling.",
        "aliases": [
            "golang",
            "go mod",
            "go test"
        ],
        "commands": [
            {
                "command": "go build ./...",
                "level": "basic",
                "description": "Compila todos los paquetes.",
                "example": "go build ./...",
                "expected": "Sin salida si exitoso.",
                "note": ""
            },
            {
                "command": "go env",
                "level": "basic",
                "description": "Muestra variables Go.",
                "example": "go env",
                "expected": "GOARCH, GOPATH, GOROOT...",
                "note": ""
            },
            {
                "command": "go list ./...",
                "level": "basic",
                "description": "Lista paquetes.",
                "example": "go list ./...",
                "expected": "Import paths.",
                "note": ""
            },
            {
                "command": "go mod init <module>",
                "level": "basic",
                "description": "Inicializa go.mod.",
                "example": "go mod init example.com/app",
                "expected": "created new go.mod.",
                "note": ""
            },
            {
                "command": "go mod tidy",
                "level": "basic",
                "description": "Sincroniza dependencias.",
                "example": "go mod tidy",
                "expected": "Descargas/cambios si corresponde.",
                "note": ""
            },
            {
                "command": "go test ./...",
                "level": "basic",
                "description": "Ejecuta tests.",
                "example": "go test ./...",
                "expected": "ok/fail por paquete.",
                "note": ""
            },
            {
                "command": "go version",
                "level": "basic",
                "description": "Muestra version y arquitectura.",
                "example": "go version",
                "expected": "go version go1.x.x windows/amd64.",
                "note": ""
            },
            {
                "command": "gofmt -w .",
                "level": "basic",
                "description": "Formatea codigo.",
                "example": "gofmt -w .",
                "expected": "Archivos modificados.",
                "note": ""
            },
            {
                "command": "go test -cover ./...",
                "level": "intermediate",
                "description": "Mide coverage.",
                "example": "go test -cover ./...",
                "expected": "coverage: X%.",
                "note": ""
            },
            {
                "command": "go vet ./...",
                "level": "intermediate",
                "description": "Analisis estatico oficial.",
                "example": "go vet ./...",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "go clean -cache -testcache",
                "level": "advanced",
                "description": "Limpia caches.",
                "example": "go clean -cache -testcache",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "go mod graph",
                "level": "advanced",
                "description": "Muestra grafo de modulos.",
                "example": "go mod graph",
                "expected": "module dependency.",
                "note": ""
            },
            {
                "command": "go test -bench=. ./...",
                "level": "advanced",
                "description": "Ejecuta benchmarks.",
                "example": "go test -bench=. ./...",
                "expected": "Benchmark... ns/op.",
                "note": ""
            },
            {
                "command": "go test -race ./...",
                "level": "advanced",
                "description": "Detecta data races.",
                "example": "go test -race ./...",
                "expected": "ok o WARNING: DATA RACE.",
                "note": ""
            }
        ]
    },
    {
        "id": "rust",
        "group": "languages",
        "title": "Rust / Cargo",
        "description": "Rust y Cargo: crates, tests, lint y docs.",
        "aliases": [
            "rust",
            "cargo",
            "rustup"
        ],
        "commands": [
            {
                "command": "cargo build --release",
                "level": "basic",
                "description": "Compila release.",
                "example": "cargo build --release",
                "expected": "Finished release profile.",
                "note": ""
            },
            {
                "command": "cargo check",
                "level": "basic",
                "description": "Valida sin build final.",
                "example": "cargo check",
                "expected": "Finished dev profile.",
                "note": ""
            },
            {
                "command": "cargo new <name>",
                "level": "basic",
                "description": "Crea proyecto.",
                "example": "cargo new cli-app",
                "expected": "Created package.",
                "note": ""
            },
            {
                "command": "cargo run",
                "level": "basic",
                "description": "Compila y ejecuta.",
                "example": "cargo run",
                "expected": "Running target/...",
                "note": ""
            },
            {
                "command": "cargo test",
                "level": "basic",
                "description": "Ejecuta tests.",
                "example": "cargo test",
                "expected": "test result: ok/FAILED.",
                "note": ""
            },
            {
                "command": "rustc --version",
                "level": "basic",
                "description": "Muestra version Rust.",
                "example": "rustc --version",
                "expected": "rustc 1.x.x.",
                "note": ""
            },
            {
                "command": "rustup show",
                "level": "basic",
                "description": "Muestra toolchains.",
                "example": "rustup show",
                "expected": "Toolchains instalados/activo.",
                "note": ""
            },
            {
                "command": "cargo clippy -- -D warnings",
                "level": "intermediate",
                "description": "Lint estricto.",
                "example": "cargo clippy -- -D warnings",
                "expected": "Diagnosticos o Finished.",
                "note": ""
            },
            {
                "command": "cargo doc --open",
                "level": "intermediate",
                "description": "Genera y abre docs.",
                "example": "cargo doc --open",
                "expected": "Documenting/Open.",
                "note": ""
            },
            {
                "command": "cargo fmt -- --check",
                "level": "intermediate",
                "description": "Comprueba formato.",
                "example": "cargo fmt -- --check",
                "expected": "Sin salida o diff.",
                "note": ""
            },
            {
                "command": "cargo tree",
                "level": "intermediate",
                "description": "Arbol de crates.",
                "example": "cargo tree",
                "expected": "Dependency tree.",
                "note": ""
            },
            {
                "command": "cargo update",
                "level": "intermediate",
                "description": "Actualiza Cargo.lock.",
                "example": "cargo update",
                "expected": "Updating crates...",
                "note": ""
            },
            {
                "command": "cargo metadata --format-version 1",
                "level": "advanced",
                "description": "Metadata workspace JSON.",
                "example": "cargo metadata --format-version 1",
                "expected": "JSON completo.",
                "note": ""
            },
            {
                "command": "cargo tree -d",
                "level": "advanced",
                "description": "Busca versiones duplicadas.",
                "example": "cargo tree -d",
                "expected": "Crates duplicados.",
                "note": ""
            }
        ]
    },
    {
        "id": "dotnet",
        "group": "languages",
        "title": ".NET / dotnet CLI",
        "description": ".NET SDK, solutions, NuGet, tests y publish.",
        "aliases": [
            "dotnet",
            "csharp",
            "nuget"
        ],
        "commands": [
            {
                "command": "dotnet --info",
                "level": "basic",
                "description": "Muestra SDKs/runtimes.",
                "example": "dotnet --info",
                "expected": "SDK, runtime, workloads.",
                "note": ""
            },
            {
                "command": "dotnet add package <package>",
                "level": "basic",
                "description": "Agrega NuGet package.",
                "example": "dotnet add package Serilog",
                "expected": "PackageReference added.",
                "note": ""
            },
            {
                "command": "dotnet build -c Release",
                "level": "basic",
                "description": "Compila Release.",
                "example": "dotnet build -c Release",
                "expected": "Build succeeded/failed.",
                "note": ""
            },
            {
                "command": "dotnet new list",
                "level": "basic",
                "description": "Lista plantillas.",
                "example": "dotnet new list",
                "expected": "Templates.",
                "note": ""
            },
            {
                "command": "dotnet new sln -n App",
                "level": "basic",
                "description": "Crea solution.",
                "example": "dotnet new sln -n App",
                "expected": "Solution created.",
                "note": ""
            },
            {
                "command": "dotnet new webapi -n Api",
                "level": "basic",
                "description": "Crea Web API.",
                "example": "dotnet new webapi -n Api",
                "expected": "Template created successfully.",
                "note": ""
            },
            {
                "command": "dotnet restore",
                "level": "basic",
                "description": "Restaura NuGet.",
                "example": "dotnet restore",
                "expected": "Restored ...",
                "note": ""
            },
            {
                "command": "dotnet sln App.sln add src/Api/Api.csproj",
                "level": "basic",
                "description": "Agrega proyecto a solution.",
                "example": "dotnet sln App.sln add src/Api/Api.csproj",
                "expected": "Project added.",
                "note": ""
            },
            {
                "command": "dotnet test",
                "level": "basic",
                "description": "Ejecuta tests.",
                "example": "dotnet test",
                "expected": "Passed/Failed totals.",
                "note": ""
            },
            {
                "command": "dotnet list package --outdated",
                "level": "intermediate",
                "description": "Lista paquetes desactualizados.",
                "example": "dotnet list package --outdated",
                "expected": "Current/Latest.",
                "note": ""
            },
            {
                "command": "dotnet publish -c Release -o publish",
                "level": "intermediate",
                "description": "Genera artefactos deployables.",
                "example": "dotnet publish -c Release -o publish",
                "expected": "Publish succeeded.",
                "note": ""
            },
            {
                "command": "dotnet watch run",
                "level": "intermediate",
                "description": "Ejecuta con hot reload.",
                "example": "dotnet watch run",
                "expected": "Hot reload enabled.",
                "note": ""
            },
            {
                "command": "dotnet ef database update",
                "level": "advanced",
                "description": "Aplica migraciones EF.",
                "example": "dotnet ef database update",
                "expected": "Applying migration... Done.",
                "note": ""
            },
            {
                "command": "dotnet ef migrations add <name>",
                "level": "advanced",
                "description": "Crea migracion EF Core.",
                "example": "dotnet ef migrations add AddUsers",
                "expected": "Done.",
                "note": ""
            }
        ]
    },
    {
        "id": "java",
        "group": "languages",
        "title": "Java / Maven / Gradle",
        "description": "JDK, Maven y Gradle.",
        "aliases": [
            "java",
            "maven",
            "mvn",
            "gradle"
        ],
        "commands": [
            {
                "command": "./gradlew build",
                "level": "basic",
                "description": "Build completo.",
                "example": "./gradlew build",
                "expected": "BUILD SUCCESSFUL/FAILED.",
                "note": ""
            },
            {
                "command": "./gradlew tasks",
                "level": "basic",
                "description": "Lista tareas Gradle.",
                "example": "./gradlew tasks",
                "expected": "Tasks list.",
                "note": ""
            },
            {
                "command": "./mvnw test",
                "level": "basic",
                "description": "Usa Maven Wrapper.",
                "example": "./mvnw test",
                "expected": "Salida Maven.",
                "note": ""
            },
            {
                "command": "java -version",
                "level": "basic",
                "description": "Muestra Java runtime.",
                "example": "java -version",
                "expected": "openjdk version ...",
                "note": ""
            },
            {
                "command": "javac -version",
                "level": "basic",
                "description": "Muestra compilador.",
                "example": "javac -version",
                "expected": "javac 21.x.",
                "note": ""
            },
            {
                "command": "mvn -version",
                "level": "basic",
                "description": "Muestra Maven/JDK.",
                "example": "mvn -version",
                "expected": "Apache Maven, Java, OS.",
                "note": ""
            },
            {
                "command": "mvn clean",
                "level": "basic",
                "description": "Limpia target.",
                "example": "mvn clean",
                "expected": "BUILD SUCCESS.",
                "note": ""
            },
            {
                "command": "mvn package",
                "level": "basic",
                "description": "Empaqueta JAR/WAR.",
                "example": "mvn package",
                "expected": "target artifact.",
                "note": ""
            },
            {
                "command": "mvn test",
                "level": "basic",
                "description": "Ejecuta tests.",
                "example": "mvn test",
                "expected": "Tests run..., BUILD SUCCESS/FAILURE.",
                "note": ""
            },
            {
                "command": "./gradlew dependencies",
                "level": "intermediate",
                "description": "Arbol de dependencias.",
                "example": "./gradlew dependencies",
                "expected": "Configurations trees.",
                "note": ""
            },
            {
                "command": "mvn dependency:tree",
                "level": "intermediate",
                "description": "Muestra dependencias.",
                "example": "mvn dependency:tree",
                "expected": "Dependency tree.",
                "note": ""
            },
            {
                "command": "./gradlew dependencyInsight --dependency okhttp",
                "level": "advanced",
                "description": "Explica resolucion de dependencia.",
                "example": "./gradlew dependencyInsight --dependency okhttp",
                "expected": "Dependency insight.",
                "note": ""
            }
        ]
    },
    {
        "id": "php",
        "group": "languages",
        "title": "PHP / Composer",
        "description": "PHP CLI y Composer.",
        "aliases": [
            "php",
            "composer"
        ],
        "commands": [
            {
                "command": "composer install",
                "level": "basic",
                "description": "Instala lockfile.",
                "example": "composer install",
                "expected": "Bundle de paquetes instalado.",
                "note": ""
            },
            {
                "command": "composer require <package>",
                "level": "basic",
                "description": "Agrega paquete.",
                "example": "composer require monolog/monolog",
                "expected": "composer.json actualizado.",
                "note": ""
            },
            {
                "command": "php --ini",
                "level": "basic",
                "description": "Muestra php.ini activo.",
                "example": "php --ini",
                "expected": "Loaded Configuration File.",
                "note": ""
            },
            {
                "command": "php -l index.php",
                "level": "basic",
                "description": "Valida sintaxis.",
                "example": "php -l index.php",
                "expected": "No syntax errors detected.",
                "note": ""
            },
            {
                "command": "php -m",
                "level": "basic",
                "description": "Lista extensiones.",
                "example": "php -m",
                "expected": "PHP Modules.",
                "note": ""
            },
            {
                "command": "php -S localhost:8000 -t public",
                "level": "basic",
                "description": "Servidor local PHP.",
                "example": "php -S localhost:8000 -t public",
                "expected": "Development Server started.",
                "note": ""
            },
            {
                "command": "php -v",
                "level": "basic",
                "description": "Muestra version PHP.",
                "example": "php -v",
                "expected": "PHP 8.x.x.",
                "note": ""
            },
            {
                "command": "composer audit",
                "level": "intermediate",
                "description": "Busca advisories.",
                "example": "composer audit",
                "expected": "Vulnerabilidades o none.",
                "note": ""
            },
            {
                "command": "composer diagnose",
                "level": "intermediate",
                "description": "Diagnostica Composer.",
                "example": "composer diagnose",
                "expected": "OK/WARNING/FAIL checks.",
                "note": ""
            },
            {
                "command": "composer dump-autoload -o",
                "level": "intermediate",
                "description": "Optimiza autoload.",
                "example": "composer dump-autoload -o",
                "expected": "Generating optimized autoload files.",
                "note": ""
            },
            {
                "command": "composer outdated",
                "level": "intermediate",
                "description": "Lista desactualizados.",
                "example": "composer outdated",
                "expected": "Current/latest.",
                "note": ""
            },
            {
                "command": "composer update",
                "level": "intermediate",
                "description": "Actualiza dependencias y lock.",
                "example": "composer update",
                "expected": "Lock operations.",
                "note": ""
            }
        ]
    },
    {
        "id": "android",
        "group": "mobile",
        "title": "Android SDK / ADB",
        "description": "ADB, emuladores y diagnostico Android.",
        "aliases": [
            "adb",
            "android",
            "emulator"
        ],
        "commands": [
            {
                "command": "adb devices -l",
                "level": "basic",
                "description": "Lista dispositivos.",
                "example": "adb devices -l",
                "expected": "serial, state, model.",
                "note": ""
            },
            {
                "command": "adb install -r app-debug.apk",
                "level": "basic",
                "description": "Reinstala APK.",
                "example": "adb install -r app-debug.apk",
                "expected": "Success.",
                "note": ""
            },
            {
                "command": "adb logcat",
                "level": "basic",
                "description": "Logs Android en vivo.",
                "example": "adb logcat",
                "expected": "Timestamp/tag/message.",
                "note": ""
            },
            {
                "command": "adb pull /sdcard/log.txt .",
                "level": "basic",
                "description": "Copia del dispositivo al host.",
                "example": "adb pull /sdcard/log.txt .",
                "expected": "1 file pulled.",
                "note": ""
            },
            {
                "command": "adb push config.json /sdcard/",
                "level": "basic",
                "description": "Copia host a dispositivo.",
                "example": "adb push config.json /sdcard/",
                "expected": "1 file pushed.",
                "note": ""
            },
            {
                "command": "adb shell",
                "level": "basic",
                "description": "Abre shell del dispositivo.",
                "example": "adb shell",
                "expected": "device:/ $.",
                "note": ""
            },
            {
                "command": "adb start-server",
                "level": "basic",
                "description": "Inicia daemon ADB.",
                "example": "adb start-server",
                "expected": "daemon started si aplica.",
                "note": ""
            },
            {
                "command": "adb uninstall <package>",
                "level": "basic",
                "description": "Desinstala app.",
                "example": "adb uninstall com.example.app",
                "expected": "Success.",
                "note": ""
            },
            {
                "command": "emulator -avd Pixel_7_API_35",
                "level": "basic",
                "description": "Inicia AVD.",
                "example": "emulator -avd Pixel_7_API_35",
                "expected": "Emulador iniciado.",
                "note": ""
            },
            {
                "command": "emulator -list-avds",
                "level": "basic",
                "description": "Lista emuladores.",
                "example": "emulator -list-avds",
                "expected": "Nombres AVD.",
                "note": ""
            },
            {
                "command": "adb kill-server",
                "level": "intermediate",
                "description": "Detiene daemon ADB.",
                "example": "adb kill-server",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "adb logcat *:E",
                "level": "intermediate",
                "description": "Filtra errores.",
                "example": "adb logcat *:E",
                "expected": "Errores de logcat.",
                "note": ""
            },
            {
                "command": "adb reverse tcp:8081 tcp:8081",
                "level": "intermediate",
                "description": "Expone host 8081 al dispositivo.",
                "example": "adb reverse tcp:8081 tcp:8081",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "adb bugreport bugreport.zip",
                "level": "advanced",
                "description": "Genera reporte completo.",
                "example": "adb bugreport bugreport.zip",
                "expected": "Bug report copied.",
                "note": ""
            }
        ]
    },
    {
        "id": "nginx",
        "group": "web-servers",
        "title": "Nginx",
        "description": "Validacion, recarga y logs.",
        "aliases": [
            "nginx",
            "reverse proxy"
        ],
        "commands": [
            {
                "command": "nginx -v",
                "level": "basic",
                "description": "Muestra version.",
                "example": "nginx -v",
                "expected": "nginx version...",
                "note": ""
            },
            {
                "command": "sudo nginx -s reload",
                "level": "basic",
                "description": "Recarga config.",
                "example": "sudo nginx -s reload",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "sudo nginx -t",
                "level": "basic",
                "description": "Valida configuracion.",
                "example": "sudo nginx -t",
                "expected": "syntax is ok/test is successful.",
                "note": ""
            },
            {
                "command": "sudo systemctl reload nginx",
                "level": "basic",
                "description": "Reload via systemd.",
                "example": "sudo systemctl reload nginx",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "systemctl status nginx",
                "level": "basic",
                "description": "Estado del servicio.",
                "example": "systemctl status nginx",
                "expected": "Active/PID/logs.",
                "note": ""
            },
            {
                "command": "tail -f /var/log/nginx/access.log",
                "level": "basic",
                "description": "Sigue accesos.",
                "example": "tail -f /var/log/nginx/access.log",
                "expected": "Requests en vivo.",
                "note": ""
            },
            {
                "command": "tail -f /var/log/nginx/error.log",
                "level": "basic",
                "description": "Sigue errores.",
                "example": "tail -f /var/log/nginx/error.log",
                "expected": "Warnings/errors.",
                "note": ""
            },
            {
                "command": "nginx -V",
                "level": "intermediate",
                "description": "Muestra build y modulos.",
                "example": "nginx -V",
                "expected": "configure arguments.",
                "note": ""
            },
            {
                "command": "sudo nginx -T",
                "level": "intermediate",
                "description": "Vuelca config completa.",
                "example": "sudo nginx -T",
                "expected": "Config expandida.",
                "note": ""
            }
        ]
    },
    {
        "id": "openssl",
        "group": "web-servers",
        "title": "OpenSSL / TLS",
        "description": "Certificados, claves y diagnostico TLS.",
        "aliases": [
            "openssl",
            "tls",
            "ssl"
        ],
        "commands": [
            {
                "command": "openssl dgst -sha256 app.zip",
                "level": "basic",
                "description": "SHA256 de archivo.",
                "example": "openssl dgst -sha256 app.zip",
                "expected": "SHA2-256(...)= hash.",
                "note": ""
            },
            {
                "command": "openssl rand -hex 32",
                "level": "basic",
                "description": "Genera 32 bytes aleatorios en hex.",
                "example": "openssl rand -hex 32",
                "expected": "64 caracteres hex.",
                "note": ""
            },
            {
                "command": "openssl version -a",
                "level": "basic",
                "description": "Muestra version/build.",
                "example": "openssl version -a",
                "expected": "Version y OPENSSLDIR.",
                "note": ""
            },
            {
                "command": "openssl x509 -in server.crt -noout -dates",
                "level": "basic",
                "description": "Muestra validez.",
                "example": "openssl x509 -in server.crt -noout -dates",
                "expected": "notBefore/notAfter.",
                "note": ""
            },
            {
                "command": "openssl x509 -in server.crt -text -noout",
                "level": "basic",
                "description": "Inspecciona certificado.",
                "example": "openssl x509 -in server.crt -text -noout",
                "expected": "Subject, Issuer, Validity, Extensions.",
                "note": ""
            },
            {
                "command": "openssl req -new -key server.key -out server.csr",
                "level": "intermediate",
                "description": "Genera CSR.",
                "example": "openssl req -new -key server.key -out server.csr",
                "expected": "Prompts + CSR.",
                "note": ""
            },
            {
                "command": "openssl verify -CAfile ca.pem server.crt",
                "level": "intermediate",
                "description": "Verifica contra CA.",
                "example": "openssl verify -CAfile ca.pem server.crt",
                "expected": "server.crt: OK o error.",
                "note": ""
            },
            {
                "command": "openssl genpkey -algorithm RSA -out server.key -pkeyopt rsa_keygen_bits:4096",
                "level": "advanced",
                "description": "Genera clave RSA 4096.",
                "example": "openssl genpkey -algorithm RSA -out server.key -pkeyopt rsa_keygen_bits:4096",
                "expected": "Archivo key.",
                "note": "Proteger clave privada."
            },
            {
                "command": "openssl s_client -connect example.com:443 -servername example.com -showcerts",
                "level": "advanced",
                "description": "Inspecciona handshake y cadena TLS.",
                "example": "openssl s_client -connect example.com:443 -servername example.com -showcerts",
                "expected": "Cadena, protocolo, cipher, verify code.",
                "note": ""
            }
        ]
    },
    {
        "id": "jq",
        "group": "cli-utils",
        "title": "jq",
        "description": "Procesamiento JSON desde terminal.",
        "aliases": [
            "jq",
            "json cli"
        ],
        "commands": [
            {
                "command": "jq \".[]\" items.json",
                "level": "basic",
                "description": "Itera elementos.",
                "example": "jq \".[]\" items.json",
                "expected": "Cada elemento.",
                "note": ""
            },
            {
                "command": "jq \"keys\" package.json",
                "level": "basic",
                "description": "Lista claves.",
                "example": "jq \"keys\" package.json",
                "expected": "Array de keys.",
                "note": ""
            },
            {
                "command": "jq -r \".name\" package.json",
                "level": "basic",
                "description": "Extrae string sin comillas.",
                "example": "jq -r \".name\" package.json",
                "expected": "Valor de name.",
                "note": ""
            },
            {
                "command": "jq . data.json",
                "level": "basic",
                "description": "Formatea/valida JSON.",
                "example": "jq . data.json",
                "expected": "JSON formateado.",
                "note": ""
            },
            {
                "command": "jq \".[] | select(.active == true)\" users.json",
                "level": "intermediate",
                "description": "Filtra objetos.",
                "example": "jq \".[] | select(.active == true)\" users.json",
                "expected": "Objetos activos.",
                "note": ""
            },
            {
                "command": "jq \"map({id,name})\" users.json",
                "level": "intermediate",
                "description": "Transforma array.",
                "example": "jq \"map({id,name})\" users.json",
                "expected": "Array reducido.",
                "note": ""
            },
            {
                "command": "jq \"sort_by(.createdAt)\" items.json",
                "level": "intermediate",
                "description": "Ordena array.",
                "example": "jq \"sort_by(.createdAt)\" items.json",
                "expected": "Array ordenado.",
                "note": ""
            },
            {
                "command": "jq \"unique_by(.email)\" users.json",
                "level": "intermediate",
                "description": "Deduplica por clave.",
                "example": "jq \"unique_by(.email)\" users.json",
                "expected": "Array sin duplicados.",
                "note": ""
            },
            {
                "command": "jq -s \".\" events.jsonl",
                "level": "intermediate",
                "description": "Convierte JSONL a array.",
                "example": "jq -s \".\" events.jsonl",
                "expected": "Array de documentos.",
                "note": ""
            }
        ]
    },
    {
        "id": "text-utils",
        "group": "cli-utils",
        "title": "grep / sed / awk",
        "description": "Busqueda y transformacion de texto.",
        "aliases": [
            "grep",
            "sed",
            "awk",
            "xargs"
        ],
        "commands": [
            {
                "command": "grep -n \"ERROR\" app.log",
                "level": "basic",
                "description": "Busca texto con numero de linea.",
                "example": "grep -n \"ERROR\" app.log",
                "expected": "linea:contenido.",
                "note": ""
            },
            {
                "command": "sed -n \"1,20p\" app.log",
                "level": "basic",
                "description": "Muestra lineas 1-20.",
                "example": "sed -n \"1,20p\" app.log",
                "expected": "Primeras 20 lineas.",
                "note": ""
            },
            {
                "command": "grep -C 3 \"Exception\" app.log",
                "level": "intermediate",
                "description": "Muestra contexto.",
                "example": "grep -C 3 \"Exception\" app.log",
                "expected": "Bloques alrededor del match.",
                "note": ""
            },
            {
                "command": "grep -RIn --exclude-dir=node_modules \"TODO\" .",
                "level": "intermediate",
                "description": "Busca recursivamente excluyendo node_modules.",
                "example": "grep -RIn --exclude-dir=node_modules \"TODO\" .",
                "expected": "ruta:linea:contenido.",
                "note": ""
            },
            {
                "command": "sort values.txt | uniq -c | sort -nr",
                "level": "intermediate",
                "description": "Cuenta valores por frecuencia.",
                "example": "sort values.txt | uniq -c | sort -nr",
                "expected": "conteo valor.",
                "note": ""
            },
            {
                "command": "xargs -P 8 -I{} curl -s -o /dev/null {}",
                "level": "advanced",
                "description": "Procesa entradas en paralelo.",
                "example": "cat urls.txt | xargs -P 8 -I{} curl -s -o /dev/null {}",
                "expected": "Jobs paralelos.",
                "note": ""
            }
        ]
    },
    {
        "id": "helm",
        "group": "cloud",
        "title": "Helm",
        "description": "Gestión de charts y releases Kubernetes.",
        "aliases": [
            "helm",
            "kubernetes charts",
            "charts"
        ],
        "commands": [
            {
                "command": "helm install <release> <chart> -f values.yaml",
                "level": "basic",
                "description": "Instala una release.",
                "example": "helm install db bitnami/postgresql -f values.yaml",
                "expected": "NAME, LAST DEPLOYED, NAMESPACE, STATUS, REVISION, NOTES.",
                "note": ""
            },
            {
                "command": "helm lint <chart>",
                "level": "basic",
                "description": "Valida estructura/templates del chart.",
                "example": "helm lint ./chart",
                "expected": "Lint summary/error.",
                "note": ""
            },
            {
                "command": "helm list -A",
                "level": "basic",
                "description": "Lista releases en todos los namespaces.",
                "example": "helm list -A",
                "expected": "NAME, NAMESPACE, REVISION, STATUS, CHART.",
                "note": ""
            },
            {
                "command": "helm repo add <name> <url>",
                "level": "basic",
                "description": "Agrega repositorio de charts.",
                "example": "helm repo add bitnami https://charts.bitnami.com/bitnami",
                "expected": "\"bitnami\" has been added.",
                "note": ""
            },
            {
                "command": "helm repo update",
                "level": "basic",
                "description": "Actualiza índices de repositorios.",
                "example": "helm repo update",
                "expected": "Successfully got an update...",
                "note": ""
            },
            {
                "command": "helm search repo <term>",
                "level": "basic",
                "description": "Busca charts.",
                "example": "helm search repo postgres",
                "expected": "NAME, CHART VERSION, APP VERSION, DESCRIPTION.",
                "note": ""
            },
            {
                "command": "helm status <release>",
                "level": "basic",
                "description": "Muestra estado de release.",
                "example": "helm status api",
                "expected": "Status, resources/notes.",
                "note": ""
            },
            {
                "command": "helm version",
                "level": "basic",
                "description": "Muestra versión Helm.",
                "example": "helm version",
                "expected": "Version/build info.",
                "note": ""
            },
            {
                "command": "helm get values <release> -a",
                "level": "intermediate",
                "description": "Obtiene values efectivos.",
                "example": "helm get values api -a",
                "expected": "YAML.",
                "note": ""
            },
            {
                "command": "helm history <release>",
                "level": "intermediate",
                "description": "Lista revisiones.",
                "example": "helm history api",
                "expected": "REVISION, UPDATED, STATUS, CHART, DESCRIPTION.",
                "note": ""
            },
            {
                "command": "helm show values <chart>",
                "level": "intermediate",
                "description": "Muestra values por defecto.",
                "example": "helm show values bitnami/postgresql",
                "expected": "YAML completo.",
                "note": ""
            },
            {
                "command": "helm template <release> <chart> -f values.yaml",
                "level": "intermediate",
                "description": "Renderiza manifests localmente sin instalar.",
                "example": "helm template api ./chart -f values.yaml",
                "expected": "YAML Kubernetes.",
                "note": ""
            },
            {
                "command": "helm upgrade --install <release> <chart> -f values.yaml",
                "level": "intermediate",
                "description": "Crea o actualiza idempotentemente.",
                "example": "helm upgrade --install api ./chart -f values-prod.yaml",
                "expected": "Release upgraded/installed.",
                "note": ""
            },
            {
                "command": "helm get manifest <release>",
                "level": "advanced",
                "description": "Obtiene manifiestos renderizados de release.",
                "example": "helm get manifest api",
                "expected": "YAML desplegado.",
                "note": ""
            },
            {
                "command": "helm rollback <release> <revision>",
                "level": "advanced",
                "description": "Revierte a revisión anterior.",
                "example": "helm rollback api 3",
                "expected": "Rollback was a success.",
                "note": ""
            },
            {
                "command": "helm uninstall <release>",
                "level": "advanced",
                "description": "Desinstala release.",
                "example": "helm uninstall api",
                "expected": "release \"api\" uninstalled.",
                "note": "Elimina recursos gestionados por la release."
            }
        ]
    },
    {
        "id": "ansible",
        "group": "cloud",
        "title": "Ansible",
        "description": "Inventario, ad-hoc, playbooks y diagnóstico.",
        "aliases": [
            "ansible",
            "playbook",
            "automation"
        ],
        "commands": [
            {
                "command": "ansible --version",
                "level": "basic",
                "description": "Muestra versión/configuración Ansible.",
                "example": "ansible --version",
                "expected": "Version, config file, module paths, Python.",
                "note": ""
            },
            {
                "command": "ansible all -i inventory.ini -a \"uname -a\"",
                "level": "basic",
                "description": "Ejecuta comando ad-hoc.",
                "example": "ansible web -i inventory.ini -a \"uptime\"",
                "expected": "CHANGED/SUCCESS + stdout.",
                "note": ""
            },
            {
                "command": "ansible all -i inventory.ini -m ping",
                "level": "basic",
                "description": "Prueba conectividad y Python remoto.",
                "example": "ansible all -i inventory.ini -m ping",
                "expected": "SUCCESS => pong o UNREACHABLE.",
                "note": ""
            },
            {
                "command": "ansible-doc <module>",
                "level": "basic",
                "description": "Muestra documentación de módulo.",
                "example": "ansible-doc ansible.builtin.copy",
                "expected": "Opciones, ejemplos, return values.",
                "note": ""
            },
            {
                "command": "ansible-inventory -i inventory.ini --list",
                "level": "basic",
                "description": "Renderiza inventario completo.",
                "example": "ansible-inventory -i inventory.ini --list",
                "expected": "JSON de hosts/groups/vars.",
                "note": ""
            },
            {
                "command": "ansible-playbook -i inventory.ini site.yml",
                "level": "basic",
                "description": "Ejecuta playbook.",
                "example": "ansible-playbook -i inventory.ini site.yml",
                "expected": "PLAY/TASK/RECAP.",
                "note": ""
            },
            {
                "command": "ansible-vault create secrets.yml",
                "level": "basic",
                "description": "Crea archivo cifrado Vault.",
                "example": "ansible-vault create secrets.yml",
                "expected": "Editor y archivo cifrado.",
                "note": ""
            },
            {
                "command": "ansible-vault edit secrets.yml",
                "level": "basic",
                "description": "Edita archivo cifrado.",
                "example": "ansible-vault edit secrets.yml",
                "expected": "Solicita contraseña y abre editor.",
                "note": ""
            },
            {
                "command": "ansible-galaxy collection install <collection>",
                "level": "intermediate",
                "description": "Instala collection.",
                "example": "ansible-galaxy collection install community.general",
                "expected": "Collection installed successfully.",
                "note": ""
            },
            {
                "command": "ansible-galaxy collection list",
                "level": "intermediate",
                "description": "Lista collections instaladas.",
                "example": "ansible-galaxy collection list",
                "expected": "Collection, version.",
                "note": ""
            },
            {
                "command": "ansible-playbook -i inventory.ini site.yml --check",
                "level": "intermediate",
                "description": "Simula cambios cuando módulos soportan check mode.",
                "example": "ansible-playbook -i inventory.ini site.yml --check",
                "expected": "Predicción de changed/ok.",
                "note": ""
            },
            {
                "command": "ansible-playbook -i inventory.ini site.yml --diff",
                "level": "intermediate",
                "description": "Muestra diffs de archivos/templates.",
                "example": "ansible-playbook -i inventory.ini site.yml --diff",
                "expected": "before/after en tareas compatibles.",
                "note": ""
            },
            {
                "command": "ansible-playbook -i inventory.ini site.yml --limit <host>",
                "level": "intermediate",
                "description": "Limita ejecución a hosts/grupo.",
                "example": "ansible-playbook -i inventory.ini site.yml --limit web-01",
                "expected": "Solo targets limitados.",
                "note": ""
            },
            {
                "command": "ansible-playbook site.yml --tags <tag>",
                "level": "intermediate",
                "description": "Ejecuta tareas etiquetadas.",
                "example": "ansible-playbook site.yml --tags deploy",
                "expected": "Solo tasks con tag.",
                "note": ""
            },
            {
                "command": "ansible-vault encrypt <file>",
                "level": "intermediate",
                "description": "Cifra archivo existente.",
                "example": "ansible-vault encrypt group_vars/prod.yml",
                "expected": "Encryption successful.",
                "note": ""
            },
            {
                "command": "ansible-playbook site.yml --start-at-task \"<task>\"",
                "level": "advanced",
                "description": "Retoma desde una tarea concreta.",
                "example": "ansible-playbook site.yml --start-at-task \"Deploy app\"",
                "expected": "Ejecución desde esa tarea.",
                "note": ""
            }
        ]
    },
    {
        "id": "make",
        "group": "cli-utils",
        "title": "Make / build automation",
        "description": "Targets, variables y diagnóstico de Makefiles.",
        "aliases": [
            "make",
            "makefile",
            "build"
        ],
        "commands": [
            {
                "command": "make",
                "level": "basic",
                "description": "Ejecuta target por defecto.",
                "example": "make",
                "expected": "Comandos del target o nothing to be done.",
                "note": ""
            },
            {
                "command": "make -C <dir> <target>",
                "level": "basic",
                "description": "Ejecuta Makefile de otro directorio.",
                "example": "make -C backend test",
                "expected": "Salida del target en backend.",
                "note": ""
            },
            {
                "command": "make <target>",
                "level": "basic",
                "description": "Ejecuta target específico.",
                "example": "make build",
                "expected": "Salida de recetas.",
                "note": ""
            },
            {
                "command": "make -B <target>",
                "level": "intermediate",
                "description": "Fuerza rebuild ignorando timestamps.",
                "example": "make -B build",
                "expected": "Reejecuta recetas.",
                "note": ""
            },
            {
                "command": "make -j4 <target>",
                "level": "intermediate",
                "description": "Ejecuta recetas en paralelo.",
                "example": "make -j4 build",
                "expected": "Salida intercalada de jobs.",
                "note": ""
            },
            {
                "command": "make -n <target>",
                "level": "intermediate",
                "description": "Simula mostrando comandos sin ejecutarlos.",
                "example": "make -n deploy",
                "expected": "Comandos que ejecutaría.",
                "note": ""
            },
            {
                "command": "make VAR=value <target>",
                "level": "intermediate",
                "description": "Sobrescribe variable desde CLI.",
                "example": "make ENV=production build",
                "expected": "Target usando ENV=production.",
                "note": ""
            },
            {
                "command": "make -pRrq : 2>/dev/null",
                "level": "advanced",
                "description": "Imprime base interna/targets para inspección.",
                "example": "make -pRrq : 2>/dev/null",
                "expected": "Reglas/variables; útil para tooling.",
                "note": ""
            }
        ]
    },
    {
        "id": "azure-cli",
        "group": "cloud",
        "title": "Azure CLI",
        "description": "Suscripciones, recursos, App Service, Container Apps y diagnóstico.",
        "aliases": [
            "azure",
            "az",
            "azure cli"
        ],
        "commands": [
            {
                "command": "az account list -o table",
                "level": "basic",
                "description": "Lista suscripciones.",
                "example": "az account list -o table",
                "expected": "Tabla Name/CloudName/SubscriptionId/State/IsDefault.",
                "note": ""
            },
            {
                "command": "az account set --subscription <id-or-name>",
                "level": "basic",
                "description": "Cambia suscripción activa.",
                "example": "az account set --subscription Development",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "az account show",
                "level": "basic",
                "description": "Muestra suscripción activa.",
                "example": "az account show",
                "expected": "JSON con id, name, tenantId, user.",
                "note": ""
            },
            {
                "command": "az group list -o table",
                "level": "basic",
                "description": "Lista resource groups.",
                "example": "az group list -o table",
                "expected": "Name, Location, Status.",
                "note": ""
            },
            {
                "command": "az login",
                "level": "basic",
                "description": "Inicia sesión interactiva.",
                "example": "az login",
                "expected": "Navegador/device auth y lista de subscriptions.",
                "note": ""
            },
            {
                "command": "az version",
                "level": "basic",
                "description": "Muestra Azure CLI y extensiones.",
                "example": "az version",
                "expected": "JSON con versiones.",
                "note": ""
            },
            {
                "command": "az acr login --name <registry>",
                "level": "intermediate",
                "description": "Autentica Docker en Azure Container Registry.",
                "example": "az acr login --name notebookregistry",
                "expected": "Login Succeeded.",
                "note": ""
            },
            {
                "command": "az containerapp list -o table",
                "level": "intermediate",
                "description": "Lista Container Apps.",
                "example": "az containerapp list -o table",
                "expected": "Name, resource group, URL, provisioning state.",
                "note": ""
            },
            {
                "command": "az containerapp logs show -g <group> -n <app> --follow",
                "level": "intermediate",
                "description": "Sigue logs de Container App.",
                "example": "az containerapp logs show -g notebook -n api --follow",
                "expected": "Logs en vivo.",
                "note": ""
            },
            {
                "command": "az keyvault secret list --vault-name <vault> -o table",
                "level": "intermediate",
                "description": "Lista metadata de secretos sin valores.",
                "example": "az keyvault secret list --vault-name notebook-vault -o table",
                "expected": "Name, Enabled, Updated.",
                "note": ""
            },
            {
                "command": "az resource list -g <group> -o table",
                "level": "intermediate",
                "description": "Lista recursos de un resource group.",
                "example": "az resource list -g notebook-dev -o table",
                "expected": "Name, resource group, location, type.",
                "note": ""
            },
            {
                "command": "az webapp list -o table",
                "level": "intermediate",
                "description": "Lista App Services.",
                "example": "az webapp list -o table",
                "expected": "Name, ResourceGroup, State, URL.",
                "note": ""
            },
            {
                "command": "az webapp log tail -g <group> -n <app>",
                "level": "intermediate",
                "description": "Sigue logs de App Service.",
                "example": "az webapp log tail -g notebook -n notebook-api",
                "expected": "Logs en vivo.",
                "note": ""
            },
            {
                "command": "az keyvault secret show --vault-name <vault> --name <secret>",
                "level": "advanced",
                "description": "Lee un secreto autorizado.",
                "example": "az keyvault secret show --vault-name notebook-vault --name DbPassword",
                "expected": "JSON con value y metadata.",
                "note": "Evitar imprimir secretos en terminal compartida."
            },
            {
                "command": "az monitor activity-log list --max-events 20 -o table",
                "level": "advanced",
                "description": "Muestra actividad reciente de la suscripción.",
                "example": "az monitor activity-log list --max-events 20 -o table",
                "expected": "Eventos recientes y estado.",
                "note": ""
            }
        ]
    },
    {
        "id": "gcloud",
        "group": "cloud",
        "title": "Google Cloud CLI",
        "description": "Proyectos, identidad, Cloud Run, GKE, Storage y logs.",
        "aliases": [
            "gcloud",
            "google cloud",
            "gcp"
        ],
        "commands": [
            {
                "command": "gcloud auth list",
                "level": "basic",
                "description": "Lista cuentas y la activa.",
                "example": "gcloud auth list",
                "expected": "Credentialed Accounts.",
                "note": ""
            },
            {
                "command": "gcloud auth login",
                "level": "basic",
                "description": "Inicia sesión de usuario.",
                "example": "gcloud auth login",
                "expected": "Navegador y cuenta autenticada.",
                "note": ""
            },
            {
                "command": "gcloud config list",
                "level": "basic",
                "description": "Muestra configuración activa.",
                "example": "gcloud config list",
                "expected": "Project, account, region/zone si están definidos.",
                "note": ""
            },
            {
                "command": "gcloud config set project <project-id>",
                "level": "basic",
                "description": "Selecciona proyecto.",
                "example": "gcloud config set project notebook-dev",
                "expected": "Updated property [core/project].",
                "note": ""
            },
            {
                "command": "gcloud projects list",
                "level": "basic",
                "description": "Lista proyectos visibles.",
                "example": "gcloud projects list",
                "expected": "PROJECT_ID, NAME, PROJECT_NUMBER.",
                "note": ""
            },
            {
                "command": "gcloud storage cp <file> gs://<bucket>/<key>",
                "level": "basic",
                "description": "Sube archivo a Cloud Storage.",
                "example": "gcloud storage cp build.zip gs://notebook-releases/app.zip",
                "expected": "Copying... completed.",
                "note": ""
            },
            {
                "command": "gcloud storage ls",
                "level": "basic",
                "description": "Lista buckets con CLI moderno.",
                "example": "gcloud storage ls",
                "expected": "gs://bucket/...",
                "note": ""
            },
            {
                "command": "gcloud version",
                "level": "basic",
                "description": "Muestra versión Google Cloud CLI.",
                "example": "gcloud version",
                "expected": "Versiones de componentes.",
                "note": ""
            },
            {
                "command": "gcloud container clusters get-credentials <cluster> --region <region>",
                "level": "intermediate",
                "description": "Actualiza kubeconfig para GKE.",
                "example": "gcloud container clusters get-credentials prod --region us-central1",
                "expected": "kubeconfig entry generated.",
                "note": ""
            },
            {
                "command": "gcloud container clusters list",
                "level": "intermediate",
                "description": "Lista clusters GKE.",
                "example": "gcloud container clusters list",
                "expected": "NAME, LOCATION, MASTER_VERSION, STATUS.",
                "note": ""
            },
            {
                "command": "gcloud run deploy <service> --source . --region <region>",
                "level": "intermediate",
                "description": "Build y deploy desde código fuente a Cloud Run.",
                "example": "gcloud run deploy api --source . --region us-central1",
                "expected": "Build/deploy progress y Service URL.",
                "note": ""
            },
            {
                "command": "gcloud run services list",
                "level": "intermediate",
                "description": "Lista servicios Cloud Run.",
                "example": "gcloud run services list",
                "expected": "SERVICE, REGION, URL, LAST DEPLOYED BY/AT.",
                "note": ""
            },
            {
                "command": "gcloud run services logs read <service> --limit=100",
                "level": "intermediate",
                "description": "Lee logs recientes Cloud Run.",
                "example": "gcloud run services logs read api --limit=100",
                "expected": "Entradas de log.",
                "note": ""
            },
            {
                "command": "gcloud logging read <filter> --limit=20 --format=json",
                "level": "advanced",
                "description": "Consulta Cloud Logging con filtro.",
                "example": "gcloud logging read 'severity>=ERROR' --limit=20 --format=json",
                "expected": "Array JSON de entradas.",
                "note": ""
            },
            {
                "command": "gcloud secrets versions access latest --secret=<name>",
                "level": "advanced",
                "description": "Lee versión de un Secret Manager.",
                "example": "gcloud secrets versions access latest --secret=db-password",
                "expected": "Valor del secreto.",
                "note": "No ejecutar donde stdout quede persistido sin protección."
            }
        ]
    },
    {
        "id": "systemd",
        "group": "observability",
        "title": "systemd / journalctl",
        "description": "Servicios Linux, logs, boot y diagnóstico operacional.",
        "aliases": [
            "systemctl",
            "journalctl",
            "service linux"
        ],
        "commands": [
            {
                "command": "journalctl -u <service> -f",
                "level": "basic",
                "description": "Sigue logs en vivo.",
                "example": "journalctl -u notebook-api -f",
                "expected": "Stream de logs.",
                "note": ""
            },
            {
                "command": "journalctl -u <service> -n 100 --no-pager",
                "level": "basic",
                "description": "Muestra últimas 100 líneas del servicio.",
                "example": "journalctl -u notebook-api -n 100 --no-pager",
                "expected": "Logs recientes.",
                "note": ""
            },
            {
                "command": "sudo systemctl disable <service>",
                "level": "basic",
                "description": "Deshabilita autostart.",
                "example": "sudo systemctl disable notebook-api",
                "expected": "Removed symlink ...",
                "note": ""
            },
            {
                "command": "sudo systemctl enable <service>",
                "level": "basic",
                "description": "Habilita inicio automático al boot.",
                "example": "sudo systemctl enable notebook-api",
                "expected": "Created symlink ...",
                "note": ""
            },
            {
                "command": "sudo systemctl restart <service>",
                "level": "basic",
                "description": "Reinicia servicio.",
                "example": "sudo systemctl restart notebook-api",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "sudo systemctl start <service>",
                "level": "basic",
                "description": "Inicia servicio.",
                "example": "sudo systemctl start nginx",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "sudo systemctl stop <service>",
                "level": "basic",
                "description": "Detiene servicio.",
                "example": "sudo systemctl stop nginx",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "systemctl is-active <service>",
                "level": "basic",
                "description": "Devuelve estado activo para scripting.",
                "example": "systemctl is-active nginx",
                "expected": "active/inactive/failed.",
                "note": ""
            },
            {
                "command": "systemctl is-enabled <service>",
                "level": "basic",
                "description": "Comprueba autostart.",
                "example": "systemctl is-enabled nginx",
                "expected": "enabled/disabled/static/masked.",
                "note": ""
            },
            {
                "command": "systemctl status <service>",
                "level": "basic",
                "description": "Muestra estado y logs recientes de un servicio.",
                "example": "systemctl status nginx",
                "expected": "Loaded, Active, PID y últimas líneas.",
                "note": ""
            },
            {
                "command": "journalctl -p err -b",
                "level": "intermediate",
                "description": "Muestra errores del boot actual.",
                "example": "journalctl -p err -b",
                "expected": "Errores con timestamp/unit.",
                "note": ""
            },
            {
                "command": "journalctl -u <service> --since \"1 hour ago\"",
                "level": "intermediate",
                "description": "Filtra logs por tiempo.",
                "example": "journalctl -u notebook-api --since \"1 hour ago\"",
                "expected": "Entradas del período.",
                "note": ""
            },
            {
                "command": "sudo systemctl daemon-reload",
                "level": "intermediate",
                "description": "Recarga archivos de units tras modificarlos.",
                "example": "sudo systemctl daemon-reload",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "sudo systemctl reload <service>",
                "level": "intermediate",
                "description": "Recarga configuración sin restart cuando el servicio lo soporta.",
                "example": "sudo systemctl reload nginx",
                "expected": "Sin salida si correcto.",
                "note": ""
            },
            {
                "command": "systemctl list-timers --all",
                "level": "intermediate",
                "description": "Lista timers systemd.",
                "example": "systemctl list-timers --all",
                "expected": "NEXT, LEFT, LAST, PASSED, UNIT, ACTIVATES.",
                "note": ""
            },
            {
                "command": "systemctl list-units --type=service --state=running",
                "level": "intermediate",
                "description": "Lista servicios activos.",
                "example": "systemctl list-units --type=service --state=running",
                "expected": "UNIT, LOAD, ACTIVE, SUB, DESCRIPTION.",
                "note": ""
            },
            {
                "command": "systemd-analyze blame",
                "level": "advanced",
                "description": "Ordena units por tiempo de arranque.",
                "example": "systemd-analyze blame",
                "expected": "Duración + unit.",
                "note": ""
            },
            {
                "command": "systemd-analyze critical-chain",
                "level": "advanced",
                "description": "Muestra cadena crítica del boot.",
                "example": "systemd-analyze critical-chain",
                "expected": "Árbol temporal de dependencias.",
                "note": ""
            }
        ]
    }
];

const mergeCommands = (baseCommands = [], extraCommands = []) => {
    const byCommand = new Map();
    [...baseCommands, ...extraCommands].forEach((item) => {
        const key = String(item?.command || "").trim();
        if (!key) return;
        if (!byCommand.has(key)) byCommand.set(key, item);
        else byCommand.set(key, { ...byCommand.get(key), ...item });
    });
    return [...byCommand.values()];
};

export const COMMAND_CATEGORIES = [
    ...BASE_COMMAND_CATEGORIES.map((category) => ({
        ...category,
        commands: mergeCommands(category.commands, COMMAND_CATEGORY_EXPANSIONS[category.id] || []),
    })),
    ...EXTRA_COMMAND_CATEGORIES.map((category) => ({
        ...category,
        commands: mergeCommands([], category.commands),
    })),
];

export const COMMAND_TOTALS = COMMAND_CATEGORIES.reduce((totals, category) => {
    category.commands.forEach((item) => {
        totals.total += 1;
        if (item.level === "basic") totals.basic += 1;
        if (item.level === "intermediate") totals.intermediate += 1;
        if (item.level === "advanced") totals.advanced += 1;
    });
    return totals;
}, { total: 0, basic: 0, intermediate: 0, advanced: 0 });
